import { Group, route, group } from '@amazeelabs/react-framework-bridge';
import loadable from '@loadable/component';
import clsx from 'clsx';
import React, { useContext, useEffect, useRef, useState, Fragment } from 'react';
import { useIntl } from '@amazeelabs/react-framework-bridge/react-intl';
import { isElement } from 'hast-util-is-element';
import { visit } from 'unist-util-visit';
import { selectAll } from 'hast-util-select';
import { Disclosure, Transition, Popover, Dialog, Tab, Listbox, Combobox } from '@headlessui/react';
import { MinusIcon, PlusIcon, ChevronUpIcon, XIcon, SearchIcon, ArrowNarrowUpIcon, ArrowLeftIcon, ArrowRightIcon, MenuAlt1Icon, GlobeAltIcon, InformationCircleIcon, DownloadIcon, ChevronDownIcon, CheckIcon, CalendarIcon, HomeIcon, ChevronLeftIcon as ChevronLeftIcon$1, ChevronRightIcon as ChevronRightIcon$1 } from '@heroicons/react/outline';
import { motion, useScroll, useTransform, easeOut, useInView, useMotionValue, animate, AnimatePresence } from 'framer-motion';
import { useFormikContext, useField, Field } from '@amazeelabs/react-framework-bridge/formik';
import create, { useStore } from 'zustand';
import { ChevronDoubleLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleRightIcon, HomeIcon as HomeIcon$1, PlusSmIcon } from '@heroicons/react/solid';
import { Player } from '@lottiefiles/react-lottie-player';
import { buildHtml } from '@amazeelabs/react-framework-bridge/storybook';
import BodyClassName from 'react-body-classname';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import { HeightTransition } from '@amazeelabs/molecules';
import ReactTooltip from 'react-tooltip';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { lowerCase, debounce, kebabCase } from 'lodash';
import { SilverbackIframe } from '@amazeelabs/silverback-iframe';
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDebouncedCallback } from 'use-debounce';
import useMeasure from 'react-use-measure';
import 'swiper/css';
import '@amazeelabs/react-framework-bridge/gatsby';

function Content(props) {
  return /*#__PURE__*/React.createElement("div", null, props.body);
}
function PageContainer({
  children,
  extraSpacing = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page', {
      'mb-7 mt-10 md:mt-12 lg:mb-9': extraSpacing
    })
  }, children);
}
function ContentContainer({
  extraSpacing = false,
  children
}) {
  return /*#__PURE__*/React.createElement(PageContainer, {
    extraSpacing: extraSpacing
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, children));
}
function TextContainer({
  children
}) {
  return /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, children));
}
function HeadingContainer({
  children
}) {
  return /*#__PURE__*/React.createElement(ContentContainer, {
    extraSpacing: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, children));
}
function StoryHeadingContainer({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "prose sm:prose-lg md:prose-xl lg:mb-5"
  }, children);
}

function Head(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.contents, props.children);
}

const ThemeContext = /*#__PURE__*/React.createContext({
  currentTheme: 'caritas'
});
function ThemeProvider({
  theme,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: `theme-${theme}`
  }, /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      currentTheme: theme
    }
  }, children));
}
function useTheme(input) {
  return input[useContext(ThemeContext).currentTheme];
}
function useActiveTheme() {
  return useContext(ThemeContext).currentTheme;
}

function Page(props) {
  const intl = useIntl();
  const showPrefooter = useTheme({
    caritas: true,
    caritascare: false,
    bergeinsatz: true,
    youngcaritas: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.seo, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full flex-col"
  }, /*#__PURE__*/React.createElement("a", {
    tabIndex: 1,
    href: "#main-content",
    className: 'skip-link'
  }, intl.formatMessage({
    id: "ZKtRoA",
    defaultMessage: [{
      "type": 0,
      "value": "Skip to content"
    }]
  })), props.header, /*#__PURE__*/React.createElement("main", {
    id: "main-content",
    className: "flex-1"
  }, props.children), /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("h2", {
    className: 'sr-only'
  }, intl.formatMessage({
    id: "Vge+RX",
    defaultMessage: [{
      "type": 0,
      "value": "Footer"
    }]
  })), showPrefooter && props.preFooter, props.footer)));
}

function Blockquote({
  className,
  Image,
  blockquote,
  name,
  jobPosition,
  imageOnRight = false,
  backgroundIsActive = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page', {
      'bg-blue-100 lg:bg-transparent': backgroundIsActive
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content my-10', {
      'lg:bg-blue-100': backgroundIsActive
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-text flex flex-col gap-3 lg:items-center lg:gap-8', {
      'lg:flex-row-reverse': imageOnRight,
      'lg:flex-row': !imageOnRight
    })
  }, Image ? /*#__PURE__*/React.createElement("figure", {
    className: clsx('flex-none lg:pt-2')
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'inline-block h-52 w-52 rounded-full'
  })) : null, /*#__PURE__*/React.createElement("blockquote", {
    className: 'pl-0 text-3xl font-light leading-snug tracking-[-0.25px] text-blue-500 lg:text-4xl lg:leading-normal lg:tracking-[-0.35px]'
  }, blockquote, name ? /*#__PURE__*/React.createElement("cite", {
    className: 'mt-5 block text-sm font-bold uppercase not-italic text-black'
  }, name, jobPosition ? /*#__PURE__*/React.createElement("span", {
    className: 'ml-3 border-l pl-3 font-light leading-none'
  }, jobPosition) : null) : null))));
}

function wrap(Wrapper, Component) {
  return function Wrapped(props) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Component, props));
  };
}
function ImageCopyrightPrefix() {
  // eslint-disable-next-line react/jsx-no-literals
  return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA9\xA0");
}

/**
 * Formats a date (no time).
 *
 * The input date should have the format Y-m-d.
 * The output date will have the format: d.m.Y
 *
 * For now, the output format is not customisable, nor language aware, but this
 * can be extended if needed.
 */
function formatDate(date) {
  const dateParts = date.split('-');
  // In case we received a wrong format, then just return the date as it is.
  if (dateParts.length !== 3) {
    return date;
  }
  return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
}
function linkArrow() {
  return `list-none before:content-[''] before:block relative before:absolute before:top-[3px] lg:before:top-1 before:-left-7 before:w-4 before:h-4 before:bg-[url('/chevron-red.svg')] before:bg-center before:bg-cover after:absolute after:-left-[30px] after:top-2.5 lg:after:top-[11px] after:content-[''] after:block after:h-[0.1rem] after:w-3 after:bg-red-500 after:rounded-xl after:block`;
}

const bullet = `list-none before:content-[''] before:w-2.5 before:h-2.5 before:rounded-tl before:block before:bg-blue-500 relative before:absolute before:top-1.5 lg:before:top-2 before:-left-7`;
const listBullet = () => tree => {
  selectAll('ul > li > div', tree).forEach(node => {
    if (node.children.length === 1 && isElement(node.children[0], 'a')) {
      node.children = [{
        type: 'element',
        tagName: 'span',
        properties: {
          class: linkArrow()
        },
        children: []
      }, ...node.children];
    } else {
      node.children = [{
        type: 'element',
        tagName: 'span',
        properties: {
          class: bullet
        },
        children: []
      }, ...node.children];
    }
  });
};

const arrow = "list-none before:content-[''] before:block relative left-0 before:absolute before:top-[3px] lg:before:top-1 before:-left-7 before:w-4 before:h-4 before:bg-[url('/chevron-red.svg')] before:bg-center before:bg-cover after:absolute after:-left-[30px] after:top-2.5 lg:after:top-[11px] after:content-[''] after:block after:h-[0.1rem] after:w-3 after:bg-red-500 after:rounded-xl after:block";
const linkParagraphsToCallToActions = () => tree => {
  visit(tree, 'element', node => {
    if (isElement(node, 'p')) {
      if (node.children.length === 1 && isElement(node.children[0], 'a')) {
        node.children[0].properties = {
          className: 'text-red-500 hover:text-red-600 font-light no-underline transition duration-300 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)] focus inline-block'
        };
        node.properties = {
          className: 'mb-3.5 last:mb-0 text-lg pr-8 xl:text-xl block pl-8'
        };
        node.children.unshift({
          type: 'element',
          tagName: 'span',
          children: [],
          properties: {
            className: arrow
          }
        });
      } else {
        node.properties = {
          className: 'mb-3.5 last:mb-0 block text-lg md:text-xl xl:text-2.5xl md:leading-relaxed xl:leading-normal mb-6 md:mb-7 lg:mb-8 xl:mb-9'
        };
      }
    }
  });
};
function CBoxFormattedText({
  Content
}) {
  return /*#__PURE__*/React.createElement(Content, {
    plugins: [linkParagraphsToCallToActions, listBullet],
    classNames: {
      a: 'group text-red-500 hover:text-red-600 no-underline transition duration-300 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)] focus',
      ul: 'pl-6 md:pl-7 mb-5 md:mb-7 lg:mb-8 last:mb-0',
      ol: 'list-decimal pl-5 xl:pl-7 mb-5 md:mb-7 lg:mb-8 last:mb-0',
      li: 'relative text-lg md:text-xl xl:text-2.5xl md:leading-relaxed xl:leading-normal mb-2 last:mb-0'
    }
  });
}

const headingClasses$1 = {
  h2: 'leading-tight lg:leading-tight text-3xl lg:text-4xl tracking-[-0.01em]',
  h3: 'leading-snug lg:leading-tight text-2xl lg:text-3xl tracking-[-0.01em]',
  h4: 'leading-normal lg:leading-snug text-xl lg:text-2xl',
  h5: 'leading-normal lg:leading-snug text-lg'
};
function Heading({
  Heading
}) {
  return /*#__PURE__*/React.createElement(Heading, {
    classNames: {
      'h2:has(strong)': clsx('font-light', headingClasses$1.h2),
      'h2:not(:has(strong))': clsx('font-bold', headingClasses$1.h2),
      'h3:has(strong)': clsx('font-light', headingClasses$1.h3),
      'h3:not(:has(strong))': clsx('font-bold', headingClasses$1.h3),
      'h4:has(strong)': clsx('font-light', headingClasses$1.h4),
      'h4:not(:has(strong))': clsx('font-bold', headingClasses$1.h4),
      'h5:has(strong)': clsx('font-light', headingClasses$1.h5),
      'h5:not(:has(strong))': clsx('font-bold', headingClasses$1.h5),
      strong: 'block font-bold'
    }
  });
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function SocialMenuAlt({
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-wrap gap-4 pb-14 md:pb-24'
  }, items?.map((item, index) => /*#__PURE__*/React.createElement(SocialMenuAltItem, _extends({
    key: index
  }, item))));
}
function SocialMenuAltItem({
  Link,
  type
}) {
  return /*#__PURE__*/React.createElement(Link, {
    "aria-label": type,
    className: 'focus relative top-0 transition-all ease-linear hover:top-1 hover:opacity-80'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, type !== 'twitter' ? type : 'Twitter / X'), type == 'facebook' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-10 w-10',
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    version: "1.1",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE_copy_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M19.488,15.999h-2.239v8.124h-3.357V16h-1.677    v-2.8h1.677v-1.681c0-2.284,0.947-3.642,3.637-3.642h2.24v2.8h-1.4c-1.047,0-1.117,0.392-1.117,1.121L17.249,13.2h2.536    L19.488,15.999z"
  })))) : null, type == 'twitter' ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "256",
    height: "256",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    className: 'h-10 w-10'
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01 ",
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))) : null, type == 'mail' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-10 w-10',
    xmlns: "http://www.w3.org/2000/svg",
    height: "72",
    viewBox: "0 0 72 72",
    width: "72"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,72 L36,72 C55.882251,72 72,55.882251 72,36 L72,36 C72,16.117749 55.882251,-3.65231026e-15 36,0 L36,0 C16.117749,3.65231026e-15 -2.4348735e-15,16.117749 0,36 L0,36 C2.4348735e-15,55.882251 16.117749,72 36,72 Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,26.1623226 L18,46.5476129 C18,47.6566452 18.8117419,48.5554839 19.9300645,48.5554839 L51.7447742,48.5554839 C52.8619355,48.5554839 53.6748387,47.6461935 53.6748387,46.5476129 L53.6748387,26.1623226 C53.6748387,24.9452903 52.947871,24 51.7447742,24 L19.9300645,24 C18.6805161,24 18,24.9685161 18,26.1623226 M20.9334194,27.9379355 C20.9334194,27.4467097 21.2307097,27.1656774 21.7056774,27.1656774 C21.9994839,27.1656774 33.560129,34.4910968 34.2603871,34.9207742 L36.0696774,36.0460645 C36.6433548,35.6616774 37.2193548,35.3330323 37.8139355,34.9347097 C39.0274839,34.1589677 49.8251613,27.1656774 50.1224516,27.1656774 C50.5985806,27.1656774 50.8947097,27.4467097 50.8947097,27.9379355 C50.8947097,28.4581935 49.8925161,28.9749677 49.239871,29.3732903 C45.1393548,31.8723871 41.04,34.5967742 36.980129,37.1887742 C36.7432258,37.3490323 36.2845161,37.6916129 35.9407742,37.6393548 C35.5575484,37.580129 23.7936774,30.0224516 21.6534194,28.7636129 C21.3317419,28.5743226 20.9334194,28.4012903 20.9334194,27.9379355",
    fill: "#FFF"
  }))) : null, type == 'link' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-10 w-10',
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10L500,10L500,10z M435.3,743.6c-49.3,49.3-129.6,49.3-179,0c-49.3-49.3-49.3-129.6,0-178.9l126.8-126.8c49.3-49.3,129.6-49.3,179,0c1.3,1.3,2.6,2.7,3.9,4.1c0.7,0.6,1.5,1.3,2.2,2c2,2,3.6,4.2,5,6.5c0.2,0.2,0.3,0.4,0.5,0.6c0,0-0.1,0.1-0.1,0.1c6.1,11.5,4.3,26-5.4,35.6c-9.7,9.7-24.4,11.5-35.9,5.2c-0.8,0.8-8.7-7.1-13-11.3l0,0c-25.8-25.8-67.3-26-93.1-0.2l-127,127c-25.8,25.8-25.8,67.5,0,93.3l0,0c25.8,25.8,67.5,25.8,93.3,0l76.4-76.4c26.5,13,57.7,13.4,84.5,1.1L435.3,743.6L435.3,743.6L435.3,743.6z M743.6,435.3L616.9,562.1c-49.3,49.3-129.6,49.3-179,0c-1.3-1.3-2.6-2.7-3.9-4.1c-0.7-0.6-1.5-1.3-2.1-2c-2-2-3.6-4.2-5-6.5c-0.2-0.2-0.3-0.4-0.5-0.6c0,0,0.1-0.1,0.1-0.1c-6.1-11.5-4.3-26,5.4-35.6c9.7-9.7,24.4-11.4,35.9-5.2c0.8-0.8,8.7,7.1,13,11.3l0,0c25.8,25.8,67.3,26,93.1,0.2l127-127c25.8-25.8,25.8-67.5,0-93.3l0,0c-25.8-25.8-67.5-25.8-93.3,0L531,375.6c-26.4-12.9-57.7-13.4-84.5-1.1l118.1-118.1c49.3-49.3,129.6-49.3,179,0C793,305.7,793,386,743.6,435.3L743.6,435.3L743.6,435.3z"
  }))) : null, type == 'linkedin' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-10 w-10',
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 32 32",
    version: "1.1",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE_copy_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.164,0,0,7.163,0,16c0,8.836,7.164,16,16,16s16-7.164,16-16C32,7.163,24.836,0,16,0z M11.844,22.277H8.58v-9.82    h3.264V22.277z M10.212,11.116h-0.021c-1.096,0-1.804-0.755-1.804-1.697c0-0.963,0.73-1.696,1.846-1.696    c1.116,0,1.804,0.733,1.825,1.696C12.058,10.362,11.349,11.116,10.212,11.116z M23.613,22.277L23.613,22.277l-3.264,0v-5.254    c0-1.32-0.472-2.22-1.654-2.22c-0.901,0-1.438,0.607-1.674,1.194c-0.086,0.21-0.108,0.503-0.108,0.796v5.484H13.65    c0,0,0.043-8.898,0-9.82h3.264v1.391c0.433-0.669,1.209-1.622,2.942-1.622c2.147,0,3.757,1.404,3.757,4.42V22.277z"
  })))) : null);
}

function Accordion({
  faqs
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 md:mb-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, faqs.map(({
    title,
    content,
    itemPointerUpHandler,
    defaultOpen
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'border-t-2 border-grey-100 last:border-b-2'
  }, /*#__PURE__*/React.createElement(Disclosure, {
    defaultOpen: defaultOpen,
    key: `${index}-${defaultOpen}`
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: 'focus group flex w-full items-center justify-between py-5 text-left transition-all hover:text-red-500 sm:px-5',
    onPointerUp: () => {
      itemPointerUpHandler(title, !open);
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'pr-8 text-lg font-bold tracking-wide'
  }, title), open ? /*#__PURE__*/React.createElement("div", {
    className: 'flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-red-500 text-red-500 transition group-hover:bg-red-500 group-hover:text-white'
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    className: 'h-4 w-4'
  })) : /*#__PURE__*/React.createElement("div", {
    className: 'flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-red-500 text-red-500 transition group-hover:bg-red-500 group-hover:text-white'
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    className: 'h-4 w-4'
  }))), /*#__PURE__*/React.createElement(Transition, {
    enter: "transition ease duration-500 transform",
    enterFrom: "opacity-0 -translate-y-12",
    enterTo: "opacity-100 translate-y-0",
    leave: "transition ease duration-300 transform",
    leaveFrom: "opacity-100 translate-y-0",
    leaveTo: "opacity-0 -translate-y-12"
  }, /*#__PURE__*/React.createElement(Disclosure.Panel, {
    className: "accordion-inner prose max-w-none pt-3 pb-6 sm:px-5"
  }, /*#__PURE__*/React.createElement(Group, {
    definition: AccordionContentGroup,
    input: content
  }))))))))));
}

/* eslint-disable react/jsx-no-literals */
function MissionSummary({
  items
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-6 max-w-sm md:mb-5 lg:mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose mb-3 !max-w-full lg:prose-xl"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'font-bold'
  }, intl.formatMessage({
    id: "TCTq9t",
    defaultMessage: [{
      "type": 0,
      "value": "Your periods"
    }]
  }))), /*#__PURE__*/React.createElement("ul", {
    className: 'md:!max-w-sm'
  }, items.map(({
    weekNumber,
    endDate,
    startDate
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: 'prose border-b-2 border-grey-100 py-3 first:border-t-2 lg:prose-xl'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, intl.formatMessage({
    id: "F0QgKi",
    defaultMessage: [{
      "type": 0,
      "value": "Calendar week "
    }, {
      "type": 1,
      "value": "number"
    }]
  }, {
    number: weekNumber
  })), /*#__PURE__*/React.createElement("div", {
    className: 'font-bold'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'after:content-["-"]'
  }, formatDate(startDate), " "), /*#__PURE__*/React.createElement("span", null, " ", formatDate(endDate)))))));
}

/* eslint-disable react/jsx-no-literals */
function BookingMissionSummary({
  items,
  showMissionClick,
  newMissionClick
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement(MissionSummary, {
    items: items
  }), /*#__PURE__*/React.createElement("div", {
    className: 'sm:flex'
  }, /*#__PURE__*/React.createElement("button", {
    className: "focus mt-4 w-full cursor-pointer select-none items-center justify-center whitespace-normal border-2 border-red-500 bg-white px-6 py-3 font-condensed text-sm uppercase tracking-wide text-red-500 transition duration-300 hover:bg-red-500 hover:text-white sm:mr-4 md:mt-6 md:w-auto md:min-w-[240px] md:py-2 md:px-12",
    onClick: showMissionClick
  }, intl.formatMessage({
    id: "jBmccO",
    defaultMessage: [{
      "type": 0,
      "value": "Show mission"
    }]
  })), /*#__PURE__*/React.createElement("button", {
    className: "focus mt-4 w-full cursor-pointer select-none items-center justify-center whitespace-normal bg-red-500 px-6 py-3 font-condensed text-sm uppercase tracking-wide text-white transition duration-300 hover:bg-red-600 md:mt-6 md:w-auto md:min-w-[240px] md:py-2 md:px-12",
    onClick: newMissionClick
  }, intl.formatMessage({
    id: "AzNH4T",
    defaultMessage: [{
      "type": 0,
      "value": "New mission"
    }]
  }))))));
}

function CBox({
  heading,
  Subheading,
  content
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10 lg:my-14 lg:max-w-full lg:px-9'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative rounded-tl-xl bg-red-500 md:block'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative w-full overflow-hidden pt-16 md:h-full lg:py-16 xl:pt-28 xl:pb-24'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2461.419",
    height: "2484.792",
    viewBox: "0 0 2461.419 2484.792",
    className: 'absolute hidden lg:top-[-800px] lg:left-[62%] lg:block lg:translate-x-64 lg:scale-[1.4] xl:-top-72 xl:left-2/3 xl:translate-x-0 2xl:left-[64%]'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2503.419,172.739C2485.374-401.7,1882.651-729,1326.847-729,547.277-729,42-177.937,42,513.4s505.277,1242.4,1284.847,1242.4c653.251,0,1140.482-360.7,1176.573-975.214h-671.3c-25.264,273.861-205.72,440.85-519.713,440.85C879.316,1221.427,713.3,867.412,713.3,513.4S879.316-194.636,1312.41-194.636c281.511,0,483.622,126.911,519.713,367.375Z",
    transform: "translate(-42 729)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'lg:px-20 1.5xl:px-28'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'relative text-black lg:flex'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'px-5 md:mb-0 md:px-16 lg:w-1/2 lg:px-0'
  }, /*#__PURE__*/React.createElement("h2", {
    className: 'block pb-8 text-3xl font-bold text-white md:mt-6 lg:max-w-[17rem] xl:max-w-xs xl:text-4.5xl 1.5xl:max-w-sm 3xl:max-w-md'
  }, heading), /*#__PURE__*/React.createElement("div", {
    className: 'text-3xl font-light text-white lg:mb-0 lg:max-w-[17rem] lg:pb-32 xl:max-w-xs xl:text-4.5xl 1.5xl:max-w-sm 3xl:max-w-md'
  }, Subheading && /*#__PURE__*/React.createElement(Subheading, null))), content && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'c-box relative overflow-hidden bg-grey-50 px-5 pt-32 pb-16 font-light leading-normal sm:pt-40 md:px-16 md:pr-40 lg:w-1/2 lg:overflow-visible lg:bg-transparent lg:p-0'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 79",
    className: 'absolute -top-8 left-0 h-36 w-[640px] sm:-top-16 sm:h-56 sm:w-[1024px] lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2957,3870h0v-79h375v23.66c-33.042.157-66.208,1.328-98.578,3.48-32.033,2.13-64.142,5.279-95.436,9.359-30.981,4.039-61.994,9.1-92.178,15.042-29.9,5.886-59.777,12.792-88.806,20.528V3870Z",
    transform: "translate(-2957 -3791)",
    fill: "#db001b"
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 164.999",
    className: 'absolute top-0 left-0 hidden w-full lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3280,3956h0V3806.474c-33.026-1.919-66.388-2.893-99.16-2.893-30.749,0-61.68.735-91.935,2.184-30.01,1.437-60.182,3.617-89.677,6.479-29.26,2.839-58.651,6.428-87.357,10.666-28.485,4.205-57.075,9.165-84.978,14.742-27.693,5.535-55.462,11.83-82.536,18.708-26.881,6.83-53.809,14.422-80.035,22.565-26.05,8.089-52.115,16.942-77.472,26.313-25.2,9.312-50.379,19.388-74.848,29.95V3791h768Z",
    transform: "translate(-2512.002 -3791)",
    fill: "#db001b"
  })), /*#__PURE__*/React.createElement(Group, {
    definition: CBoxContentGroup,
    input: content
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "375",
    height: "56.001",
    viewBox: "0 0 375 56.001",
    className: 'absolute bottom-0 right-0 sm:hidden '
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3332,4371.341H3081.1a541.975,541.975,0,0,1,54.4-19.62,588.338,588.338,0,0,1,58.79-14.429c20.433-3.926,41.72-6.921,63.272-8.9,21.949-2.019,44.775-3.043,67.844-3.043,2.246,0,4.464.008,6.592.024v45.972Zm-256.538,0H2957v0h118.461Z",
    transform: "translate(-2957 -4315.339)",
    fill: "#db001b"
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "404.548",
    height: "62.001",
    viewBox: "0 0 404.548 62.001",
    className: 'absolute bottom-0 right-0 hidden sm:block lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3280,4479.419H2875.454a645.072,645.072,0,0,1,64.251-22.971,699.344,699.344,0,0,1,69.378-16.885c24.1-4.592,49.208-8.1,74.625-10.414,25.876-2.36,52.788-3.557,79.989-3.557,19.995,0,39.926.548,59.24,1.63,19.291,1.08,38.489,2.721,57.062,4.877v-14.682l0,62Z",
    transform: "translate(-2875.454 -4417.418)",
    fill: "#db001b"
  })))))))));
}

function CBoxDonation({
  Subheading,
  content
}) {
  if (!content.items.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10 lg:my-14 lg:max-w-full lg:px-9'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative rounded-tl-xl bg-blue-600 md:block'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative w-full overflow-hidden pt-16 md:h-full lg:py-16 xl:pt-28 xl:pb-24'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2461.419",
    height: "2484.792",
    viewBox: "0 0 2461.419 2484.792",
    className: 'absolute hidden lg:top-[-800px] lg:left-[62%] lg:block lg:translate-x-64 lg:scale-[1.4] xl:-top-72 xl:left-2/3 xl:translate-x-0 2xl:left-[64%]'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2503.419,172.739C2485.374-401.7,1882.651-729,1326.847-729,547.277-729,42-177.937,42,513.4s505.277,1242.4,1284.847,1242.4c653.251,0,1140.482-360.7,1176.573-975.214h-671.3c-25.264,273.861-205.72,440.85-519.713,440.85C879.316,1221.427,713.3,867.412,713.3,513.4S879.316-194.636,1312.41-194.636c281.511,0,483.622,126.911,519.713,367.375Z",
    transform: "translate(-42 729)",
    fill: "#EFF4F6"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'lg:px-20 1.5xl:px-28'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'relative text-black lg:flex lg:items-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'px-5 md:mb-0 md:px-16 lg:w-1/2 lg:px-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'text-3xl font-light text-white lg:mb-0 lg:max-w-[275px] xl:max-w-xs xl:text-4.5xl 1.5xl:max-w-[23rem] 3xl:max-w-[30rem]'
  }, Subheading && /*#__PURE__*/React.createElement(Subheading, null))), content && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'c-box relative overflow-hidden bg-blue-100 px-5 pt-32 pb-16 font-light leading-normal sm:pt-40 md:px-16 lg:w-1/2 lg:overflow-visible lg:bg-transparent lg:p-0'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 79",
    className: 'absolute -top-8 left-0 h-36 w-[640px] sm:-top-16 sm:h-56 sm:w-[1024px] lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2957,3870h0v-79h375v23.66c-33.042.157-66.208,1.328-98.578,3.48-32.033,2.13-64.142,5.279-95.436,9.359-30.981,4.039-61.994,9.1-92.178,15.042-29.9,5.886-59.777,12.792-88.806,20.528V3870Z",
    transform: "translate(-2957 -3791)",
    fill: "#547c8f"
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 164.999",
    className: 'absolute top-0 left-0 hidden w-full lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3280,3956h0V3806.474c-33.026-1.919-66.388-2.893-99.16-2.893-30.749,0-61.68.735-91.935,2.184-30.01,1.437-60.182,3.617-89.677,6.479-29.26,2.839-58.651,6.428-87.357,10.666-28.485,4.205-57.075,9.165-84.978,14.742-27.693,5.535-55.462,11.83-82.536,18.708-26.881,6.83-53.809,14.422-80.035,22.565-26.05,8.089-52.115,16.942-77.472,26.313-25.2,9.312-50.379,19.388-74.848,29.95V3791h768Z",
    transform: "translate(-2512.002 -3791)",
    fill: "#547c8f"
  })), /*#__PURE__*/React.createElement(Group, {
    definition: CBoxContentGroup,
    input: content
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "375",
    height: "56.001",
    viewBox: "0 0 375 56.001",
    className: 'absolute bottom-0 right-0 sm:hidden '
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3332,4371.341H3081.1a541.975,541.975,0,0,1,54.4-19.62,588.338,588.338,0,0,1,58.79-14.429c20.433-3.926,41.72-6.921,63.272-8.9,21.949-2.019,44.775-3.043,67.844-3.043,2.246,0,4.464.008,6.592.024v45.972Zm-256.538,0H2957v0h118.461Z",
    transform: "translate(-2957 -4315.339)",
    fill: "#547c8f"
  })), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "404.548",
    height: "62.001",
    viewBox: "0 0 404.548 62.001",
    className: 'absolute bottom-0 right-0 hidden sm:block lg:hidden'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3280,4479.419H2875.454a645.072,645.072,0,0,1,64.251-22.971,699.344,699.344,0,0,1,69.378-16.885c24.1-4.592,49.208-8.1,74.625-10.414,25.876-2.36,52.788-3.557,79.989-3.557,19.995,0,39.926.548,59.24,1.63,19.291,1.08,38.489,2.721,57.062,4.877v-14.682l0,62Z",
    transform: "translate(-2875.454 -4417.418)",
    fill: "#547c8f"
  })))))))));
}

function CollageStoryBlock({
  SmallImage,
  BigImage,
  content,
  textPosition
}) {
  const fadeInVariants = {
    initial: {
      opacity: 0,
      y: 125
    },
    animate: {
      opacity: 1,
      y: 0
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative my-16 lg:my-20"
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: "flex flex-col md:flex-row",
    whileInView: "animate",
    viewport: {
      once: true,
      margin: '-150px 0px'
    },
    initial: "initial"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('order-last md:w-5/12', {
      'md:order-first md:pr-8': textPosition === 'top_left',
      'md:pl-8': textPosition === 'top_right',
      'md:mt-[30%] md:pl-8': textPosition === 'bottom_left',
      'md:order-first md:mt-[30%] md:pr-8': textPosition === 'bottom_right'
    })
  }, textPosition?.includes('top') ? /*#__PURE__*/React.createElement(motion.div, {
    className: 'bg-[rgba(255,255,255,0.75)] pb-4 md:max-w-lg md:pb-4 lg:max-w-2xl lg:pr-6 lg:pt-0 lg:pl-0 xl:pb-14',
    transition: {
      duration: 1,
      ease: 'easeOut',
      delay: 0.3
    },
    variants: fadeInVariants
  }, /*#__PURE__*/React.createElement("div", {
    className: "box-prose prose mt-5 text-lg font-light sm:mt-10 lg:text-xl lg:leading-[1.8]"
  }, /*#__PURE__*/React.createElement(Group, {
    definition: CollageStoryContentGroup,
    input: content
  }))) : null, /*#__PURE__*/React.createElement(motion.div, {
    transition: {
      duration: 1,
      ease: 'easeOut',
      delay: textPosition?.includes('top') ? 0.6 : 0.3
    },
    variants: fadeInVariants
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-4 aspect-h-3 relative block overflow-hidden'
  }, /*#__PURE__*/React.createElement(SmallImage.Image, {
    className: '!absolute !block w-full max-w-full rounded-tl-lg object-cover'
  })), SmallImage.source && /*#__PURE__*/React.createElement("p", {
    className: 'mt-1 text-sm font-light lg:text-base'
  }, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), SmallImage.source))), /*#__PURE__*/React.createElement("div", {
    className: 'mb-4 sm:mb-0 md:w-7/12'
  }, /*#__PURE__*/React.createElement(motion.div, {
    transition: {
      duration: 1,
      ease: 'easeOut'
    },
    variants: fadeInVariants
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('aspect-w-4 aspect-h-3 relative block overflow-hidden xl:mt-0', {
      'md:mt-[20%]': textPosition?.includes('top')
    })
  }, /*#__PURE__*/React.createElement(BigImage.Image, {
    className: '!absolute !block w-full max-w-full rounded-tl-lg object-cover'
  })), BigImage.source && /*#__PURE__*/React.createElement("p", {
    className: 'mt-1 text-sm font-light lg:text-base'
  }, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), BigImage.source)), textPosition?.includes('bottom') ? /*#__PURE__*/React.createElement("div", {
    className: clsx('flex', {
      'xl:justify-end': textPosition === 'bottom_left'
    })
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: 'bg-[rgba(255,255,255,0.75)] pt-8 md:max-w-lg md:pt-12 lg:max-w-2xl lg:pb-12 lg:pr-6 lg:pt-16 lg:pl-0 xl:pt-20',
    transition: {
      duration: 1,
      ease: 'easeOut',
      delay: 0.6
    },
    variants: fadeInVariants
  }, /*#__PURE__*/React.createElement("div", {
    className: "box-prose prose text-lg font-light lg:text-xl lg:leading-[1.8]"
  }, /*#__PURE__*/React.createElement(Group, {
    definition: CollageStoryContentGroup,
    input: content
  })))) : null)));
}

function ConfirmedWeekList({
  title,
  periods
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose mb-3 !max-w-full lg:prose-xl'
  }, /*#__PURE__*/React.createElement("h3", null, intl.formatMessage({
    id: "k7wvmw",
    defaultMessage: [{
      "type": 0,
      "value": "Your booking in "
    }, {
      "type": 1,
      "value": "name"
    }]
  }, {
    name: title
  }))), /*#__PURE__*/React.createElement(MissionSummary, {
    items: periods
  }))));
}

function ContactBox({
  contacts
}) {
  return /*#__PURE__*/React.createElement("div", null, contacts.map((contact, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'my-10 flex flex-col gap-1 rounded-tl-xl bg-green-100 p-5 lg:flex-row lg:gap-10 lg:p-10'
  }, /*#__PURE__*/React.createElement("div", null, contact.Image ? /*#__PURE__*/React.createElement(contact.Image, {
    className: 'mb-9 block h-36 max-h-[9rem] w-36 max-w-[9rem] rounded-full object-cover object-top lg:mb-0'
  }) : /*#__PURE__*/React.createElement("div", {
    className: 'w-36'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'prose sm:prose-lg lg:prose-xl'
  }, contact.name || contact.role ? /*#__PURE__*/React.createElement("div", {
    className: '!mt-0'
  }, contact.name ? /*#__PURE__*/React.createElement("h3", {
    className: '!my-0'
  }, contact.name) : null, contact.role ? /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, contact.role) : null) : null, contact.organisation || contact.Address || contact.telephone ? /*#__PURE__*/React.createElement("p", null, contact.organisation ? /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, contact.organisation) : null, contact.Address ? /*#__PURE__*/React.createElement(contact.Address, null) : null) : null, contact.telephone || contact.mail ? /*#__PURE__*/React.createElement("p", null, contact.telephone ? /*#__PURE__*/React.createElement("span", {
    className: 'block'
  }, contact.telephone) : null, contact.mail ? /*#__PURE__*/React.createElement("a", {
    className: 'focus inline-block text-red-500 no-underline transition duration-300 hover:text-red-600 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)]',
    href: `mailto:${contact.mail}`
  }, contact.mail) : null) : null, contact.AdditionalInfo ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(contact.AdditionalInfo, null), ' ') : null))));
}

/**
 * Hook that detects clicks outside of the passed ref
 * Solution taken from https://stackoverflow.com/a/42234988.
 */
function useOutsideClick(ref, callback) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function Loading({
  style
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: clsx('h-10 w-10 animate-spin', {
      'text-white': style === 'light',
      'text-blue-500': style === 'dark' || !style
    }),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
}

/* eslint-disable react/jsx-no-literals */
function Pager({
  pagerLinks
}) {
  const intl = useIntl();
  const linkClasses = 'text-red-500 transition hover:text-black';
  const activeLinkClass = 'text-white bg-red-500 hover:text-white rounded-full inline-block px-2.5';
  return /*#__PURE__*/React.createElement("ul", {
    className: 'mx-auto -mb-8 mt-8 flex items-center justify-center font-condensed text-lg text-red-500'
  }, pagerLinks?.FirstPage && /*#__PURE__*/React.createElement("li", {
    className: 'text-[0px]'
  }, /*#__PURE__*/React.createElement(pagerLinks.FirstPage, {
    className: clsx('flex items-center p-1 md:px-1.5', linkClasses)
  }, intl.formatMessage({
    id: "A64Z+T",
    defaultMessage: [{
      "type": 0,
      "value": "First page"
    }]
  }), /*#__PURE__*/React.createElement(ChevronDoubleLeftIcon, {
    className: 'h-5 w-5'
  }))), pagerLinks?.PreviousPage && /*#__PURE__*/React.createElement("li", {
    className: 'text-[0px]'
  }, /*#__PURE__*/React.createElement(pagerLinks.PreviousPage, {
    className: clsx('flex items-center p-1 md:px-1.5', linkClasses)
  }, intl.formatMessage({
    id: "k9hDFZ",
    defaultMessage: [{
      "type": 0,
      "value": "Previous page"
    }]
  }), /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: 'h-5 w-5'
  }))), pagerLinks?.hasMissingLeftPages && /*#__PURE__*/React.createElement("li", {
    className: 'p-1 md:px-1.5'
  }, "..."), pagerLinks?.pages && pagerLinks.pages.map((page, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, page.Link ? /*#__PURE__*/React.createElement(page.Link, {
    className: clsx('inline-block px-2.5 md:px-3', linkClasses)
  }, page.number) : /*#__PURE__*/React.createElement("span", {
    className: activeLinkClass
  }, page.number))), pagerLinks?.hasMissingRightPages && /*#__PURE__*/React.createElement("li", {
    className: 'p-1 md:px-1.5'
  }, "..."), pagerLinks?.NextPage && /*#__PURE__*/React.createElement("li", {
    className: 'text-[0px]'
  }, /*#__PURE__*/React.createElement(pagerLinks.NextPage, {
    className: clsx('flex items-center p-1 md:px-1.5', linkClasses)
  }, intl.formatMessage({
    id: "rBj9Ib",
    defaultMessage: [{
      "type": 0,
      "value": "Next page"
    }]
  }), /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: 'h-5 w-5'
  }))), pagerLinks?.LastPage && /*#__PURE__*/React.createElement("li", {
    className: 'text-[0px]'
  }, /*#__PURE__*/React.createElement(pagerLinks.LastPage, {
    className: clsx('flex items-center p-1 md:px-1.5', linkClasses)
  }, intl.formatMessage({
    id: "N8BBfe",
    defaultMessage: [{
      "type": 0,
      "value": "Last page"
    }]
  }), /*#__PURE__*/React.createElement(ChevronDoubleRightIcon, {
    className: 'h-5 w-5'
  }))));
}

const LottieAnimation = ({
  animationDataUrl,
  loop,
  autoplay,
  hover,
  className,
  style,
  playAnimation
}) => {
  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [, setLottiePlayerDesktop] = useState(null);
  const getPlayerProps = () => ({
    className: className,
    style: style ?? {
      width: '100%'
    },
    loop: loop,
    autoplay: autoplay,
    hover: hover,
    ref: playerRef,
    keepLastFrame: true,
    src: animationDataUrl,
    lottieRef: instance => {
      setLottiePlayerDesktop(instance);
    },
    onEvent: event => {
      if (playAnimation !== undefined) {
        if (event === 'play') {
          setIsPlaying(true);
        }
        if (event === 'complete') {
          setIsPlaying(false);
        }
      }
    }
  });
  useEffect(() => {
    if (playAnimation !== undefined) {
      if (playAnimation === true && !isPlaying && playerRef.current) {
        playerRef.current.setSeeker(0);
        playerRef.current.play();
      }
    }
  }, [playerRef, playAnimation, isPlaying]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'relative',
    "data-chromatic": "ignore"
  }, /*#__PURE__*/React.createElement(Player, getPlayerProps()));
};

function MoreLinkCard({
  title,
  Link,
  className
}) {
  const [playAnimation, setPlayAnimation] = useState(false);
  return /*#__PURE__*/React.createElement(Link, {
    className: 'focus relative flex h-full items-center rounded-tl-lg bg-blue-100 transition'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('w-full break-words p-7 pb-6 text-xl font-bold sm:p-10 sm:pb-8 md:text-2xl lg:p-12 lg:pb-10 lg:text-3xl', className),
    onMouseEnter: () => setPlayAnimation(true),
    onMouseLeave: () => setPlayAnimation(false)
  }, title, /*#__PURE__*/React.createElement("div", {
    className: "relative -left-2 mt-0.5 flex brightness-0 md:mt-2 lg:mt-3 h-8 w-8 md:h-11 md:w-11 lg:h-[52px] lg:w-[52px]"
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/arrow_right_red.json',
    playAnimation: playAnimation
  }))));
}

function Teaser({
  Image,
  description,
  title,
  date,
  category,
  Link,
  sosTag,
  bioTag,
  language,
  status,
  isProject = false
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    lang: language,
    className: clsx({
      'border-4 border-red-500': status === 0
    })
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'focus group relative block rounded-tl-lg'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-1 relative -mb-9 block overflow-hidden rounded-tl-lg border-b-4 border-red-500'
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  }) : /*#__PURE__*/React.createElement("img", {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105',
    src: '/fallback_teaser_image.svg',
    alt: 'Teaser image fallback'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative ml-[5.1%] w-[95%] max-w-[95%] bg-white md:ml-[10.1%] md:w-[90%] md:max-w-[90%]'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute -top-[26px] right-0 md:-top-3.5'
  }, isProject && !!date?.end && new Date(date?.end) < new Date() && /*#__PURE__*/React.createElement("span", {
    className: 'ml-0.5 bg-blue-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "T2DELw",
    defaultMessage: [{
      "type": 0,
      "value": "finished"
    }]
  })), !!bioTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-green-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "2W0f9h",
    defaultMessage: [{
      "type": 0,
      "value": "Bio"
    }]
  })), !!sosTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-red-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "CAe6jR",
    defaultMessage: [{
      "type": 0,
      "value": "SOS"
    }]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "relative overflow-hidden pl-5 pt-5 transition after:absolute after:left-0 after:top-[-105%] after:h-full after:w-[4px] after:bg-red-500 after:transition-[top] after:content-[''] group-hover:after:top-0"
  }, !!category && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(category.CategoryLink, {
    className: clsx('focus mb-2.5 inline-block border-black text-xs font-bold uppercase text-red-500 transition')
  }, category.text)), /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition')
  }, title), !!date && !!date.start && /*#__PURE__*/React.createElement("div", {
    className: 'mb-2.5 flex items-center text-sm uppercase text-grey-500'
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: date.start
  }, new Date(date.start).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  })), !!date.end && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'mx-2'
  }, ' - '), /*#__PURE__*/React.createElement("time", {
    dateTime: date.end
  }, new Date(date.end).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  })))), description ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-2.5 font-light'
  }, description) : null))));
}

function TeaserGrid({
  teasers,
  Title,
  Link,
  MoreLink,
  MoreLinkTitle
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, Title ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-2 md:mb-5'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'md:inline-block'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })), Link ? /*#__PURE__*/React.createElement(Link, {
    className: 'focus mb-2 inline-block font-light text-red-500 hover:text-red-600 hover:underline md:mb-0 md:ml-4'
  }, intl.formatMessage({
    id: "pFK6bJ",
    defaultMessage: [{
      "type": 0,
      "value": "View all"
    }]
  })) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: "-mx-2 flex flex-wrap"
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "w-full p-2.5 pb-6 last:pb-0 lg:w-1/3"
  }, /*#__PURE__*/React.createElement(Teaser, teaser))), MoreLink ? /*#__PURE__*/React.createElement("div", {
    className: 'w-full p-2.5 pb-6 last:pb-0 lg:w-1/3'
  }, /*#__PURE__*/React.createElement(MoreLinkCard, {
    title: MoreLinkTitle || intl.formatMessage({
      id: "pFK6bJ",
      defaultMessage: [{
        "type": 0,
        "value": "View all"
      }]
    }),
    Link: MoreLink,
    className: ''
  })) : null)));
}

function ContentHub({
  formFilters,
  teasers,
  pagerLinks,
  isLoading,
  displayFilters,
  GermanLink
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full items-center justify-center py-20"
  }, /*#__PURE__*/React.createElement(Loading, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, displayFilters && /*#__PURE__*/React.createElement(ContentHubForm, formFilters))), intl.locale === 'en' || intl.locale === 'it' ? /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'border-l-4 border-green-500 bg-white px-4 py-3 -mb-1.5'
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-6 w-6 inline mr-2.5 text-green-500",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  })), /*#__PURE__*/React.createElement("span", null, intl.formatMessage({
    id: "lRnc6B",
    defaultMessage: [{
      "type": 0,
      "value": "Additional content can be found on the German version of the site. "
    }, {
      "type": 1,
      "value": "german_version_link"
    }]
  }, {
    german_version_link: GermanLink ? /*#__PURE__*/React.createElement(GermanLink, {
      className: 'focus mb-2 inline-block font-light text-red-500 hover:text-red-600 hover:underline'
    }, intl.formatMessage({
      id: "KQJRB0",
      defaultMessage: [{
        "type": 0,
        "value": "View German content"
      }]
    })) : null
  }))))) : null, teasers.teasers.length ? /*#__PURE__*/React.createElement(TeaserGrid, {
    teasers: teasers.teasers
  }) : /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
    id: "11GIik",
    defaultMessage: [{
      "type": 0,
      "value": "No content available with the given filters."
    }]
  })))), /*#__PURE__*/React.createElement("div", {
    className: "pb-10"
  }, pagerLinks && /*#__PURE__*/React.createElement(Pager, {
    pagerLinks: pagerLinks
  }))));
}
function ContentHubForm({
  Form,
  selectWidgetsOpenStateStore,
  themes,
  types,
  countries,
  count
}) {
  const FormInner = () => {
    const intl = useIntl();
    const {
      values,
      resetForm,
      submitForm
    } = useFormikContext();
    const setOpenedSelectWidget = useStore(selectWidgetsOpenStateStore, state => state.update);
    const openedWidgets = useStore(selectWidgetsOpenStateStore, state => state.openedWidgets);
    const Filterlenght = [themes, types, countries].filter(a => a !== undefined);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: 'mb-10 flex flex-col lg:max-w-6xl lg:gap-7 xl:flex-row xl:gap-10'
    }, /*#__PURE__*/React.createElement("div", {
      className: clsx('flex flex-col items-end lg:flex-row lg:gap-7 xl:gap-10', {
        'xl:max-w-6xl': Filterlenght.length === 3,
        'xl:max-w-4xl': Filterlenght.length === 2,
        'xl:max-w-sm': Filterlenght.length === 1
      })
    }, themes ? /*#__PURE__*/React.createElement("label", {
      className: clsx('w-full mb-5 lg:mb-0 xl:max-w-[215px] xl:w-[215px]', {
        'lg:w-1/3': Filterlenght.length === 3,
        'lg:w-1/2': Filterlenght.length === 2,
        'lg:w-full': Filterlenght.length === 1
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: 'sr-only mb-2 block font-condensed text-xs uppercase tracking-wide'
    }, intl.formatMessage({
      id: "UdtpV7",
      defaultMessage: [{
        "type": 0,
        "value": "Topic"
      }]
    })), /*#__PURE__*/React.createElement(Multiselect, {
      name: "themes",
      title: intl.formatMessage({
        id: "UdtpV7",
        defaultMessage: [{
          "type": 0,
          "value": "Topic"
        }]
      }),
      items: themes,
      disabled: themes.length <= 0,
      setOpenedSelectWidget: setOpenedSelectWidget,
      openState: openedWidgets.includes('themes')
    })) : null, types ? /*#__PURE__*/React.createElement("label", {
      className: clsx('w-full mb-5 lg:mb-0 xl:max-w-[215px] xl:w-[215px]', {
        'lg:w-1/3': Filterlenght.length === 3,
        'lg:w-1/2': Filterlenght.length === 2,
        'lg:w-full': Filterlenght.length === 1
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: 'sr-only mb-2 block font-condensed text-xs uppercase tracking-wide'
    }, intl.formatMessage({
      id: "7l6nS4",
      defaultMessage: [{
        "type": 0,
        "value": "Format / Type"
      }]
    })), /*#__PURE__*/React.createElement(Multiselect, {
      name: "types",
      title: intl.formatMessage({
        id: "7l6nS4",
        defaultMessage: [{
          "type": 0,
          "value": "Format / Type"
        }]
      }),
      items: types,
      disabled: types.length <= 0,
      setOpenedSelectWidget: setOpenedSelectWidget,
      openState: openedWidgets.includes('types')
    })) : null, countries ? /*#__PURE__*/React.createElement("label", {
      className: clsx('w-full mb-5 lg:mb-0 xl:max-w-[215px] xl:w-[215px]', {
        'lg:w-1/3': Filterlenght.length === 3,
        'lg:w-1/2': Filterlenght.length === 2,
        'lg:w-full': Filterlenght.length === 1
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: 'sr-only mb-2 block font-condensed text-xs uppercase tracking-wide'
    }, intl.formatMessage({
      id: "vONi+O",
      defaultMessage: [{
        "type": 0,
        "value": "Country"
      }]
    })), /*#__PURE__*/React.createElement(Multiselect, {
      name: "countries",
      title: intl.formatMessage({
        id: "vONi+O",
        defaultMessage: [{
          "type": 0,
          "value": "Country"
        }]
      }),
      items: countries,
      disabled: countries.length <= 0,
      setOpenedSelectWidget: setOpenedSelectWidget,
      openState: openedWidgets.includes('countries')
    })) : null), /*#__PURE__*/React.createElement("div", {
      className: 'flex flex-col lg:flex-row-reverse lg:items-end lg:gap-7 xl:flex-row xl:gap-10'
    }, /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "button-tertiary shrink-0"
    }, count && /*#__PURE__*/React.createElement("span", {
      className: 'pr-3'
    }, count), /*#__PURE__*/React.createElement("span", null, intl.formatMessage({
      id: "jo5Adw",
      defaultMessage: [{
        "type": 0,
        "value": "Ergebnis(se) anzeigen"
      }]
    }))), /*#__PURE__*/React.createElement("button", {
      type: "reset",
      className: 'button-text shrink-0 whitespace-nowrap',
      onClick: () => {
        resetForm({
          values: {}
        });
        submitForm();
      }
    }, intl.formatMessage({
      id: "KuVIjg",
      defaultMessage: [{
        "type": 0,
        "value": "Alle löschen"
      }]
    })))), values.themes?.length || values.types?.length || values.countries?.length ? /*#__PURE__*/React.createElement("div", {
      className: 'my-10 flex flex-wrap gap-5 lg:max-w-6xl'
    }, !!values.themes?.length && themes && !!themes.length && values.themes?.map((item, index) => /*#__PURE__*/React.createElement(Badge, {
      key: index,
      items: themes,
      item: item
    })), !!values.types?.length && types && !!types.length && values.types?.map((item, index) => /*#__PURE__*/React.createElement(Badge, {
      key: index,
      items: types,
      item: item
    })), !!values.countries?.length && countries && !!countries.length && values.countries?.map((item, index) => /*#__PURE__*/React.createElement(Badge, {
      key: index,
      items: countries,
      item: item
    }))) : null);
  };
  return /*#__PURE__*/React.createElement(Form, {
    className: "my-10",
    id: "listing-filters"
  }, /*#__PURE__*/React.createElement(FormInner, null));
}
function Multiselect({
  name,
  title,
  items,
  className,
  disabled,
  onOptionChange,
  setOpenedSelectWidget,
  openState
}) {
  const [field] = useField(name);
  const ref = useRef(null);
  useOutsideClick(ref, () => {
    setOpenedSelectWidget && setOpenedSelectWidget(name, false);
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(Popover, {
    className: "relative w-full",
    "aria-disabled": disabled
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover.Button, {
    className: clsx('focus-form mb-0 w-full rounded-sm border border-blue-100 bg-blue-100 p-3 pb-2 text-left text-black', disabled && 'text-[#B3B6B8]', className),
    disabled: disabled,
    onPointerUp: () => {
      setOpenedSelectWidget && setOpenedSelectWidget(name, !openState);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex flex-nowrap items-center justify-between text-sm font-bold after:absolute after:right-[2.7rem] after:top-[30px] after:h-6 after:w-px after:translate-y-[-20px] after:rounded-full after:bg-black after:content-[""] lg:after:top-5 lg:after:translate-y-[-10px]', disabled && 'after:bg-[#B3B6B8]')
  }, field.value?.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden text-ellipsis whitespace-nowrap"
  }, items.filter(item => field.value.includes(item.id)).map(item => item.label).join(', ')), ' ', /*#__PURE__*/React.createElement("div", {
    className: "ml-4 shrink-0 before:content-[\"(\"] after:content-[\")\"]"
  }, field.value?.length)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement(ChevronUpIcon, {
    strokeWidth: 2,
    className: clsx('block h-5 w-5 shrink-0 transition', {
      'rotate-180': setOpenedSelectWidget ? !openState : !open
    })
  })))), (setOpenedSelectWidget && openState || !setOpenedSelectWidget && open) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Popover.Panel, {
    className: "absolute z-[10000] w-full border border-grey-100 bg-white py-2 drop-shadow-xl",
    tabIndex: -1,
    static: true
  }, items.map(({
    id,
    label,
    depth
  }) => /*#__PURE__*/React.createElement("label", {
    key: id,
    className: `relative flex items-center px-3 py-1.5 font-light last:mb-0 hover:bg-blue-100 ml-${depth * 4}`
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    onChange: e => {
      field.onChange(e);
      if (typeof onOptionChange !== 'undefined') {
        onOptionChange(e);
      }
    },
    name: name,
    value: id,
    className: "focus-form absolute text-red-500"
  }), /*#__PURE__*/React.createElement("span", {
    className: "block pl-7"
  }, label))))))));
}
function Badge({
  items,
  item
}) {
  const filterObject = items.filter(originalItem => originalItem.id == item)[0];
  const filterLabel = filterObject ? filterObject.label : null;
  return filterLabel ? /*#__PURE__*/React.createElement("span", {
    className: 'focus rounded-md bg-green-100 px-3 pt-2 pb-1.5 text-sm font-bold text-blue-500 transition'
  }, filterLabel) : null;
}

function CookiePreferencesButton({
  label
}) {
  const intl = useIntl();
  const handleClick = () => {
    // @ts-ignore
    if (window !== undefined && window.Optanon !== undefined) {
      // @ts-ignore
      Optanon.ToggleInfoDisplay();
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    className: 'button-tertiary gap-3',
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: "1.5",
    stroke: "currentColor",
    className: "w-5 h-5 mb-px"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  })), label || intl.formatMessage({
    id: "RgrBpr",
    defaultMessage: [{
      "type": 0,
      "value": "Adjust cookie settings"
    }]
  }));
}

const buildEcommerceItemsFromBoxItems = (boxItems, recurringInterval, transactionInfo) => {
  return boxItems.map(boxItem => ({
    item_name: boxItem.donationIcon?.originalLabel,
    item_id: boxItem.donationIcon?.originalLabel,
    // For box items, we get the amount in units, so we need to convert it to
    // subunits, like all the other simple donations (where the price is taken
    // from the transaction info object).
    price: Math.round(boxItem.amount * 100),
    quantity: 1,
    item_variant: recurringInterval,
    donation_purpose_label: transactionInfo?.stored_donation_purpose_label,
    donation_purpose_id: transactionInfo?.stored_donation_purpose_id
  }));
};
const buildEcommerceItems = (paymentFormData, boxItems) => {
  const recurringInterval = paymentFormData.payment_type === 'recurring' ? paymentFormData.recurring_interval : 'onetime';
  if (typeof boxItems !== 'undefined') {
    return buildEcommerceItemsFromBoxItems(boxItems, recurringInterval, paymentFormData);
  }
  return [{
    item_name: 'donation',
    item_id: 'donation',
    price: Math.round(paymentFormData.amount * 100),
    quantity: 1,
    item_variant: recurringInterval
  }];
};
const pushRaisenowCoverFeeInteraction = (event, boxItems) => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const paymentFormData = event.data.api.paymentForm.data;
  const eventObject = {
    event: 'additional_payment',
    ecommerce: {
      additional_payment: paymentFormData.stored_cover_transaction_fee.toString(),
      api_data: event.data.api,
      currencyCode: paymentFormData.currency.toUpperCase(),
      items: buildEcommerceItems(paymentFormData, boxItems)
    }
  };
  window.dataLayer.push(eventObject);
};
const pushRaisenowPersonalDetailsUpdated = (event, boxItems) => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const paymentFormData = event.data.api.paymentForm.data;
  const eventObject = {
    event: 'add_shipping_info',
    ecommerce: {
      api_data: event.data.api,
      currencyCode: event.data.api.paymentForm.data.currency.toUpperCase(),
      items: buildEcommerceItems(paymentFormData, boxItems)
    }
  };
  window.dataLayer.push(eventObject);
};
const pushRaisenowPaymentMethodChanged = (event, boxItems) => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const paymentFormData = event.data.api.paymentForm.data;
  const eventObject = {
    event: 'add_payment_info',
    ecommerce: {
      payment_type: paymentFormData.payment_method,
      api_data: event.data.api,
      currencyCode: paymentFormData.currency.toUpperCase(),
      items: buildEcommerceItems(paymentFormData, boxItems)
    }
  };
  window.dataLayer.push(eventObject);
};
const pushRaisenowPaymentCompleted = event => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const api = event.data.api;
  const transactionInfo = typeof api.epmsPaymentInfo !== 'undefined' ? api.epmsPaymentInfo : api.transactionInfo;
  const paymentStatus = typeof api.epmsPaymentInfo !== 'undefined' ? api.epmsPaymentInfo.last_status : api.transactionInfo.epayment_status;
  // If the epmsPaymentInfo property does not exist on the api object, then the
  // amount is returned in units. Otherwise, it is returned in subunits. This
  // is an API issue, and we might have to revert this code when the issue gets
  // fixed in Raisenow.
  const amountInUnits = typeof api.epmsPaymentInfo === 'undefined';
  // The value of a successfull payment status can be 'success' if it comes from
  // the transactionInfo object, or 'succeeded' if it comes from the
  // epmsPaymentInfo object.
  if (paymentStatus === 'success' || paymentStatus === 'succeeded') {
    const boxItems = transactionInfo.stored_box_items ? JSON.parse(transactionInfo.stored_box_items) : [];
    const recurringInterval = transactionInfo.stored_rnw_recurring_interval_name || 'onetime';
    // If the amount returned is in units, then we multiply it by 100, as we
    // want to send the amount in subunits to the GTM purchase event.
    const totalAmount = amountInUnits ? transactionInfo.amount * 100 : transactionInfo.amount;
    // The fee info is already in subunits.
    const tax = transactionInfo.stored_rnw_cover_fee_amount ? parseInt(transactionInfo.stored_rnw_cover_fee_amount) : 0;
    const currencyCode = typeof transactionInfo.currency !== 'undefined' ? transactionInfo.currency : typeof transactionInfo.currency_identifier !== 'undefined' ? transactionInfo.currency_identifier : 'CHF';
    const eventObject = {
      event: 'purchase',
      ecommerce: {
        transaction_id: transactionInfo.epp_transaction_id,
        value: Math.round(totalAmount),
        tax: Math.round(tax),
        api_data: event.data.api,
        currencyCode: currencyCode.toUpperCase(),
        items: boxItems.length > 0 ? buildEcommerceItemsFromBoxItems(boxItems, recurringInterval, transactionInfo) : [{
          item_name: 'donation',
          item_id: 'donation',
          price: Math.round(totalAmount - tax),
          quantity: 1,
          item_variant: recurringInterval,
          donation_purpose_id: transactionInfo.stored_donation_purpose_id,
          donation_purpose_label: transactionInfo.stored_donation_purpose_label
        }]
      }
    };
    window.dataLayer.push(eventObject);
  }
};
const pushDonationBoxAddItem = donationItem => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'donation-box',
    donation_box_value: `CHF ${donationItem.amount}`,
    price: Math.round(donationItem.amount * 100),
    item_name: donationItem.donationIcon?.originalLabel,
    item_id: donationItem.donationIcon?.originalLabel,
    donation_purpose_label: donationItem.donationPurposeLabel,
    donation_purpose_id: donationItem.donationPurposeId
  };
  window.dataLayer.push(eventObject);
};
const pushDonationBoxCheckoutItems = items => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'donation-box-checkout',
    items: items.map(boxItem => ({
      item_name: boxItem.donationIcon?.originalLabel,
      item_id: boxItem.donationIcon?.originalLabel,
      price: Math.round(boxItem.amount * 100),
      quantity: 1,
      donation_purpose_label: boxItem.donationPurposeLabel,
      donation_purpose_id: boxItem.donationPurposeId
    }))
  };
  window.dataLayer.push(eventObject);
};
const pushLocationsAdditionalSearchClick = additionalSearchSelected => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'additional_search_criteria',
    additional_criteria: additionalSearchSelected
  };
  window.dataLayer.push(eventObject);
};
const pushLocationsSearchResultsViewTypeClick = viewType => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'change_results',
    type: viewType
  };
  window.dataLayer.push(eventObject);
};
const pushLocationsSearchFiltersAppliedClick = (totalResults, filters) => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'filters_applied',
    results: totalResults,
    filters: filters
  };
  window.dataLayer.push(eventObject);
};
const pushLocationsSearchFiltersSelect = (filter_name, filter_value) => {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }
  const eventObject = {
    event: 'filter_selected',
    filter_name: filter_name,
    filter_value: filter_value
  };
  window.dataLayer.push(eventObject);
};

const widgets = {
  donation: 'https://tamaro.raisenow.com/caritas-spenden/latest/widget.js',
  climate: 'https://tamaro.raisenow.com/caritas-klima/latest/widget.js',
  sponsor: 'https://tamaro.raisenow.com/caritas-paten/latest/widget.js'
};
const blocks = {
  donation: [
  // Hide the purpose selection block.
  // 'payment_purposes',
  'payment_amounts_and_intervals', 'payment_payment_methods', 'payment_profile', {
    if: 'showPaymentAddress()',
    then: 'payment_address'
  }, 'payment_cover_fee'],
  climate: [
  // Hide the purpose selection block.
  // 'payment_purposes',
  'payment_amounts_and_intervals', 'payment_payment_methods', 'payment_profile', {
    if: 'showPaymentAddress()',
    then: 'payment_address'
  }],
  // TODO: Fill sponsor blocks when it has bee updated to Tamaro v2.
  // sponsor: [],
  sponsor: [
  // Hide the purpose selection block.
  // "payment_purposes",
  'payment_amounts_and_intervals', 'payment_payment_methods', 'payment_profile', {
    if: 'showPaymentAddress()',
    then: 'payment_address'
  }]
};
function DonationForm({
  widget,
  debug,
  nodeId,
  campaignId,
  campaignSubId,
  sextantProductId,
  sextantContractTemplateUid,
  description,
  purposeTexts,
  thankYouPagePath,
  donationPurposeLabel,
  testMode = true,
  boxItems,
  hasDisclaimer,
  ...props
}) {
  const ref = React.useRef(null);
  const intl = useIntl();
  const defaultPeriod = widget === 'sponsor' ? 'monthly' : 'oneTime';
  const defaultAmounts = props.amounts?.[defaultPeriod]?.amounts || [];
  const amounts = widget === 'donation' || widget === 'sponsor' ? {
    amounts: [{
      if: 'paymentType() != recurring',
      then: defaultAmounts
    }, {
      if: 'paymentType() == recurring and recurringInterval() == monthly',
      then: props.amounts?.monthly?.amounts || defaultAmounts
    }, {
      if: 'paymentType() == recurring and recurringInterval() == yearly',
      then: props.amounts?.yearly?.amounts || defaultAmounts
    }, {
      if: 'paymentType() == recurring and recurringInterval() == quarterly',
      then: defaultAmounts
    }, {
      if: 'paymentType() == recurring and recurringInterval() == semestral',
      then: defaultAmounts
    }]
  } : {
    amounts: defaultAmounts.map(defaultAmountValue => {
      return {
        if: `paymentForm(stored_climate_shares_number) == ${defaultAmountValue}`,
        then: defaultAmountValue * 500
      };
    })
  };
  const defaultAmount = props.amount || props.amounts && props.amounts[props.period]?.default;
  useEffect(() => {
    const config = {
      language: props.language || 'de',
      purposeDetails: {
        // Set the campaign as the only purpose option on this widget.
        // The widget itself should not be displayed at all.
        [`p${nodeId}`]: {
          stored_sxt_product_id: sextantProductId,
          stored_sxt_contract_template_id: sextantContractTemplateUid,
          ...(typeof campaignId !== 'undefined' && typeof campaignSubId !== 'undefined' ? {
            stored_campaign_id: campaignId,
            stored_campaign_subid: campaignSubId
          } : {})
        }
      },
      paymentFormPrefill: {
        stored_sxt_product_id: sextantProductId,
        stored_sxt_contract_template_id: sextantContractTemplateUid,
        stored_donation_purpose_label: donationPurposeLabel,
        stored_donation_purpose_id: nodeId,
        ...(boxItems ? {
          // The new box items contain also the svgSource field for the icon
          // itself, and we don't want that information to appear in the
          // donationIcon because:
          // 1. It is just polluting the data.
          // 2. Generates errors when parsing the JSON output when data is
          // retrieved from raisenow (the data seems to be truncated, it has
          // probably a maximum length).
          stored_box_items: JSON.stringify(boxItems.map(boxItem => ({
            ...boxItem,
            donationIcon: {
              label: boxItem.donationIcon?.label,
              originalLabel: boxItem.donationIcon?.originalLabel
            }
          })))
        } : {}),
        ...(description ? {
          stored_customer_message: description
        } : {}),
        ...(widget === 'climate' ? {
          stored_climate_shares_number: defaultAmount || '1'
        } : {}),
        ...(defaultAmount ? {
          amount_position: !props.isCustomAmount && props.amounts ? props.amounts[props.period]?.amounts?.indexOf(defaultAmount) : -1,
          ...(props.isCustomAmount ? {
            custom_amount: defaultAmount
          } : {})
        } : {})
      },
      ...(defaultAmount ? {
        default_amount: defaultAmount
      } : {}),
      // Preselect our single purpose option.
      default_purpose: `p${nodeId}`,
      ...(props.period && props.period !== 'oneTime' && {
        default_payment_type: 'recurring',
        default_recurring_interval: props.period
      }),
      purposes: [`p${nodeId}`],
      // The original purposeTexts object has this form:
      // {
      //  en: {34: "Donation title 1", 50: "Donation title 2"}
      //  de: {34: "Donation title 1 DE", 50: "Donation title 2 DE"}
      // }
      // And we have to convert it to:
      // {
      //   en: {
      //     purposes: {p34: "Donation title 1", p50: "Donation title 2"}
      //   }
      //   de: {
      //     purposes: {p34: "Donation title 1 DE", p50: "Donation title 2 DE"}
      //   }
      // }
      translations: purposeTexts ? Object.keys(purposeTexts).reduce((accumulator, currentPurposeLangcode) => {
        return {
          ...accumulator,
          [currentPurposeLangcode]: {
            purposes: Object.keys(purposeTexts[currentPurposeLangcode]).reduce((purposeTranslations, currentPurposeId) => {
              return {
                ...purposeTranslations,
                [`p${currentPurposeId}`]: purposeTexts[currentPurposeLangcode][currentPurposeId]
              };
            }, {}),
            ...(widget === 'donation' && {
              blocks: {
                payment_submit: {
                  submit: intl.formatMessage({
                    id: "mKndUJ",
                    defaultMessage: [{
                      "type": 0,
                      "value": "Make the donation "
                    }, {
                      "type": 1,
                      "value": "title"
                    }]
                  }, {
                    title: purposeTexts[currentPurposeLangcode][nodeId]
                  })
                }
              }
            }),
            ...(widget === 'sponsor' && {
              blocks: {
                payment_submit: {
                  submit: intl.formatMessage({
                    id: "jjVcK8",
                    defaultMessage: [{
                      "type": 0,
                      "value": "Take over sponsorship for «"
                    }, {
                      "type": 1,
                      "value": "title"
                    }, {
                      "type": 0,
                      "value": "»"
                    }]
                  }, {
                    title: purposeTexts[currentPurposeLangcode][nodeId]
                  })
                }
              }
            })
          }
        };
      }, {}) : {},
      paymentWidgetBlocks: blocks[widget],
      ...amounts,
      // Stay in test mode until the variable is defined, which
      // should only happen on the actual production environment.
      testMode,
      ...(widget === 'climate' ? {
        slots: {
          amounts_start: [{
            component: 'field',
            type: 'select',
            formName: 'payment_form',
            name: 'stored_climate_shares_number',
            label: 'payment_form.stored_climate_shares_number',
            options: defaultAmounts.map(defaultAmountValue => {
              return {
                value: defaultAmountValue,
                label: `payment_form.stored_climate_shares_numbers.${defaultAmountValue}`
              };
            })
          }]
        }
      } : {}),
      ...(debug ? {
        debug: true,
        layout: 'list',
        overlayMode: 'outer',
        debugSlots: true,
        debugErrorMessages: true,
        debugStyles: true
      } : {})
    };

    // Remove a potentially existing raisenow script and inject the current one
    const raisenowScript = document.getElementById('raisenow-widget-script');
    if (raisenowScript) {
      if (raisenowScript.getAttribute('src') !== widgets[widget]) {
        window.rnw?.tamaro?.destroy?.();
        window.rnw = undefined;
        raisenowScript.remove();
        document.querySelectorAll('[data-widget="rnw-tamaro"]').forEach(el => el.remove());
      }
    }
    if (!document.getElementById('raisenow-widget-script')) {
      const script = document.createElement('script');
      script.src = widgets[widget];
      script.id = 'raisenow-widget-script';
      window.document.body.appendChild(script);
    }
    if (window.rnw?.tamaro.customStore) {
      window.rnw.tamaro.customStore.boxItems = boxItems;
    }
    // Wait for the raisenow script to initialize `window.rnw` and create
    // the widget
    const interval = setInterval(() => {
      if (window.rnw && ref.current) {
        if (interval) {
          clearInterval(interval);
        }
        window.rnw?.tamaro.runWidget(ref.current, config);
        if (!window.rnw.tamaro.customStore) {
          window.rnw.tamaro.customStore = {
            boxItems: boxItems
          };
        }

        // Transaction (payment) completed event.
        if (!window.rnw.tamaro.customStore.paymentCompleteSubscribed) {
          window.rnw.tamaro.customStore.paymentCompleteSubscribed = true;
          window.rnw.tamaro.events.paymentComplete.subscribe(function (event) {
            // @todo: this works, but this will be triggered whenever a success
            // page gets displayed, so even when the page is just refreshed.
            pushRaisenowPaymentCompleted(event);
            const api = event.data.api;
            // The value of a successfull payment status can be 'success' if it
            // comes from the transactionInfo object, or 'succeeded' if it comes
            // from the epmsPaymentInfo object.
            if ((typeof api.epmsPaymentInfo !== "undefined" && api.epmsPaymentInfo.last_status === 'succeeded' || typeof api.transactionInfo !== "undefined" && api.transactionInfo.epayment_status === 'success') && thankYouPagePath) {
              // When redirecting to the thank you page, we want to hide all the
              // transaction info blocks, but keep the payment widget so that
              // the loading throbber gets displayed.
              document.querySelectorAll('.payment-widget .transaction-info-block div').forEach(el => el.style.display = 'none');
              window.location.href = `${window.location.origin}${thankYouPagePath}`;
            } else {
              // If there is no thank you page, we want to scroll to the top of
              // the donation widget, which will contain the transaction info
              // and the thank you message.
              const hashElement = document.getElementById('widget-top-element--widget');
              if (hashElement) {
                hashElement.scrollIntoView();
              }
            }
          });
        }

        // Payment method changed (add payment info) event.
        if (!window.rnw.tamaro.customStore.paymentMethodChangedSubscribed) {
          window.rnw.tamaro.customStore.paymentMethodChangedSubscribed = true;
          window.rnw.tamaro.events.paymentMethodChanged.subscribe(function (event) {
            // We only trigger this even if the payment method get selected, not
            // when the user clicks on the "Choose another payment method" link,
            // because this event is also invoked then. Also, we are not
            // interested to trigger this if there is already a transaction
            // available (so the user is on the thank you page).
            try {
              const transactionExists = typeof event.data.api.transactionInfo !== 'undefined' || typeof event.data.api.epmsPaymentInfo !== 'undefined';
              if (!transactionExists && event.data.api.paymentForm.data.payment_method) {
                pushRaisenowPaymentMethodChanged(event, window.rnw?.tamaro.customStore.boxItems);
              }
            } catch (error) {
              console.error(error);
            }
          });
        }

        // Add personal details. We subscribe actually to the
        // beforePaymentValidate event, which gets triggered very often, and we
        // will just check if the user did some changes in the salutation
        // field (which is required), which means the user did enter some data
        // in the personal details section.
        let gaPersonalDetailsAdded = '';
        let gaCoverFeeAccepted = 'false';
        if (!window.rnw.tamaro.customStore.beforePaymentValidateSubscribed) {
          window.rnw.tamaro.customStore.beforePaymentValidateSubscribed = true;
          window.rnw.tamaro.events.beforePaymentValidate.subscribe(function (event) {
            try {
              // For some reason, the event.data.api.transactionInfo object is
              // always undefined here (might be a bug or maybe something else
              // behaving in a different way on raisenow), even if there is a
              // transaction (like on the thank you page), so we will just check
              // the epp_transaction_id paramtere in the current location (url).
              const transactionExists = typeof event.data.api.currentLocation.params.epp_transaction_id !== 'undefined';
              const form = event.data.api.paymentForm;
              if (
              // We are also not interested to trigger the event if there is
              // already a transaction object available (which means we are
              // already on a thank you page).
              !transactionExists && typeof form.data.stored_customer_salutation !== 'undefined' && form.data.stored_customer_salutation !== null && form.data.stored_customer_salutation !== gaPersonalDetailsAdded) {
                gaPersonalDetailsAdded = form.data.stored_customer_salutation;
                pushRaisenowPersonalDetailsUpdated(event, window.rnw?.tamaro.customStore.boxItems);
              }
              if (!transactionExists && typeof form.data.stored_cover_transaction_fee !== 'undefined' && form.data.stored_cover_transaction_fee !== null && form.data.stored_cover_transaction_fee.toString() !== gaCoverFeeAccepted) {
                gaCoverFeeAccepted = form.data.stored_cover_transaction_fee.toString();
                pushRaisenowCoverFeeInteraction(event, window.rnw?.tamaro.customStore.boxItems);
              }
            } catch (error) {
              console.error(error);
            }
          });
        }
      }
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, [ref, campaignId, campaignSubId, debug, sextantContractTemplateUid, sextantProductId, widget, description, props.amount]);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'mt-20 mb-5 sm:mb-10': hasDisclaimer
    }, 'my-20')
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }));
}

function DonationBox({
  items,
  customItem,
  donationForm,
  showForm = false,
  boxLabels = {},
  boxGraphics = {}
}) {
  const intl = useIntl();
  const [selectedItems, setSelectedItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [CollapsibleIsOpen, setCollapsibleIsOpen] = useState(true);
  const [inputValue, setInputValue] = useState(0);
  const ScrollRef = useRef(null);
  const labelCustomAmount = boxLabels.labelCustomAmount || intl.formatMessage({
    id: "/t9a6u",
    defaultMessage: [{
      "type": 0,
      "value": "Custom amount"
    }]
  });
  const customItemOption = customItem ? {
    donationIcon: {
      label: labelCustomAmount,
      originalLabel: labelCustomAmount,
      svgSource: allowanceSvgSource
    },
    amount: 0
  } : undefined;
  const labelCustomAmountDescription = boxLabels.labelCustomAmountDescription || intl.formatMessage({
    id: "c9k9eR",
    defaultMessage: [{
      "type": 0,
      "value": "Ihre Geldspende für die Caritas Katastrophenhilfe"
    }]
  });
  const labelCustomAmountButton = boxLabels.labelCustomAmountButton || intl.formatMessage({
    id: "Fz1trW",
    defaultMessage: [{
      "type": 0,
      "value": "Eingeben"
    }]
  });
  const labelBoxContentTitle = boxLabels.labelBoxContentTitle || intl.formatMessage({
    id: "o9Tbwx",
    defaultMessage: [{
      "type": 0,
      "value": "Ihre Hilfskiste enthält"
    }]
  });
  const labelBoxContentValue = boxLabels.labelBoxContentValue || intl.formatMessage({
    id: "T3X5iU",
    defaultMessage: [{
      "type": 0,
      "value": "Wert Ihrer Kiste"
    }]
  });
  const labelCloseBoxButton = boxLabels.labelCloseBoxButton || intl.formatMessage({
    id: "KPwwnE",
    defaultMessage: [{
      "type": 0,
      "value": "KISTE SCHLIESSEN"
    }]
  });
  const labelOpenBoxButton = boxLabels.labelOpenBoxButton || intl.formatMessage({
    id: "9y1GxX",
    defaultMessage: [{
      "type": 0,
      "value": "Kiste anpassen"
    }]
  });
  const labelFooterText = boxLabels.labelFooterText || intl.formatMessage({
    id: "7cRiw8",
    defaultMessage: [{
      "type": 0,
      "value": "Caritas Schweiz setzt Ihre Spende dort ein, wo Menschen in Entwicklungsländern von Covid-19 betroffen sind und Hilfe benötigen."
    }]
  });
  const openBoxImagePath = boxGraphics.openBoxImage ? boxGraphics.openBoxImage.file.url : '/donation-box/donation_box_open.png';
  const closedBoxImagePath = boxGraphics.closedBoxImage ? boxGraphics.closedBoxImage.file.url : '/donation-box/donation_box_closed.png';
  useEffect(() => {
    setTotalAmount(selectedItems.reduce((accumulator, object) => {
      return accumulator + object.amount;
    }, 0));
  }, [selectedItems]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page relative my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    ref: ScrollRef,
    className: 'absolute -mt-20'
  }), /*#__PURE__*/React.createElement(Transition, {
    show: CollapsibleIsOpen && !showForm,
    enter: "transition-opacity duration-500 delay-500",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: () => {
      ScrollRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto my-16 max-w-5xl'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-wrap justify-center xl:-mx-2.5'
  }, items.map((item, index) => {
    const itemIsActive = selectedItems.filter(({
      donationIcon
    }) => donationIcon?.label === item.donationIcon?.label).length > 0;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `relative box-border w-1/2 p-2.5 md:w-1/3 lg:w-1/6 tracking-donation-box-item tracking-donation-box-item-price-chf${item.amount}`
    }, /*#__PURE__*/React.createElement("button", {
      className: 'focus w-full h-full',
      onClick: () => {
        const selectedBoxItem = {
          ...item,
          donationPurposeLabel: donationForm.donationPurposeLabel,
          donationPurposeId: donationForm.nodeId
        };
        setSelectedItems(prevSelectedItems => [...prevSelectedItems, selectedBoxItem]);
        pushDonationBoxAddItem(selectedBoxItem);
      },
      disabled: itemIsActive
    }, /*#__PURE__*/React.createElement(DonationBadge, {
      active: itemIsActive,
      donationIcon: item.donationIcon,
      amount: item.amount
    })), itemIsActive ? /*#__PURE__*/React.createElement("button", {
      className: 'focus absolute top-0 right-0 flex h-6 w-6 items-center justify-center rounded-full bg-green-100 transition hover:bg-green-500 hover:text-white',
      onClick: () => setSelectedItems(selectedItems.filter(({
        donationIcon
      }) => donationIcon?.label !== item.donationIcon?.label))
    }, /*#__PURE__*/React.createElement(XIcon, {
      className: 'h-4 w-4'
    })) : null);
  }), customItemOption ? /*#__PURE__*/React.createElement("div", {
    className: 'relative box-border w-1/2 p-2.5 md:w-1/3 lg:w-1/6 tracking-donation-box-item tracking-donation-box-item-price-select'
  }, /*#__PURE__*/React.createElement("button", {
    className: 'focus w-full h-full',
    disabled: selectedItems.filter(({
      donationIcon
    }) => donationIcon?.label === customItemOption.donationIcon?.label).length > 0,
    onClick: () => setModalIsOpen(true)
  }, /*#__PURE__*/React.createElement(DonationBadge, {
    active: selectedItems.filter(({
      donationIcon
    }) => donationIcon?.label === customItemOption.donationIcon?.label).length > 0,
    donationIcon: customItemOption.donationIcon,
    amount: inputValue
  })), selectedItems.filter(({
    donationIcon
  }) => donationIcon?.label === customItemOption.donationIcon?.label).length > 0 ? /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setSelectedItems(selectedItems.filter(({
        donationIcon
      }) => donationIcon?.label !== customItemOption.donationIcon?.label));
      setInputValue(0);
    },
    className: 'focus absolute top-0 right-0 flex h-6 w-6 items-center justify-center rounded-full bg-green-100 transition hover:bg-green-500 hover:text-white'
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-4 w-4'
  })) : null) : null)), /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto mb-20 mt-28 max-w-sm'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'h-auto w-full',
    src: openBoxImagePath,
    alt: intl.formatMessage({
      id: "wj6AFw",
      defaultMessage: [{
        "type": 0,
        "value": "opened box"
      }]
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: 'absolute left-1/2 bottom-16 grid -translate-x-1/2 grid-cols-3 gap-3'
  }, selectedItems.length ? selectedItems.map((item, index) => {
    const Icon = buildHtml(item.donationIcon?.svgSource || '');
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: 'flex h-10 w-10 items-center justify-center rounded-tl-lg bg-white shadow-lg md:h-14 md:w-14'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'mx-auto h-6 w-6 md:h-10 md:w-10'
    }, Icon ? /*#__PURE__*/React.createElement(Icon, null) : null));
  }) : null))), /*#__PURE__*/React.createElement("div", {
    className: 'my-10 mx-auto max-w-4xl'
  }, selectedItems.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-full md:prose-xl'
  }, /*#__PURE__*/React.createElement("h4", null, labelBoxContentTitle)), /*#__PURE__*/React.createElement("ul", {
    className: 'mt-5'
  }, selectedItems.map(({
    amount,
    donationIcon
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: 'md:prose:xl prose flex max-w-full items-center justify-between border-b border-grey-100 py-3 first:border-t'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center justify-between'
  }, /*#__PURE__*/React.createElement("span", null, donationIcon?.label)), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center justify-between'
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("small", {
    className: 'text-sm'
  }, "CHF"), " ", amount), /*#__PURE__*/React.createElement("button", {
    onClick: () => setSelectedItems(selectedItems.filter(item => item.donationIcon?.label !== donationIcon?.label)),
    className: 'focus ml-3 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-blue-100 transition hover:bg-blue-500 hover:text-white'
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-4 w-4'
  }))))), /*#__PURE__*/React.createElement("li", {
    className: 'prose mt-3 flex max-w-full max-w-full items-center justify-between font-bold md:prose-xl'
  }, /*#__PURE__*/React.createElement("span", null, labelBoxContentValue), /*#__PURE__*/React.createElement("span", {
    className: 'mr-11'
  }, /*#__PURE__*/React.createElement("small", {
    className: 'text-sm'
  }, "CHF"), " ", totalAmount)))) : null, /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto mt-14 max-w-md'
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('focus flex h-16 w-full items-center justify-center rounded-tl-xl px-6 font-condensed uppercase text-white transition', {
      'bg-red-500 hover:bg-red-600': selectedItems.length,
      'bg-grey-200': !selectedItems.length
    }),
    type: "submit",
    disabled: !selectedItems.length,
    onClick: () => {
      setCollapsibleIsOpen(false);
      pushDonationBoxCheckoutItems(selectedItems);
    }
  }, labelCloseBoxButton), /*#__PURE__*/React.createElement("div", {
    className: 'prose mt-8 max-w-full text-center md:prose-xl'
  }, labelFooterText)))), /*#__PURE__*/React.createElement(Transition, {
    show: !CollapsibleIsOpen || showForm,
    enter: "transition-opacity duration-500 delay-500",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: () => {
      ScrollRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, selectedItems.length ? /*#__PURE__*/React.createElement("div", {
    className: 'my-20 mx-auto max-w-sm'
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('focus flex h-16 w-full items-center justify-center rounded-tl-xl px-6 font-condensed uppercase text-white transition', {
      'bg-red-500 hover:bg-red-600': selectedItems.length,
      'bg-grey-200': !selectedItems.length
    }),
    type: "submit",
    disabled: !selectedItems.length,
    onClick: () => {
      setCollapsibleIsOpen(true);
    }
  }, labelOpenBoxButton), /*#__PURE__*/React.createElement("div", {
    className: 'relative mt-14'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'h-auto w-full',
    src: closedBoxImagePath,
    alt: intl.formatMessage({
      id: "IYUp8M",
      defaultMessage: [{
        "type": 0,
        "value": "closed box"
      }]
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute left-1/2 grid -translate-x-1/2 grid-cols-3 gap-3 bottom-16')
  }, selectedItems.length ? selectedItems.map((item, index) => {
    const Icon = buildHtml(item.donationIcon?.svgSource || '');
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: 'flex h-10 w-10 items-center justify-center rounded-tl-lg bg-white shadow-lg md:h-14 md:w-14'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'mx-auto h-6 w-6 md:h-10 md:w-10'
    }, Icon ? /*#__PURE__*/React.createElement(Icon, null) : null));
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: 'prose mt-14 text-center md:prose-xl'
  }, /*#__PURE__*/React.createElement("h2", {
    className: '!leading-normal lg:!leading-snug !text-xl lg:!text-2xl'
  }, labelBoxContentValue), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("small", {
    className: 'text-base'
  }, "CHF"), " ", totalAmount))) : null, /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto max-w-4xl donation-box'
  }, /*#__PURE__*/React.createElement(DonationForm, Object.assign(donationForm, {
    amount: totalAmount,
    boxItems: selectedItems
  }))))), customItemOption ? /*#__PURE__*/React.createElement(Dialog, {
    className: 'fixed top-0 left-0 z-[99999] flex h-screen w-screen items-center justify-center bg-white/95',
    open: ModalIsOpen,
    onClose: () => setModalIsOpen(false)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-xl md:prose-xl'
  }, /*#__PURE__*/React.createElement(Dialog.Title, {
    className: 'text-center'
  }, labelCustomAmountDescription), /*#__PURE__*/React.createElement("div", {
    className: '!my-16 flex items-end justify-center'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'font-bold'
  }, intl.formatMessage({
    id: "hCU9Bm",
    defaultMessage: [{
      "type": 0,
      "value": "CHF"
    }]
  })), /*#__PURE__*/React.createElement("input", {
    type: 'number',
    onChange: e => setInputValue(parseInt(e.target.value)),
    className: 'focus ml-5 w-24 border-0 border-b-4 border-dashed border-grey-600 bg-transparent p-0 text-center text-3xl font-bold focus:border-grey-600 focus:outline-none focus:ring-0'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto max-w-md'
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('focus flex h-16 w-full items-center justify-center rounded-tl-xl px-6 font-condensed uppercase text-white transition', {
      'bg-red-500 hover:bg-red-600': inputValue > 0 && inputValue,
      'bg-grey-200': inputValue < 1 || !inputValue
    }),
    disabled: inputValue < 1 || !inputValue,
    onClick: () => {
      const donationItem = {
        donationIcon: customItemOption.donationIcon,
        amount: inputValue,
        donationPurposeLabel: donationForm.donationPurposeLabel,
        donationPurposeId: donationForm.nodeId
      };
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, donationItem]);
      pushDonationBoxAddItem(donationItem);
      setModalIsOpen(false);
    }
  }, labelCustomAmountButton)), /*#__PURE__*/React.createElement("button", {
    className: 'focus absolute right-5 top-5 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 transition hover:bg-blue-500 hover:text-white md:right-10 md:top-10',
    onClick: () => {
      setModalIsOpen(false);
      setInputValue(0);
    }
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-8 w-8'
  })))))) : null);
}
function DonationBadge({
  amount,
  donationIcon,
  active = false
}) {
  const intl = useIntl();
  const Icon = buildHtml(donationIcon?.svgSource || '');
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('w-full h-full rounded-tl-xl px-2 pt-8 pb-10 text-center shadow-lg transition relative', {
      'bg-blue-100 hover:bg-blue-200': !active,
      'bg-green-300 ': active
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mx-auto h-16 w-16'
  }, Icon ? /*#__PURE__*/React.createElement(Icon, null) : null), /*#__PURE__*/React.createElement("span", {
    className: 'mt-4 mb-3 block text-base'
  }, donationIcon?.label), /*#__PURE__*/React.createElement("span", {
    className: 'block text-xl font-bold after:absolute after:bottom-5 after:left-1/2 after:h-1 after:w-6 after:-translate-x-1/2 after:rounded-md after:bg-red-500 after:content-[""]'
  }, amount > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("small", {
    className: 'text-sm'
  }, "CHF"), " ", amount) : intl.formatMessage({
    id: "Oo+0sJ",
    defaultMessage: [{
      "type": 0,
      "value": "..."
    }]
  })));
}
const allowanceSvgSource = `<svg
version="1.1"
xmlns="http://www.w3.org/2000/svg"
x="0px"
y="0px"
viewBox="0 0 24 24"
enableBackground="new 0 0 24 24"
xmlSpace="preserve"
>
<g id="Outline_Icons">
  <g>
    <ellipse
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      cx="8"
      cy="2.5"
      rx="7.5"
      ry="2"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M15.5,2.5v3
c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M15.5,5.5v3
c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
    />

    <ellipse
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      cx="16"
      cy="15.5"
      rx="7.5"
      ry="2"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M23.5,15.5v3
c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M23.5,18.5v3
c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M15.5,8.5v3
c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M0.5,11.5v3
c0,1.105,3.358,2,7.5,2h0.5"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M0.5,14.5v3
c0,1.105,3.358,2,7.5,2h0.5"
    />

    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      x1="15.5"
      y1="11.5"
      x2="15.5"
      y2="13.5"
    />
  </g>
</g>
<g id="Invisible_Shape">
  <rect fill="none" width="24" height="24" />
</g>
</svg>`;

function BackButton({
  backButton,
  className
}) {
  const intl = useIntl();
  const showBack = useStore(backButton, state => state.show_back_button);
  if (showBack) {
    return /*#__PURE__*/React.createElement("button", {
      className: clsx(className, 'fixed bg-black hover:bg-black/90 rounded-tl-xl focus cursor-pointer overflow-hidden text-white text-[15px] md:text-base md: !leading-snug uppercase text-center font-condensed py-5 px-7 whitespace-nowrap'),
      onClick: () => {
        history.back();
      }
    }, intl.formatMessage({
      id: "cyR7Kh",
      defaultMessage: [{
        "type": 0,
        "value": "Back"
      }]
    }));
  }
  return null;
}

const locales = {
  de: {
    code: 'de',
    flag: '🇩🇪',
    name: 'Deutsch',
    dateLocale: de
  },
  fr: {
    code: 'fr',
    flag: '🇫🇷',
    name: 'Français',
    dateLocale: fr
  },
  it: {
    code: 'it',
    flag: '🇮🇹',
    name: 'Italiano',
    dateLocale: it
  },
  en: {
    code: 'en',
    flag: '🇬🇧',
    name: 'English',
    dateLocale: en
  },
  es: {
    code: 'es',
    flag: '🇪🇸',
    name: 'Spanish',
    dateLocale: en
  },
  'pt-pt': {
    code: 'pt',
    flag: '🇵🇹',
    name: 'Portuguese',
    dateLocale: en
  }
};

function isHomeLink(link) {
  try {
    const url = link.startsWith('/') ? new URL(link, 'http://www.example.com') : new URL(link);
    return /^\/[a-z-]*$/.test(url.pathname.replace(/^https?:\/\/[^/]+/, ''));
  } catch (error) {
    return /^\/[a-z-]*$/.test(link.replace(/^https?:\/\/[^/]+/, ''));
  }
}

function Collapsible({
  children,
  show,
  fadeDuration,
  scaleDuration,
  delay,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      transitionProperty: 'opacity',
      transitionDuration: `${fadeDuration}ms`,
      transitionDelay: show ? `${scaleDuration + delay}ms` : `${delay}ms`,
      opacity: show ? 1 : 0
    }
  }, /*#__PURE__*/React.createElement(HeightTransition, _extends({
    show: show,
    duration: scaleDuration / 1000,
    delayEnter: !show ? (fadeDuration + delay) / 1000 : delay / 1000
  }, rest), children));
}

function HeaderDesktop$3({
  HomeLink
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-0 left-0'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'logo focus absolute z-[1010] left-0 w-[270px] h-[100px] bg-white flex items-center justify-center rounded-bl-xl'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'h-7',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }))));
}
function MicrositeHeader({
  HomeLink,
  backButton
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement(HeaderDesktop$3, {
    HomeLink: HomeLink
  })), /*#__PURE__*/React.createElement("div", {
    className: " fixed bottom-0 z-[3000] right-0 md:top-0 h-fit md:sticky"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative container-content"
  }, /*#__PURE__*/React.createElement(BackButton, {
    backButton: backButton,
    className: "absolute bottom-[1.875rem] md:bottom-auto md:top-[1.875rem] right-0 "
  })))));
}

function UserLinksDesktop({
  userStore,
  LoginLink,
  ProfileLink
}) {
  const userId = useStore(userStore, state => state.uid);
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, userId === 0 && LoginLink && /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline font-light leading-none tracking-[0.55px] xl:my-0 xl:text-sm"
  }, /*#__PURE__*/React.createElement(LoginLink, {
    className: "focus flex items-center gap-x-3 transition hover:text-red-500"
  }, /*#__PURE__*/React.createElement(IconUser, {
    className: 'h-[17px] w-[17px]'
  }), intl.formatMessage({
    id: "AyGauy",
    defaultMessage: [{
      "type": 0,
      "value": "Login"
    }]
  }))), userId > 0 && ProfileLink && /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline font-light leading-none tracking-[0.55px] xl:my-0 xl:text-sm"
  }, /*#__PURE__*/React.createElement(ProfileLink, {
    className: "focus flex items-center gap-x-3 transition hover:text-red-500"
  }, /*#__PURE__*/React.createElement(IconUser, {
    className: 'h-[17px] w-[17px]'
  }), intl.formatMessage({
    id: "BEX6A7",
    defaultMessage: [{
      "type": 0,
      "value": "My profile"
    }]
  }))));
}
function HeaderDesktop$2({
  HomeLink,
  metaMenuItems,
  localizations,
  mainMenuItems,
  SearchLink,
  DonationLink,
  countryProgram,
  currentUser,
  LoginLink,
  ProfileLink,
  currentPath
}) {
  const intl = useIntl();
  const sticky = useShowStickyHeader$1();
  const activeTheme = useActiveTheme();
  const showCountryProgram = useTheme({
    caritas: true,
    youngcaritas: false,
    caritascare: false,
    bergeinsatz: false
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'hidden xl:block'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'fixed top-0 left-0 z-50 w-full bg-grey-100 text-sm'
  }, /*#__PURE__*/React.createElement(ScrollIndicator$1, null), /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement(JumpToTopButton$1, {
    showButton: sticky
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute right-0 top-0 flex items-center justify-end gap-10')
  }, /*#__PURE__*/React.createElement(Transition, {
    show: !sticky,
    className: 'flex items-center gap-10',
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(HeaderMetaMenu, {
    metaMenuItems: metaMenuItems
  }), /*#__PURE__*/React.createElement(LanguageSwitcher, {
    localizations: localizations
  }), showCountryProgram && /*#__PURE__*/React.createElement(CountryProgram, countryProgram), /*#__PURE__*/React.createElement(UserLinksDesktop, {
    userStore: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  })), /*#__PURE__*/React.createElement(DonationLink, {
    className: 'tracking-header-sticky focus flex items-center gap-2 rounded-tl-lg bg-red-500 px-16 py-2.5 font-condensed uppercase text-white transition hover:bg-red-600 lg:text-[15px]',
    activeClassName: 'bg-red-600'
  }, activeTheme === 'caritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 -mr-5'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/heart_white.json',
    autoplay: true,
    loop: true,
    className: 'absolute w-10 h-10 inset-0 -translate-x-1/2 -translate-y-1/2'
  })), intl.formatMessage({
    id: "2IFGap",
    defaultMessage: [{
      "type": 0,
      "value": "Donate"
    }]
  })), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 -mr-5 yc-people-animation'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/people_animation_red_bg.json',
    autoplay: true,
    loop: true,
    className: 'absolute w-10 h-10 inset-0 -translate-x-1/2 -translate-y-1/2'
  })), intl.formatMessage({
    id: "U8u4uF",
    defaultMessage: [{
      "type": 0,
      "value": "Get involved"
    }]
  })), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-7 -mr-3'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/question_white.json',
    autoplay: true,
    loop: true,
    className: 'absolute w-10 h-10 inset-0 -translate-x-1/2 -translate-y-1/2'
  })), intl.formatMessage({
    id: "l0cx8s",
    defaultMessage: [{
      "type": 0,
      "value": "Consultation"
    }]
  })), activeTheme === 'bergeinsatz' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-6 -mr-1'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/mountain_white.json',
    autoplay: true,
    loop: true,
    className: 'absolute w-10 h-10 inset-0 -translate-x-1/2 -translate-y-1/2'
  })), intl.formatMessage({
    id: "pZr+P4",
    defaultMessage: [{
      "type": 0,
      "value": "Find mission"
    }]
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-[40px] pt-8'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content flex items-start justify-between'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'logo focus'
  }, ['caritas', 'bergeinsatz'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-8 2xl:h-9',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-9',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-9',
    src: '/youngcaritas_logo.svg',
    alt: intl.formatMessage({
      id: "OYLWAB",
      defaultMessage: [{
        "type": 0,
        "value": "Young Caritas"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: 'ml-4 flex items-start justify-end xl:ml-5 2xl:ml-8'
  }, /*#__PURE__*/React.createElement(MainNavigation, {
    mainMenuItems: mainMenuItems,
    currentPath: currentPath
  }), SearchLink ? /*#__PURE__*/React.createElement(SearchLink, {
    className: 'focus group border-b-2 border-transparent pb-[22px]',
    activeClassName: 'border-red-500 text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-block p-1.5 transition-shadow group-hover:shadow-[inset_0_-36px_0_0_rgba(219,0,27,0.15)]'
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: 'relative top-px h-[18px] w-[18px]  2xl:h-[22px] 2xl:w-[22px]'
  }), /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, intl.formatMessage({
    id: "xmcVZ0",
    defaultMessage: [{
      "type": 0,
      "value": "Search"
    }]
  })))) : null)))));
}
function HeaderMetaMenu({
  metaMenuItems
}) {
  return /*#__PURE__*/React.createElement("ul", {
    className: 'flex items-center gap-6 text-sm font-light'
  }, metaMenuItems.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'focus border-b-2 border-transparent pb-[11px] tracking-[0.55px] transition hover:text-red-500',
    activeClassName: 'border-red-500 text-red-500'
  }, title))));
}
function LanguageSwitcher({
  localizations
}) {
  const {
    locale
  } = useIntl();
  const separator = '|';
  const isHomepage = Object.values(localizations).map(loc => loc.href).filter(isHomeLink).length === Object.values(localizations).length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(localizations).length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline font-light uppercase leading-none tracking-[0.15px] xl:my-0 xl:text-sm"
  }, Object.keys(localizations).map((code, index) => {
    const Link = localizations[code];
    const name = locales[code].name;
    const isHome = isHomeLink(Link.href);
    const label = locales[code].code;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: code
    }, locale === code ? /*#__PURE__*/React.createElement("div", {
      className: clsx('mx-2.5', {
        'font-bold': locale === code
      }),
      key: index
    }, /*#__PURE__*/React.createElement("span", {
      title: name
    }, label.toUpperCase())) : /*#__PURE__*/React.createElement(Link, {
      key: index,
      className: clsx('focus mx-2.5 transition first:ml-0 hover:text-red-500 xl:first:ml-2.5', {
        'text-grey-500': !isHomepage && isHome
      })
    }, /*#__PURE__*/React.createElement("span", {
      title: name
    }, label.toUpperCase())), index < Object.keys(localizations).length - 1 && /*#__PURE__*/React.createElement("div", {
      className: 'text-grey-500'
    }, separator));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null));
}
function ScrollIndicator$1() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(0);
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    function handleUpdate() {
      setWidth(window.document.body.offsetWidth);
      setHeight(window.innerHeight);
      setFullHeight(window.document.body.offsetHeight);
      setScroll(window.scrollY);
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    window.addEventListener('resize', handleUpdate);
    return () => {
      window.removeEventListener('scroll', handleUpdate);
      window.removeEventListener('resize', handleUpdate);
    };
  }, [setWidth, setHeight, setScroll]);
  const percentage = fullHeight - height > 0 ? scroll / (fullHeight - height) * width : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-0.5 w-full bg-transparent delay-500 duration-500 xl:bg-grey-100')
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percentage
    },
    className: clsx('h-full bg-red-500')
  }));
}
function useShowStickyHeader$1() {
  const [show, setShow] = useState(false);
  // height difference between Header wide and Header shrink
  const heightDifference = 0;
  const limit = 50;
  useEffect(() => {
    function handleUpdate() {
      if (show && window.scrollY < limit) {
        setShow(false);
      }
      if (!show && window.scrollY > limit + heightDifference) {
        setShow(true);
      }
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    return () => window.removeEventListener('scroll', handleUpdate);
  }, [show, setShow]);
  return show;
}
const JumpToTopButton$1 = ({
  showButton
}) => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setTimeout(() => {
      document.querySelectorAll('.logo')[0]?.focus();
    }, 1500);
  };
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('text-black duration-300', {
      'invisible opacity-0': !showButton
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    className: 'focus group flex items-center gap-2 p-2.5 pl-0 transition hover:text-red-500',
    "aria-label": intl.formatMessage({
      id: "lIJKZh",
      defaultMessage: [{
        "type": 0,
        "value": "Scroll to top"
      }]
    }),
    "aria-hidden": "true",
    tabIndex: -1
  }, intl.formatMessage({
    id: "Gs9Kfp",
    defaultMessage: [{
      "type": 0,
      "value": "Back to top"
    }]
  }), /*#__PURE__*/React.createElement(ArrowNarrowUpIcon, {
    className: 'h-4 w-4'
  })));
};
function MainNavigation({
  mainMenuItems,
  currentPath
}) {
  const intl = useIntl();
  const rootButtonClasses = clsx('pt-1 pb-7 inline-flex border-transparent border-b-2 duration-300 group font-condensed uppercase 2xl:text-[1.025rem] tracking-wider text-[0.90rem] focus transition-shadow');
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": intl.formatMessage({
      id: "CFS8/C",
      defaultMessage: [{
        "type": 0,
        "value": "Main navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: clsx('flex items-center text-lg')
  }, mainMenuItems.map(({
    title,
    Link,
    children,
    childrenPaths
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "relative inline-block pr-4 xl:pr-6 2xl:pr-8"
  }, !children ? /*#__PURE__*/React.createElement(Link, {
    className: rootButtonClasses,
    activeClassName: 'border-red-500 text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex flex-wrap items-center justify-center pt-1 text-center leading-tight transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, title)) : /*#__PURE__*/React.createElement(Popover, {
    className: "relative"
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover.Button, {
    className: clsx(rootButtonClasses, {
      'text-red-500': open,
      'border-red-500 text-red-500': childrenPaths && childrenPaths.includes(currentPath) || currentPath === Link.href
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex flex-wrap items-center justify-between pt-1 text-center leading-tight transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, title)), /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "duration-75 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    tabIndex: -1,
    className: clsx('absolute top-14 z-10 w-[318px] rounded-b-md bg-white py-5 drop-shadow-xl', {
      'left-0': mainMenuItems.length !== index + 1
    }, {
      'right-0': mainMenuItems.length === index + 1
    })
  }, /*#__PURE__*/React.createElement(SlidingNavigationMenu, {
    items: children,
    fadeDuration: 300,
    scaleDuration: 300,
    parent: {
      title,
      Link
    }
  })))))))));
}
function SlidingNavigationMenu({
  items,
  parent,
  grandParent,
  className,
  ...rest
}) {
  const intl = useIntl();
  const menuItemClasses = 'lg:px-8 font-light';
  return /*#__PURE__*/React.createElement(MenuTreeWrapper, null, /*#__PURE__*/React.createElement("ul", {
    className: clsx('text-base font-normal', className)
  }, grandParent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus group w-full max-w-full items-center py-3 text-left', menuItemClasses)
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex items-center justify-between px-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-25px_0_0_rgba(219,0,27,0.15)]'
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: 'mr-3 h-4 w-4'
  }), grandParent ? grandParent.title : intl.formatMessage({
    id: "CFS8/C",
    defaultMessage: [{
      "type": 0,
      "value": "Main navigation"
    }]
  }))))) : null, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(parent.Link, {
    className: clsx('focus group block w-full max-w-full items-center py-2 font-bold transition-shadow last:border-0', menuItemClasses),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex items-start justify-between px-1 pt-1.5 font-bold transition-shadow duration-300 group-hover:shadow-[inset_0_-28px_0_0_rgba(219,0,27,0.15)]'
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'mr-3 mt-0.5 h-4 w-4'
  }), parent.title)))) : null, items.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, currentItem.children ? /*#__PURE__*/React.createElement(Disclosure, null, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus group w-full max-w-full py-3 text-left transition', menuItemClasses)
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex items-center justify-between px-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-25px_0_0_rgba(219,0,27,0.15)]'
  }, currentItem.title, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'ml-3 h-4 w-4'
  })))), /*#__PURE__*/React.createElement(SubmenuTransition, _extends({
    show: open
  }, rest), /*#__PURE__*/React.createElement(Disclosure.Panel, null, /*#__PURE__*/React.createElement(SlidingNavigationMenu, _extends({}, rest, {
    items: currentItem.children || [],
    parent: currentItem,
    grandParent: parent
  })))))) : /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('focus group block w-full max-w-full py-3', menuItemClasses),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('inline-flex items-center justify-between px-1 transition-shadow duration-300', {
      'group-hover:shadow-[inset_0_-25px_0_0_rgba(219,0,27,0.15)]': currentItem.title.length < 35
    }, {
      'group-hover:shadow-[inset_0_-50px_0_0_rgba(219,0,27,0.15)]': currentItem.title.length >= 35
    })
  }, currentItem.title)))))));
}
function MenuItemTransition({
  children,
  fadeDuration,
  scaleDuration
}) {
  const {
    expanded
  } = useContext(MenuTreeContext);
  return /*#__PURE__*/React.createElement(Collapsible, {
    show: !expanded,
    delay: !expanded ? fadeDuration : 0,
    fadeDuration: fadeDuration,
    scaleDuration: scaleDuration
  }, children);
}
function SubmenuTransition({
  children,
  show,
  fadeDuration,
  scaleDuration
}) {
  const {
    setExpanded
  } = useContext(MenuTreeContext);
  return /*#__PURE__*/React.createElement(Collapsible, {
    show: show,
    delay: !show ? 0 : fadeDuration,
    fadeDuration: fadeDuration,
    scaleDuration: scaleDuration,
    beforeEnter: () => {
      setExpanded(true);
    },
    beforeLeave: () => {
      setExpanded(false);
    }
  }, children);
}
const MenuTreeContext = /*#__PURE__*/React.createContext({
  expanded: false,
  setExpanded: () => undefined
});
function MenuTreeWrapper({
  children
}) {
  const [expanded, setExpanded] = useState(false);
  return /*#__PURE__*/React.createElement(MenuTreeContext.Provider, {
    value: {
      expanded,
      setExpanded
    }
  }, children);
}
function HeaderMobile({
  HomeLink,
  mainMenuItems,
  metaMenuItems,
  localizations,
  SearchLink,
  DonationLink,
  countryProgram,
  currentUser,
  LoginLink,
  ProfileLink
}) {
  const intl = useIntl();
  const activeTheme = useActiveTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: 'xl:hidden'
  }, /*#__PURE__*/React.createElement(ScrollIndicator$1, null), /*#__PURE__*/React.createElement(Popover, null, /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "duration-75 ease-out",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Popover.Panel, {
    tabIndex: -1,
    className: "fixed inset-0 z-10 overflow-y-auto bg-white"
  }, /*#__PURE__*/React.createElement(BodyClassName, {
    className: 'h-screen overflow-hidden'
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('container-page mb-5 border-b-2 border-red-500 bg-white')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content flex items-center justify-between'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'focus'
  }, ['caritas', 'bergeinsatz'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/youngcaritas_logo.svg',
    alt: intl.formatMessage({
      id: "OYLWAB",
      defaultMessage: [{
        "type": 0,
        "value": "Young Caritas"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center'
  }, /*#__PURE__*/React.createElement(DonationLink, {
    className: 'tracking-header-sticky focus mx-4 rounded-tl-lg bg-red-500 py-2.5 px-1.5 text-center font-condensed text-xs uppercase text-white hover:bg-red-600 md:mr-7 md:py-4 md:px-3',
    activeClassName: 'bg-red-600'
  }, activeTheme === 'caritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 mb-3 -mt-2 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/heart_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "2IFGap",
    defaultMessage: [{
      "type": 0,
      "value": "Donate"
    }]
  })), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-7 mb-2 -mt-2 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/question_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "l0cx8s",
    defaultMessage: [{
      "type": 0,
      "value": "Consultation"
    }]
  })), activeTheme === 'bergeinsatz' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-6 mb-1 -mt-1 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/mountain_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "pZr+P4",
    defaultMessage: [{
      "type": 0,
      "value": "Find mission"
    }]
  })), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 mb-3 -mt-2 h-5 mx-auto yc-people-animation'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/people_animation_red_bg.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "U8u4uF",
    defaultMessage: [{
      "type": 0,
      "value": "Get involved"
    }]
  }))), /*#__PURE__*/React.createElement(Popover.Button, {
    "aria-label": intl.formatMessage({
      id: "ElXe9Q",
      defaultMessage: [{
        "type": 0,
        "value": "Hide mobile navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: 'h-8 w-8'
  }))))), /*#__PURE__*/React.createElement("div", {
    className: 'px-4'
  }, /*#__PURE__*/React.createElement(MobileNavigation, {
    mainMenuItems: mainMenuItems,
    metaMenuItems: metaMenuItems,
    SearchLink: SearchLink,
    localizations: localizations,
    countryProgram: countryProgram,
    currentUser: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content container-content flex items-center justify-between'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'focus'
  }, ['caritas', 'bergeinsatz'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("img", {
    className: 'h-8',
    src: '/youngcaritas_logo.svg',
    alt: intl.formatMessage({
      id: "OYLWAB",
      defaultMessage: [{
        "type": 0,
        "value": "Young Caritas"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center xl:hidden'
  }, /*#__PURE__*/React.createElement(DonationLink, {
    className: 'tracking-header-sticky focus mx-4 rounded-tl-lg bg-red-500 py-2.5 px-1.5 text-center font-condensed text-xs uppercase text-white hover:bg-red-600 md:mr-7 md:py-4 md:px-3',
    activeClassName: 'bg-red-600'
  }, activeTheme === 'caritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 mb-3 -mt-2 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/heart_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "2IFGap",
    defaultMessage: [{
      "type": 0,
      "value": "Donate"
    }]
  })), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-7 mb-2 -mt-2 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/question_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "l0cx8s",
    defaultMessage: [{
      "type": 0,
      "value": "Consultation"
    }]
  })), activeTheme === 'bergeinsatz' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-6 mb-1 -mt-1 h-5 mx-auto'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/mountain_white.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "pZr+P4",
    defaultMessage: [{
      "type": 0,
      "value": "Find mission"
    }]
  })), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'w-9 mb-3 -mt-2 h-5 mx-auto yc-people-animation'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    animationDataUrl: '/lottie/people_animation_red_bg.json',
    autoplay: true,
    loop: true
  })), intl.formatMessage({
    id: "U8u4uF",
    defaultMessage: [{
      "type": 0,
      "value": "Get involved"
    }]
  }))), /*#__PURE__*/React.createElement(Popover.Button, {
    "aria-label": intl.formatMessage({
      id: "5DT7Ca",
      defaultMessage: [{
        "type": 0,
        "value": "Show mobile navigation"
      }]
    })
  }, /*#__PURE__*/React.createElement(MenuAlt1Icon, {
    className: "h-8 w-8"
  }))))))));
}
function MobileNavigation({
  mainMenuItems,
  metaMenuItems,
  SearchLink,
  localizations,
  countryProgram,
  currentUser,
  LoginLink,
  ProfileLink
}) {
  return /*#__PURE__*/React.createElement(MobileSlidingNavigationMenu, {
    scaleDuration: 100,
    fadeDuration: 200,
    className: 'mt-5',
    items: mainMenuItems,
    itemsSecondary: metaMenuItems,
    SearchLink: SearchLink,
    localizations: localizations,
    countryProgram: countryProgram,
    currentUser: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  });
}
function MobileSlidingNavigationMenu({
  items,
  itemsSecondary,
  parent,
  className,
  grandParent,
  SearchLink,
  localizations,
  countryProgram,
  currentUser,
  LoginLink,
  ProfileLink,
  ...rest
}) {
  const intl = useIntl();
  const [currentPath, setCurrentPath] = useState('');
  const showCountryProgram = useTheme({
    caritas: true,
    youngcaritas: false,
    caritascare: false,
    bergeinsatz: false
  });
  useEffect(() => {
    setCurrentPath(window.location.pathname);
  });
  return /*#__PURE__*/React.createElement(MenuTreeWrapper, null, /*#__PURE__*/React.createElement("ul", {
    className: clsx('mobile-nav text-base font-normal', className)
  }, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus group w-full max-w-full py-3 text-left text-grey-500')
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex items-center pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, /*#__PURE__*/React.createElement(MobileArrow, {
    className: 'mr-3 h-5 w-5 rotate-180'
  }), grandParent ? grandParent.title : intl.formatMessage({
    id: "CFS8/C",
    defaultMessage: [{
      "type": 0,
      "value": "Main navigation"
    }]
  }))))) : null, parent ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(parent.Link, {
    className: clsx('focus group block w-full max-w-full py-3 font-condensed uppercase tracking-wider last:border-0'),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, parent.title)))) : null, items.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, currentItem.children ? /*#__PURE__*/React.createElement(Disclosure, null, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: clsx('focus group w-full py-3 text-left font-condensed uppercase tracking-wider', {
      'border-red-500 text-red-500': currentItem.childrenPaths && currentItem.childrenPaths.includes(currentPath) || currentPath === currentItem.Link.href
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: 'flex w-full max-w-full items-center justify-between pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, currentItem.title, /*#__PURE__*/React.createElement(MobileArrow, {
    className: 'h-5 w-5'
  })))), /*#__PURE__*/React.createElement(SubmenuTransition, _extends({
    show: open
  }, rest), /*#__PURE__*/React.createElement(Disclosure.Panel, null, /*#__PURE__*/React.createElement(MobileSlidingNavigationMenu, _extends({}, rest, {
    currentUser: currentUser,
    items: currentItem.children || [],
    parent: currentItem,
    grandParent: parent,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink,
    className: 'not-first-level'
  })))))) : /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('focus group block w-full max-w-full py-3 '),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, currentItem.title))))), itemsSecondary ? itemsSecondary.map((currentItem, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: clsx('mobile-meta-menu py-3 font-light', {
      'pt-5': index === 0
    })
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, index === 0 ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-7 border-t border-grey-500'
  }) : null, /*#__PURE__*/React.createElement(currentItem.Link, {
    className: clsx('focus group block w-full max-w-full'),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, currentItem.title))))) : null, SearchLink ? /*#__PURE__*/React.createElement("li", {
    className: 'mobile-meta-menu py-3 font-light'
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(SearchLink, {
    className: clsx('focus  group w-full max-w-full'),
    activeClassName: 'text-red-500'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'inline-flex items-center gap-3 pt-1 transition-shadow duration-300 group-hover:shadow-[inset_0_-29px_0_0_rgba(219,0,27,0.15)]'
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    className: 'h-4 w-4'
  }), intl.formatMessage({
    id: "xmcVZ0",
    defaultMessage: [{
      "type": 0,
      "value": "Search"
    }]
  }))))) : null, countryProgram && showCountryProgram ? /*#__PURE__*/React.createElement("li", {
    className: 'mobile-meta-menu py-3'
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(CountryProgram, countryProgram))) : null, /*#__PURE__*/React.createElement(UserLinksMobile, _extends({
    userStore: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  }, rest)), localizations ? /*#__PURE__*/React.createElement("li", {
    className: 'mobile-meta-menu mt-5 py-3'
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    localizations: localizations
  }))) : null));
}
function UserLinksMobile({
  userStore,
  LoginLink,
  ProfileLink,
  ...rest
}) {
  const userId = useStore(userStore, state => state.uid);
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, userId === 0 && LoginLink ? /*#__PURE__*/React.createElement("li", {
    className: "mobile-meta-menu py-3 font-light"
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(LoginLink, {
    className: "focus inline-flex items-center gap-x-3 transition hover:shadow-[inset_0_-36px_0_0_rgba(219,0,27,0.15)]"
  }, /*#__PURE__*/React.createElement(IconUser, {
    className: 'h-[18px] w-[18px]'
  }), intl.formatMessage({
    id: "AyGauy",
    defaultMessage: [{
      "type": 0,
      "value": "Login"
    }]
  })))) : null, userId > 0 && ProfileLink ? /*#__PURE__*/React.createElement("li", {
    className: "mobile-meta-menu py-3 font-light"
  }, /*#__PURE__*/React.createElement(MenuItemTransition, rest, /*#__PURE__*/React.createElement(ProfileLink, {
    className: "focus inline-flex items-center gap-x-3 transition hover:shadow-[inset_0_-36px_0_0_rgba(219,0,27,0.15)]"
  }, /*#__PURE__*/React.createElement(IconUser, {
    className: 'h-[18px] w-[18px]'
  }), intl.formatMessage({
    id: "BEX6A7",
    defaultMessage: [{
      "type": 0,
      "value": "My profile"
    }]
  })))) : null);
}
function MobileArrow({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "19.606",
    height: "10.122",
    viewBox: "0 0 19.606 10.122",
    fill: 'currentColor'
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_91",
    d: "M-2871.771,12695.878a.8.8,0,0,1,0-1.177l3.175-2.987h-15.518a.862.862,0,0,1-.888-.834.858.858,0,0,1,.888-.83h15.137l-2.795-2.628a.8.8,0,0,1,0-1.177.926.926,0,0,1,1.252,0l5.124,4.815-5.124,4.817a.908.908,0,0,1-.626.245A.906.906,0,0,1-2871.771,12695.878Zm-12.342-.115a.862.862,0,0,1-.888-.835.859.859,0,0,1,.888-.831h6.319a.858.858,0,0,1,.884.831.861.861,0,0,1-.884.835Zm0-8.1a.862.862,0,0,1-.888-.835.859.859,0,0,1,.888-.831h7.794a.861.861,0,0,1,.888.831.864.864,0,0,1-.888.835Z",
    transform: "translate(2885 -12686.001)"
  }));
}
function CountryProgram({
  Link,
  ariaLabel,
  linkTitle
}) {
  return /*#__PURE__*/React.createElement(Link, {
    className: 'focus inline-flex items-center py-1.5 transition hover:shadow-[inset_0_-36px_0_0_rgba(219,0,27,0.15)] lg:hover:text-red-500 lg:hover:shadow-none',
    "aria-label": ariaLabel,
    activeClassName: 'text-red-500 lg:border-b-2 lg:border-red-500 lg:py-[9px]'
  }, /*#__PURE__*/React.createElement(GlobeAltIcon, {
    strokeWidth: 1,
    className: 'h-5 w-5'
  }), /*#__PURE__*/React.createElement("span", {
    className: 'pl-2 font-light lg:sr-only'
  }, linkTitle));
}
function IconUser({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    id: "User_Smal_Circle",
    "data-name": "User Smal Circle",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: "3",
    cy: "3",
    r: "3",
    transform: "translate(9 5.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M12,13.5a11.52,11.52,0,0,0-5.14,1.37A2.51,2.51,0,0,0,5.5,17.11v.46a.93.93,0,0,0,.93.94H17.57a.93.93,0,0,0,.93-.94v-.46a2.51,2.51,0,0,0-1.36-2.23A11.52,11.52,0,0,0,12,13.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_Path_3",
    "data-name": "<Path>",
    cx: "11.5",
    cy: "11.5",
    r: "11.5",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1"
  })));
}
function Header({
  metaMenuItems,
  HomeLink,
  localizations,
  mainMenuItems,
  SearchLink,
  DonationLink,
  countryProgram,
  currentUser,
  LoginLink,
  ProfileLink,
  currentPath,
  microsite,
  backButton
}) {
  if (microsite) {
    return /*#__PURE__*/React.createElement(MicrositeHeader, {
      HomeLink: HomeLink,
      backButton: backButton
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: 'sticky top-0 z-[99999] bg-white xl:static'
  }, /*#__PURE__*/React.createElement(HeaderDesktop$2, {
    currentPath: currentPath,
    HomeLink: HomeLink,
    metaMenuItems: metaMenuItems,
    localizations: localizations,
    mainMenuItems: mainMenuItems,
    SearchLink: SearchLink,
    DonationLink: DonationLink,
    countryProgram: countryProgram,
    currentUser: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  }), /*#__PURE__*/React.createElement(HeaderMobile, {
    localizations: localizations,
    HomeLink: HomeLink,
    metaMenuItems: metaMenuItems,
    mainMenuItems: mainMenuItems,
    SearchLink: SearchLink,
    DonationLink: DonationLink,
    countryProgram: countryProgram,
    currentUser: currentUser,
    LoginLink: LoginLink,
    ProfileLink: ProfileLink
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lg:absolute fixed bottom-0 right-0 z-[2909] container-page lg:!px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "maxLg:absolute"
  }, /*#__PURE__*/React.createElement(BackButton, {
    backButton: backButton,
    className: "maxLg:bottom-[1.875rem] maxLg:absolute maxLg:right-0 lg:translate-x-[-100%]"
  }))))));
}

function HeaderDesktop$1({
  HomeLink,
  localizations
}) {
  const intl = useIntl();
  const sticky = useShowStickyHeader();
  const activeTheme = useActiveTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: 'block'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'fixed top-0 left-0 z-50 w-full bg-grey-100 text-sm'
  }, /*#__PURE__*/React.createElement(ScrollIndicator, null), /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content flex items-center justify-between'
  }, /*#__PURE__*/React.createElement(JumpToTopButton, {
    showButton: sticky
  }), /*#__PURE__*/React.createElement(Transition, {
    show: !sticky,
    className: 'flex items-center gap-10',
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    localizations: localizations
  }))))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-[40px] pt-8'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content flex items-start justify-between'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'logo focus'
  }, ['caritas', 'bergeinsatz'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-8 2xl:h-9',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-9',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("img", {
    className: 'h-7 xl:h-9',
    src: '/youngcaritas_logo.svg',
    alt: intl.formatMessage({
      id: "OYLWAB",
      defaultMessage: [{
        "type": 0,
        "value": "Young Caritas"
      }]
    })
  }))))));
}
function ScrollIndicator() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(0);
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    function handleUpdate() {
      setWidth(window.document.body.offsetWidth);
      setHeight(window.innerHeight);
      setFullHeight(window.document.body.offsetHeight);
      setScroll(window.scrollY);
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    window.addEventListener('resize', handleUpdate);
    return () => {
      window.removeEventListener('scroll', handleUpdate);
      window.removeEventListener('resize', handleUpdate);
    };
  }, [setWidth, setHeight, setScroll]);
  const percentage = fullHeight - height > 0 ? scroll / (fullHeight - height) * width : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute bottom-0 left-0 h-0.5 w-full bg-transparent delay-500 duration-500 lg:bg-grey-100')
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percentage
    },
    className: clsx('h-full bg-red-500')
  }));
}
function useShowStickyHeader() {
  const [show, setShow] = useState(false);
  // height difference between Header wide and Header shrink
  const heightDifference = 0;
  const limit = 50;
  useEffect(() => {
    function handleUpdate() {
      if (show && window.scrollY < limit) {
        setShow(false);
      }
      if (!show && window.scrollY > limit + heightDifference) {
        setShow(true);
      }
    }
    handleUpdate();
    window.addEventListener('scroll', handleUpdate);
    return () => window.removeEventListener('scroll', handleUpdate);
  }, [show, setShow]);
  return show;
}
const JumpToTopButton = ({
  showButton
}) => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setTimeout(() => {
      document.querySelectorAll('.logo')[0]?.focus();
    }, 1500);
  };
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('text-black duration-300', {
      'invisible opacity-0': !showButton
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    className: 'focus group flex items-center gap-2 p-2.5 pl-0 transition hover:text-red-500',
    "aria-label": intl.formatMessage({
      id: "lIJKZh",
      defaultMessage: [{
        "type": 0,
        "value": "Scroll to top"
      }]
    }),
    "aria-hidden": "true",
    tabIndex: -1
  }, intl.formatMessage({
    id: "Gs9Kfp",
    defaultMessage: [{
      "type": 0,
      "value": "Back to top"
    }]
  }), /*#__PURE__*/React.createElement(ArrowNarrowUpIcon, {
    className: 'h-4 w-4'
  })));
};
function DonationHeader({
  HomeLink,
  localizations,
  backButton
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 z-[3000] right-0 md:top-0 h-fit md:sticky"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative container-content"
  }, /*#__PURE__*/React.createElement(BackButton, {
    backButton: backButton,
    className: "absolute bottom-[1.875rem] md:bottom-auto md:top-[3.5rem] right-0 "
  })))), /*#__PURE__*/React.createElement("header", {
    className: 'top-0 z-[1010] mb-7 bg-white'
  }, /*#__PURE__*/React.createElement(HeaderDesktop$1, {
    HomeLink: HomeLink,
    localizations: localizations
  })));
}

function DonationField({
  isCustomAmountField = false,
  amount,
  label,
  fieldName,
  customFieldName,
  activeCustomField = false,
  isHeaderField = false,
  hasRoundedBorder = false,
  inputClass = ''
}) {
  const intl = useIntl();
  const inputRef = useRef(null);
  const [field] = useField(customFieldName || '');
  return isCustomAmountField ? /*#__PURE__*/React.createElement("label", {
    className: clsx('focus focus-within flex h-20 w-full cursor-pointer flex-col items-center justify-center', {
      'bg-grey-600 text-white': activeCustomField
    }, {
      'bg-white text-grey-600': !activeCustomField
    }, {
      'md:w-24': isHeaderField
    }),
    onClick: () => {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, /*#__PURE__*/React.createElement(Field, {
    type: "radio",
    name: fieldName,
    className: clsx(['peer sr-only', inputClass]),
    value: 0
  }), /*#__PURE__*/React.createElement("input", _extends({}, field, {
    type: "number",
    className: clsx('no-focus h-7 max-w-full border-0 bg-grey-600 p-0 text-center text-2xl font-bold text-white', {
      hidden: !activeCustomField
    }),
    ref: inputRef
  })), /*#__PURE__*/React.createElement("span", {
    className: clsx('text-2xl font-bold', {
      hidden: activeCustomField
    })
  }, intl.formatMessage({
    id: "Oo+0sJ",
    defaultMessage: [{
      "type": 0,
      "value": "..."
    }]
  })), /*#__PURE__*/React.createElement("span", {
    className: clsx('text-sm')
  }, label)) : /*#__PURE__*/React.createElement("label", {
    className: clsx('focus-within block w-full', {
      'md:w-24': isHeaderField
    })
  }, /*#__PURE__*/React.createElement(Field, {
    type: "radio",
    name: fieldName,
    value: amount,
    className: clsx(['peer sr-only', inputClass])
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('flex h-20 w-full w-full cursor-pointer flex-col items-center justify-center bg-white text-grey-600 transition hover:bg-blue-200 peer-checked:bg-grey-600 peer-checked:text-white', {
      'md:w-24': isHeaderField
    }, {
      'rounded-tl-xl': hasRoundedBorder
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: 'text-2xl font-bold'
  }, amount), /*#__PURE__*/React.createElement("span", {
    className: 'text-sm'
  }, label)));
}

function DonationWidget({
  periods,
  Form,
  type
}) {
  const intl = useIntl();
  const [isMounted, setIsMounted] = useState(false); // Need this for the react-tooltip
  const periodLabels = {
    oneTime: intl.formatMessage({
      id: "FT2bqM",
      defaultMessage: [{
        "type": 0,
        "value": "one time"
      }]
    }),
    monthly: intl.formatMessage({
      id: "d0YHgM",
      defaultMessage: [{
        "type": 0,
        "value": "monthly"
      }]
    }),
    yearly: intl.formatMessage({
      id: "2sqsLa",
      defaultMessage: [{
        "type": 0,
        "value": "yearly"
      }]
    })
  };
  const optionLabels = {
    donation: intl.formatMessage({
      id: "hCU9Bm",
      defaultMessage: [{
        "type": 0,
        "value": "CHF"
      }]
    }),
    climate: intl.formatMessage({
      id: "OKhRC6",
      defaultMessage: [{
        "type": 0,
        "value": "Share"
      }]
    }),
    sponsorship: intl.formatMessage({
      id: "hCU9Bm",
      defaultMessage: [{
        "type": 0,
        "value": "CHF"
      }]
    })
  };
  const optionLabelsPlural = {
    donation: intl.formatMessage({
      id: "hCU9Bm",
      defaultMessage: [{
        "type": 0,
        "value": "CHF"
      }]
    }),
    climate: intl.formatMessage({
      id: "mrwfXX",
      defaultMessage: [{
        "type": 0,
        "value": "Shares"
      }]
    }),
    sponsorship: intl.formatMessage({
      id: "hCU9Bm",
      defaultMessage: [{
        "type": 0,
        "value": "CHF"
      }]
    })
  };
  const buttonLabels = {
    donation: intl.formatMessage({
      id: "2IFGap",
      defaultMessage: [{
        "type": 0,
        "value": "Donate"
      }]
    }),
    climate: intl.formatMessage({
      id: "ON3hq/",
      defaultMessage: [{
        "type": 0,
        "value": "Subscribe shares"
      }]
    }),
    sponsorship: intl.formatMessage({
      id: "sspxvQ",
      defaultMessage: [{
        "type": 0,
        "value": "Become a sponsor"
      }]
    })
  };
  const tooltipLabels = {
    donation: intl.formatMessage({
      id: "i21FM/",
      defaultMessage: [{
        "type": 0,
        "value": "Tooltip text for donations"
      }]
    }),
    climate: intl.formatMessage({
      id: "E74iUZ",
      defaultMessage: [{
        "type": 0,
        "value": "Tooltip text for climate shares"
      }]
    }),
    sponsorship: intl.formatMessage({
      id: "f1IAGt",
      defaultMessage: [{
        "type": 0,
        "value": "Tooltip text for sponsorships"
      }]
    })
  };
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const FormInner = () => {
    const [activeCustomField, setActiveCustomField] = useState(false);
    const {
      values,
      setValues
    } = useFormikContext();
    const [period, setPeriod] = useState('');
    useEffect(() => {
      // @ts-ignore
      if (period !== values.period) {
        const periodDefaultValue = periods.filter(
        // If there is not yet a period chosen by the user (so when the user
        // first loads the page), then the periods filter call should just
        // return the original array, and the default value would be basically
        // the one corresponding to the first element from the perioods array.
        // @ts-ignore
        item => typeof values.period === 'undefined' || item.period.value === values.period
        // @ts-ignore
        )[0]?.period?.defaultValue;
        if (periodDefaultValue) {
          // @ts-ignore
          setValues({
            // @ts-ignore
            ...values,
            // If the currently selected values have no period defined, we want
            // to set it to the value of the first period from the available
            // periods array.
            // @ts-ignore
            period: typeof values.period === 'undefined' ? periods[0]?.period.value : values.period,
            // @ts-ignore
            amount: `${periodDefaultValue}`
          });
        }
        // @ts-ignore
        setPeriod(typeof values.period === 'undefined' ? periods[0]?.period.value : values.period);
      }
    }, [values]);
    return /*#__PURE__*/React.createElement(Tab.Group, null, /*#__PURE__*/React.createElement(Tab.List, {
      className: clsx('w-full border-b border-blue-500', {
        'grid grid-cols-2': periods.length === 2
      }, {
        'grid grid-cols-3': periods.length === 3 || periods.length === 1
      })
    }, periods.map(({
      period
    }, index) => /*#__PURE__*/React.createElement(Tab, {
      className: 'focus w-full text-xs font-bold uppercase md:text-sm',
      key: index
    }, ({
      selected
    }) => /*#__PURE__*/React.createElement("span", {
      onClick: () => {
        // @ts-ignore
        setValues({
          ...values,
          period: period.value
        });
      },
      className: clsx('block border-b-4 pb-3', {
        'border-grey-600 text-grey-600': selected
      }, {
        'border-transparent text-blue-500': !selected
      }, {
        'border-transparent text-blue-500': !selected
      })
    }, periodLabels[period.value])))), /*#__PURE__*/React.createElement(Tab.Panels, null, periods.map(({
      period,
      items
    }, index) => {
      const itemsLength = period.displayCustomAmount ? items.length + 1 : items.length;
      return /*#__PURE__*/React.createElement(Tab.Panel, {
        key: index,
        className: 'focus'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'mt-5 flex flex-col gap-5'
      }, /*#__PURE__*/React.createElement("fieldset", {
        className: clsx('grid gap-5', {
          'grid-cols-1': itemsLength === 1,
          'grid-cols-2': itemsLength === 2,
          'grid-cols-2 md:grid-cols-3': itemsLength === 3,
          'grid-cols-2 md:grid-cols-4': itemsLength === 4
        }),
        role: "group"
      }, items.map(({
        amount
      }, index) => /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          // @ts-ignore
          setValues({
            ...values,
            customAmountIsActive: false
          });
          setActiveCustomField(false);
        },
        key: index
      }, /*#__PURE__*/React.createElement(DonationField, {
        amount: amount,
        label: parseInt(amount) > 1 ? optionLabelsPlural[type] : optionLabels[type],
        fieldName: 'amount',
        hasRoundedBorder: index === 0,
        inputClass: "tracking-main-donation-widget-amount"
      }))), !!period.displayCustomAmount && /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          // @ts-ignore
          setValues({
            ...values,
            customAmountIsActive: true
          });
          setActiveCustomField(true);
        }
      }, /*#__PURE__*/React.createElement(DonationField, {
        amount: '1001',
        label: optionLabels[type],
        fieldName: 'amount',
        isCustomAmountField: true,
        customFieldName: 'customAmount',
        activeCustomField: activeCustomField,
        inputClass: "tracking-main-donation-widget-amount"
      }))), /*#__PURE__*/React.createElement("button", {
        className: 'tracking-main-donation-widget-submit focus flex h-16 w-full items-center justify-center rounded-tl-xl bg-red-500 px-6 font-condensed uppercase text-white transition hover:bg-red-600',
        type: "submit"
      }, buttonLabels[type])));
    })));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, {
    className: 'w-full',
    id: "donation"
  }, /*#__PURE__*/React.createElement(FormInner, null)), /*#__PURE__*/React.createElement("div", {
    className: 'mt-7 flex gap-3'
  }, /*#__PURE__*/React.createElement("a", {
    "data-for": "main",
    "data-tip": tooltipLabels[type]
  }, /*#__PURE__*/React.createElement(InformationCircleIcon, {
    className: 'h-6 w-6 cursor-pointer'
  })), isMounted && /*#__PURE__*/React.createElement(ReactTooltip, {
    className: '!max-w-[350px] !text-base',
    id: "main",
    place: 'left'
  }), /*#__PURE__*/React.createElement("span", null, intl.formatMessage({
    id: "hPyxZd",
    defaultMessage: [{
      "type": 0,
      "value": "Ihre Daten sind bei uns sicher."
    }]
  }))));
}

function FactSheet({
  Title,
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, Title ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-5 md:mb-7'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })) : null, items.map(({
    Heading,
    content
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-3.5 gap-5 rounded-tl-xl bg-blue-100 px-5 pt-6 pb-7 font-light last:mb-0 md:flex-row md:px-7 md:text-lg lg:pr-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-2 text-lg font-bold leading-normal md:text-xl'
  }, /*#__PURE__*/React.createElement(Heading, null)), /*#__PURE__*/React.createElement("div", {
    className: 'fact-inner'
  }, /*#__PURE__*/React.createElement(Group, {
    definition: FactSheetContentGroup,
    input: content
  })))))));
}

function FactTiles({
  ProjectNumber,
  Canton,
  WorkType,
  Languages,
  MainActivity,
  Location,
  Animals,
  Lodgings,
  AdditionalInformation
}) {
  const intl = useIntl();
  const facts = [];
  if (Canton) {
    facts.push({
      title: intl.formatMessage({
        id: "wuH4dN",
        defaultMessage: [{
          "type": 0,
          "value": "Canton"
        }]
      }),
      Description: Canton
    });
  }
  if (Location) {
    facts.push({
      title: intl.formatMessage({
        id: "rvirM2",
        defaultMessage: [{
          "type": 0,
          "value": "Location"
        }]
      }),
      Description: Location
    });
  }
  if (WorkType) {
    facts.push({
      title: intl.formatMessage({
        id: "9wxRta",
        defaultMessage: [{
          "type": 0,
          "value": "Type of work"
        }]
      }),
      Description: WorkType
    });
  }
  if (Languages) {
    facts.push({
      title: intl.formatMessage({
        id: "GsBRWL",
        defaultMessage: [{
          "type": 0,
          "value": "Languages"
        }]
      }),
      Description: Languages
    });
  }
  if (Animals) {
    facts.push({
      title: intl.formatMessage({
        id: "EZRKjg",
        defaultMessage: [{
          "type": 0,
          "value": "Animals"
        }]
      }),
      Description: Animals
    });
  }
  if (MainActivity) {
    facts.push({
      title: intl.formatMessage({
        id: "y2xJjT",
        defaultMessage: [{
          "type": 0,
          "value": "Main activity"
        }]
      }),
      Description: MainActivity
    });
  }
  if (Lodgings) {
    facts.push({
      title: intl.formatMessage({
        id: "3894qF",
        defaultMessage: [{
          "type": 0,
          "value": "Lodgings"
        }]
      }),
      Description: Lodgings
    });
  }
  if (AdditionalInformation) {
    facts.push({
      title: intl.formatMessage({
        id: "gh/lBJ",
        defaultMessage: [{
          "type": 0,
          "value": "Additional information"
        }]
      }),
      Description: AdditionalInformation
    });
  }
  if (ProjectNumber) {
    facts.push({
      title: intl.formatMessage({
        id: "d3wh25",
        defaultMessage: [{
          "type": 0,
          "value": "Project number"
        }]
      }),
      Description: ProjectNumber
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page my-10 md:mb-20 md:mt-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, Heading ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-5 md:mb-7'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: buildHtml(`<h4>${intl.formatMessage({
      id: "vAy3Cs",
      defaultMessage: [{
        "type": 0,
        "value": "What you need to know about the location"
      }]
    })}</h4>`)
  })) : null, facts.map((fact, index) => /*#__PURE__*/React.createElement(Fact, _extends({
    key: index
  }, fact))))));
}
function Fact({
  title,
  Description
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'mb-3.5 flex flex-col gap-5 rounded-tl-xl bg-blue-100 px-5 pt-6 pb-7 font-light last:mb-0 md:flex-row md:px-7 md:text-lg lg:pr-14'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: 'mb-2 text-xl font-bold'
  }, title), /*#__PURE__*/React.createElement("div", {
    className: 'prose max-w-full md:prose-xl'
  }, /*#__PURE__*/React.createElement(Description, null))));
}

function FileLinksBlock({
  title,
  anchor,
  content,
  files
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "container-page mb-10 bg-blue-100 lg:bg-transparent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content py-10 md:py-14 lg:bg-blue-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('prose !max-w-full lg:prose-xl')
  }, title && /*#__PURE__*/React.createElement("h2", {
    id: anchor || undefined
  }, title), /*#__PURE__*/React.createElement(Group, {
    definition: FileListContentGroup,
    input: content
  }))), files.map((file, index) => /*#__PURE__*/React.createElement(File, _extends({
    key: index
  }, file))))));
}
function File({
  fileUrl,
  title,
  size,
  type,
  Description,
  Source,
  Image
}) {
  const intl = useIntl();
  const descriptionString = Description.initialHtmlString;
  const ariaLabelDescription = descriptionString.replace(/(<([^>]+)>)/gi, '');
  return /*#__PURE__*/React.createElement("a", {
    href: fileUrl,
    download: true,
    target: '_blank',
    className: 'mb-4 flex flex-col gap-5 last:mb-0 md:flex-row focus transition hover:bg-blue-200 p-3 rounded-tl-xl md:-ml-3',
    "aria-label": `${title}, ${ariaLabelDescription}, ${intl.formatMessage({
      id: "xD6TLA",
      defaultMessage: [{
        "type": 0,
        "value": "Download ("
      }, {
        "type": 1,
        "value": "type"
      }, {
        "type": 0,
        "value": ", "
      }, {
        "type": 1,
        "value": "size"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      type: formatFileType(type),
      size
    })}`,
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'block h-[143px] w-full max-w-[100px] shrink-0',
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: 'mb-3 text-lg font-bold'
  }, title), /*#__PURE__*/React.createElement(Description, null), Source ? /*#__PURE__*/React.createElement(Source, null) : null, /*#__PURE__*/React.createElement("span", {
    className: 'mt-3 inline-flex items-center gap-3 py-1 text-sm font-light uppercase text-red-500 transition'
  }, /*#__PURE__*/React.createElement(DownloadIcon, {
    className: 'h-3 w-3'
  }), intl.formatMessage({
    id: "xD6TLA",
    defaultMessage: [{
      "type": 0,
      "value": "Download ("
    }, {
      "type": 1,
      "value": "type"
    }, {
      "type": 0,
      "value": ", "
    }, {
      "type": 1,
      "value": "size"
    }, {
      "type": 0,
      "value": ")"
    }]
  }, {
    type: formatFileType(type),
    size
  }))));
}
function formatFileType(fileType) {
  const words = fileType.split('/');
  return words[1] ? words[1] : words[0] ? words[0] : '';
}

function flatten(a, level = 1) {
  return a.reduce(function (flattened, {
    value,
    title,
    children
  }) {
    return flattened.concat([{
      value,
      title,
      level: level
    }]).concat(children ? flatten(children, 2) : []);
  }, []);
}
function Select({
  selectItems,
  name,
  id,
  onChangeHandler
}) {
  const [field,, helpers] = useField(name);
  const [query, setQuery] = useState('');
  const filteredSelect = query === '' ? selectItems : flatten(selectItems).filter(({
    title
  }) => {
    return lowerCase(title).includes(query.toLowerCase());
  });
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, selectItems.length < 10 ? /*#__PURE__*/React.createElement(Listbox, {
    value: field.value,
    onChange: ev => {
      helpers.setValue(ev);
      if (typeof onChangeHandler !== 'undefined') {
        onChangeHandler(ev);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement(Listbox.Button, {
    id: id,
    className: 'field relative min-h-[38px] w-full min-w-full max-w-full truncate bg-white pt-3.5 pb-2.5 pr-14 pl-4 text-left text-sm font-bold leading-none focus-visible:outline-dotted focus-visible:outline-2 focus-visible:outline-red-500'
  }, flatten(selectItems).filter(item => item.value === field.value)[0]?.title, /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-1 top-1/2 flex h-full w-11 -translate-y-1/2 items-center justify-center before:relative before:-left-2.5 before:h-2/3 before:w-0.5 before:border-l before:border-l-black before:content-[""] sm:w-[38px]'
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    className: 'h-5 w-5'
  }))), /*#__PURE__*/React.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Listbox.Options, {
    className: "absolute z-[10000] -mt-px max-h-60 w-full min-w-[200px] overflow-auto border border-grey-200 bg-white text-base shadow-lg focus:outline-none sm:text-sm py-4"
  }, flatten(selectItems).sort((a, b) => a.title.localeCompare(b.title)).map(({
    title,
    value,
    level
  }, index) => /*#__PURE__*/React.createElement(Listbox.Option, {
    key: index,
    className: clsx('relative cursor-default select-none bg-white py-2 pr-4 text-black transition hover:bg-blue-50', {
      'pl-10': level === 1,
      'pl-16': level === 2
    }),
    value: value
  }, ({
    selected
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: clsx('block', {
      'font-bold': selected,
      'font-normal': !selected && level === 1,
      'font-thin': !selected && level === 2
    })
  }, title), selected ? /*#__PURE__*/React.createElement("span", {
    className: clsx('absolute top-1.5 left-0 flex items-center', {
      'pl-3': level === 1,
      'pl-9': level === 2
    })
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })) : null))))))) : /*#__PURE__*/React.createElement(Combobox, {
    value: field.value,
    onChange: ev => helpers.setValue(ev)
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement(Combobox.Input, {
    className: 'field relative w-full border-0 py-[7px] pt-2 pb-1.5 pl-3 pr-12 text-left text-[14px] font-bold focus-visible:outline-dotted focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-red-500 focus-visible:ring-0',
    onChange: event => setQuery(event.target.value),
    displayValue: value => flatten(filteredSelect).filter(
    // TODO: Investigate whats the real input of `displayValue`.
    // @ts-ignore
    item => item.value === value)[0]?.title || '',
    id: id
  }), /*#__PURE__*/React.createElement(Combobox.Button, {
    className: 'absolute right-1 top-1/2 flex h-full w-11 -translate-y-1/2 items-center justify-center before:relative before:-left-2.5 before:h-2/3 before:w-0.5 before:border-l before:border-l-black before:content-[""] sm:w-[38px]'
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    className: 'h-5 w-5'
  })), /*#__PURE__*/React.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Combobox.Options, {
    className: "absolute z-[10000] -mt-px max-h-60 w-full min-w-[200px] overflow-auto border border-grey-200 bg-white text-base shadow-lg focus:outline-none sm:text-sm"
  }, filteredSelect.length === 0 && query !== '' ? /*#__PURE__*/React.createElement("div", {
    className: "relative cursor-default select-none py-2 px-4 text-grey-500"
  }, intl.formatMessage({
    id: "/vMjUJ",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing found."
    }]
  })) : flatten(filteredSelect).sort((a, b) => a.title.localeCompare(b.title)).map(({
    title,
    value,
    level
  }, index) => /*#__PURE__*/React.createElement(Combobox.Option, {
    key: index,
    className: clsx('relative cursor-default select-none py-2.5 pr-4 text-black', {
      'pl-10': level === 1,
      'pl-16': level === 2
    }),
    value: value
  }, ({
    selected
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: clsx('block', {
      'font-bold': selected,
      'font-normal': !selected && level === 1,
      'font-thin': !selected && level === 2
    })
  }, title), selected ? /*#__PURE__*/React.createElement("span", {
    className: clsx('text-blue-900 absolute inset-y-0 left-0 flex items-center pl-3', {
      'pl-3': level === 1,
      'pl-9': level === 2
    })
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })) : null))))))));
}

function ViolationMessage({
  Message,
  dangerousHtmlMessageString,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(className, 'border-l-4 border-red-500 bg-white px-4 py-3 -mb-1.5 mt-7 status-message violation-message')
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-6 w-6 inline mr-2.5 text-red-500",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  })), Message && /*#__PURE__*/React.createElement("span", {
    className: 'relative top-px'
  }, /*#__PURE__*/React.createElement(Message, null)), dangerousHtmlMessageString && /*#__PURE__*/React.createElement("span", {
    className: 'relative top-px',
    dangerouslySetInnerHTML: {
      __html: dangerousHtmlMessageString
    }
  }));
}

function TeaserBergeinsatz({
  Image,
  description,
  title,
  Link,
  bioTag,
  sosTag,
  status
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('focus group relative block rounded-tl-lg', {
      'border-4 border-red-500': status === 0
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-5 aspect-h-4 relative -mb-9 block overflow-hidden rounded-tl-lg border-b-4 border-red-500'
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  }) : /*#__PURE__*/React.createElement("img", {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105',
    src: '/fallback_teaser_image.svg',
    alt: 'Teaser image fallback'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative ml-[5.1%] w-[95%] max-w-[95%] bg-white md:ml-[10.1%] md:w-[90%] md:max-w-[90%] md:bg-blue-100'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute -top-[26px] right-0 md:-top-3.5'
  }, !!bioTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-green-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "2W0f9h",
    defaultMessage: [{
      "type": 0,
      "value": "Bio"
    }]
  })), !!sosTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-red-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "CAe6jR",
    defaultMessage: [{
      "type": 0,
      "value": "SOS"
    }]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "relative overflow-hidden pl-5 pt-5 transition after:absolute after:left-0 after:top-[-105%] after:h-full after:w-[4px] after:bg-red-500 after:transition-[top] after:content-[''] group-hover:after:top-0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: clsx('max-w-[calc(100%-35px)] text-xl font-bold transition')
  }, title), description ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-1 font-light sm:mt-2.5'
  }, description) : null))));
}

function TeaserGridBergeinsatz({
  teasers,
  MoreLink
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap"
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "w-full pb-9 last:pb-0 sm:w-1/2 sm:p-2.5 md:pb-6 lg:w-1/4"
  }, /*#__PURE__*/React.createElement(TeaserBergeinsatz, teaser)))), MoreLink ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-10 flex text-center md:mt-11'
  }, /*#__PURE__*/React.createElement(MoreLink, {
    className: 'focus mx-auto min-w-[25%] bg-blue-500 py-2.5 px-8 font-condensed uppercase text-white transition hover:bg-blue-600'
  }, intl.formatMessage({
    id: "RHVodH",
    defaultMessage: [{
      "type": 0,
      "value": "Go to all missions"
    }]
  }))) : null);
}

const Map$1 = loadable(() => import('./Map-59f23966.js'));
const dataLayerFieldName = {
  startdate: 'Startdatum',
  enddate: 'Enddatum',
  type: 'Arbeiten für Freiwillige',
  language: 'Sprache',
  canton: 'Kanton',
  remainingSpots: 'Verfügbare Plätze',
  bio: 'Bio-Bauernhöfe',
  sos: 'SOS-Bauernhöfe'
};
function FilteredLocations({
  gridItems,
  markers,
  MoreLink,
  pagerLinks,
  isLoadingData,
  viewTypeStore,
  filteredResultsAmountStore,
  availableFiltersStore,
  ...Form
}) {
  const intl = useIntl();
  const viewType = useStore(viewTypeStore, state => state.viewType);
  const setViewType = useStore(viewTypeStore, state => state.update);
  const Title = buildHtml(`<h2>${intl.formatMessage({
    id: "7kGcaL",
    defaultMessage: [{
      "type": 0,
      "value": "Find your dream farm"
    }]
  })}</h2>`);
  return /*#__PURE__*/React.createElement("div", {
    className: 'mb-10 max-w-full rounded-tl-xl bg-blue-100 pt-8 md:mb-20 md:rounded-none md:px-4 md:pb-5 md:pt-16 lg:pt-20'
  }, /*#__PURE__*/React.createElement("div", {
    id: "search"
  }), /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 md:px-2.5"
  }, Heading ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-5 md:mb-7'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })) : null, /*#__PURE__*/React.createElement(FilteredLocationsForm, _extends({
    filteredResultsAmountStore: filteredResultsAmountStore,
    availableFiltersStore: availableFiltersStore
  }, Form)), !isLoadingData && gridItems?.length ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "focus mx-auto mt-5 mb-9 flex w-full shrink-0 cursor-pointer select-none items-center justify-center whitespace-normal border border-black bg-transparent px-6 py-2.5 font-condensed text-sm uppercase text-black transition duration-300 hover:bg-black hover:text-white sm:my-7 sm:w-auto md:mt-12 lg:px-7",
    onClick: () => {
      const newViewType = viewType === 'map' ? 'list' : 'map';
      setViewType(newViewType);
      pushLocationsSearchResultsViewTypeClick(newViewType);
    }
  }, viewType === 'map' ? intl.formatMessage({
    id: "Ui9oH6",
    defaultMessage: [{
      "type": 0,
      "value": "Show results in list"
    }]
  }) : intl.formatMessage({
    id: "pCHmu1",
    defaultMessage: [{
      "type": 0,
      "value": "Show results in map"
    }]
  })) : null), !isLoadingData && !gridItems?.length && /*#__PURE__*/React.createElement(ViolationMessage, {
    Message: buildHtml(intl.formatMessage({
      id: "BXCmTO",
      defaultMessage: [{
        "type": 0,
        "value": "There are no locations to be displayed."
      }]
    }))
  }), !isLoadingData && gridItems?.length && viewType !== 'map' ? /*#__PURE__*/React.createElement("div", {
    className: 'bg-white px-4 pb-5 pt-10 md:bg-transparent md:p-0 md:pb-16 lg:pb-20'
  }, /*#__PURE__*/React.createElement(TeaserGridBergeinsatz, {
    teasers: gridItems,
    MoreLink: MoreLink
  }), pagerLinks && /*#__PURE__*/React.createElement(Pager, {
    pagerLinks: pagerLinks
  })) : null, !isLoadingData && markers?.length && viewType === 'map' ? /*#__PURE__*/React.createElement("div", {
    className: '-mx-4 lg:-mx-6'
  }, /*#__PURE__*/React.createElement(Map$1, {
    markers: markers,
    center: {
      lat: 46.8,
      lng: 8.2
    },
    centerByMapBounds: false,
    zoom: 8,
    isRedesignedPopup: false
  })) : null));
}
function FilteredLocationsForm({
  Form,
  showAllFilters = false,
  filteredResultsAmountStore,
  availableFiltersStore
}) {
  const intl = useIntl();
  const [allFiltersState, setAllFiltersState] = useState({
    openAll: false,
    openAllClicked: false
  });
  const availableFilters = useStore(availableFiltersStore, state => state.filters);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    className: 'form mt-2 md:mt-10',
    id: 'listing-filters'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'lg:flex lg:items-start lg:gap-6'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'w-full'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'gap-6 sm:grid sm:grid-cols-2 md:pb-2 lg:grid-cols-4'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "n5QvJy",
    defaultMessage: [{
      "type": 0,
      "value": "Start date"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative mb-4 before:absolute before:right-11 before:top-[7px] before:z-10 before:block before:h-2/3 before:w-px before:bg-black before:content-[""] sm:mb-0'
  }, /*#__PURE__*/React.createElement(DateWidget, {
    name: "startdate"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "Humfno",
    defaultMessage: [{
      "type": 0,
      "value": "End date"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative mb-4 before:absolute before:right-11 before:top-[7px] before:z-10 before:block before:h-2/3 before:w-px before:bg-black before:content-[""] sm:mb-0'
  }, /*#__PURE__*/React.createElement(DateWidget, {
    name: "enddate"
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'mb-4 sm:mb-0'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'type',
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "9wxRta",
    defaultMessage: [{
      "type": 0,
      "value": "Type of work"
    }]
  })), /*#__PURE__*/React.createElement(MultiselectFilterFormItem, {
    name: 'type',
    title: intl.formatMessage({
      id: "zQvVDJ",
      defaultMessage: [{
        "type": 0,
        "value": "All"
      }]
    }),
    items: availableFilters?.types || []
  })), /*#__PURE__*/React.createElement("div", {
    className: 'mb-1 sm:mb-0'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'language',
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "y1Z3or",
    defaultMessage: [{
      "type": 0,
      "value": "Language"
    }]
  })), /*#__PURE__*/React.createElement(MultiselectFilterFormItem, {
    name: 'language',
    title: intl.formatMessage({
      id: "zQvVDJ",
      defaultMessage: [{
        "type": 0,
        "value": "All"
      }]
    }),
    items: availableFilters?.languages || []
  }))), /*#__PURE__*/React.createElement(Disclosure, {
    defaultOpen: allFiltersState.openAllClicked ? allFiltersState.openAll : showAllFilters
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Disclosure.Panel, {
    className: "accordion-inner max-w-none pt-3 md:pt-4 lg:pb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'gap-6 sm:mt-3 sm:grid sm:grid-cols-2 md:mt-0 lg:grid-cols-4'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-4 sm:mb-0'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'canton',
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "wuH4dN",
    defaultMessage: [{
      "type": 0,
      "value": "Canton"
    }]
  })), /*#__PURE__*/React.createElement(MultiselectFilterFormItem, {
    name: 'canton',
    title: intl.formatMessage({
      id: "zQvVDJ",
      defaultMessage: [{
        "type": 0,
        "value": "All"
      }]
    }),
    items: availableFilters?.cantons || []
  })), /*#__PURE__*/React.createElement("div", {
    className: 'mb-4 sm:mb-0'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'remainingSpots',
    className: 'mb-2 block font-condensed text-xs uppercase tracking-wide'
  }, intl.formatMessage({
    id: "/hSjkz",
    defaultMessage: [{
      "type": 0,
      "value": "Available spots"
    }]
  })), /*#__PURE__*/React.createElement(Select, {
    selectItems: [{
      value: '',
      title: '1'
    }, {
      value: '2',
      title: '2'
    }, {
      value: '3',
      title: '3'
    }],
    name: 'remainingSpots',
    id: 'remainingSpots',
    onChangeHandler: ev => {
      pushLocationsSearchFiltersSelect(dataLayerFieldName.remainingSpots, ev === '' ? '1' : ev);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "checkboxes--wrapper sm:-mt-1.5 lg:mt-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item"
  }, /*#__PURE__*/React.createElement(CheckboxFormItem, {
    name: "bio",
    id: 'bio',
    disabled: !availableFilters?.hasBioLocations
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "bio"
  }, intl.formatMessage({
    id: "IqAR5M",
    defaultMessage: [{
      "type": 0,
      "value": "Bio Farms"
    }]
  })))), /*#__PURE__*/React.createElement("div", {
    className: "checkboxes--wrapper sm:-mt-1.5 lg:mt-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item"
  }, /*#__PURE__*/React.createElement(CheckboxFormItem, {
    name: "sos",
    id: 'sos',
    disabled: !availableFilters?.hasSOSLocations
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "sos"
  }, intl.formatMessage({
    id: "7Xcn2h",
    defaultMessage: [{
      "type": 0,
      "value": "SOS Farms"
    }]
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: " lg:relative lg:left-[51%]  lg:grid lg:grid-cols-4 lg:gap-6"
  }, /*#__PURE__*/React.createElement(Disclosure.Button, {
    className: 'focus group mt-0.5 flex items-center py-3 pr-4 pl-0 text-left text-[15px] transition-all hover:text-red-500 focus:outline-offset-[-8px] sm:mx-auto sm:mt-0 sm:justify-center sm:px-4 md:relative lg:-top-1.5 lg:mx-0 lg:min-w-[210px]',
    onPointerUp: () => {
      // The onClick event does not seem to work on this
      // component (Disclosure.Button) so we use the
      // onPoniterUp() event instead.
      setAllFiltersState({
        openAll: !open,
        openAllClicked: true
      });
      pushLocationsAdditionalSearchClick(!open);
    }
  }, open ? /*#__PURE__*/React.createElement("div", {
    className: 'flex h-6 w-6 shrink-0 items-center text-red-500 transition'
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    className: 'h-4 w-4'
  })) : /*#__PURE__*/React.createElement("div", {
    className: 'flex h-6 w-6 shrink-0 items-center text-red-500 transition'
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    className: 'h-4 w-4'
  })), /*#__PURE__*/React.createElement("h3", {
    className: 'shrink-0 font-light text-red-500'
  }, open ? intl.formatMessage({
    id: "NvSwV9",
    defaultMessage: [{
      "type": 0,
      "value": "Show fewer options"
    }]
  }) : intl.formatMessage({
    id: "CD3U9S",
    defaultMessage: [{
      "type": 0,
      "value": "Show more options"
    }]
  })))))))), /*#__PURE__*/React.createElement(SubmitButton$1, {
    filteredResultsAmountStore: filteredResultsAmountStore,
    types: availableFilters?.types || [],
    languages: availableFilters?.languages || [],
    cantons: availableFilters?.cantons || []
  }))));
}
const CheckboxFormItem = ({
  name,
  id,
  disabled
}) => {
  const [field] = useField(name);
  return /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: name,
    id: id,
    disabled: disabled,
    onChange: e => {
      field.onChange(e);
      pushLocationsSearchFiltersSelect(dataLayerFieldName[name] || name, e.target.checked);
    }
  });
};
const MultiselectFilterFormItem = ({
  name,
  title,
  items
}) => {
  const {
    values
  } = useFormikContext();
  return /*#__PURE__*/React.createElement(Multiselect, {
    name: name,
    className: items.length ? 'bg-white' : '',
    title: title,
    items: items,
    disabled: !items.length,
    onOptionChange: e => {
      let newValues = [];
      if (typeof values[name] !== 'string') {
        newValues = values[name];
      }
      if (e.target.checked) {
        newValues.push(`${e.target.value}`);
      } else {
        newValues = newValues.filter(el => el !== `${e.target.value}`);
      }
      pushLocationsSearchFiltersSelect(dataLayerFieldName[name] || name, prepareTermValuesForDatalayer(newValues, items));
    }
  });
};
const SubmitButton$1 = ({
  filteredResultsAmountStore,
  types,
  languages,
  cantons
}) => {
  const intl = useIntl();
  const {
    values
  } = useFormikContext();
  const filteredResultsAmount = useStore(filteredResultsAmountStore, state => state.amount);
  return /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "focus mx-auto mt-1 flex w-full shrink-0 cursor-pointer select-none items-center justify-center whitespace-normal bg-red-500 px-6 py-[9px] font-condensed text-sm uppercase text-white transition duration-300 hover:bg-red-600 sm:mt-4 sm:w-auto md:px-7 lg:mx-0 lg:mt-6 lg:w-1/5",
    onPointerUp: () => {
      const valuesToPush = prepareValuesForDatalayer(values, {
        types: types,
        languages: languages,
        cantons: cantons
      });
      pushLocationsSearchFiltersAppliedClick(filteredResultsAmount || 0, valuesToPush);
    }
  }, filteredResultsAmount ? intl.formatMessage({
    id: "wCK1QQ",
    defaultMessage: [{
      "type": 0,
      "value": "Find farm ("
    }, {
      "type": 1,
      "value": "number"
    }, {
      "type": 0,
      "value": ")"
    }]
  }, {
    number: filteredResultsAmount || '...'
  }) : intl.formatMessage({
    id: "kiL4zB",
    defaultMessage: [{
      "type": 0,
      "value": "Find farm"
    }]
  }));
};
const prepareTermValuesForDatalayer = (terms, termsMap) => {
  const filterValues = [];
  const searchTermValue = id => {
    for (const map of termsMap) {
      if (map.id === id) {
        return map.originalLabel || map.label;
      }
    }
    return '';
  };
  if (typeof terms !== 'string') {
    terms.map(termId => {
      filterValues.push(searchTermValue(termId));
    });
  }
  return filterValues;
};
const prepareValuesForDatalayer = (values, valuesMap) => {
  const filters = [];
  filters.push({
    filter_name: dataLayerFieldName.startdate,
    filter_value: values.startdate
  });
  filters.push({
    filter_name: dataLayerFieldName.enddate,
    filter_value: values.enddate
  });
  filters.push({
    filter_name: dataLayerFieldName.type,
    filter_value: typeof valuesMap.types !== 'undefined' ? prepareTermValuesForDatalayer(values.type, valuesMap.types) : []
  });
  filters.push({
    filter_name: dataLayerFieldName.language,
    filter_value: typeof valuesMap.languages !== 'undefined' ? prepareTermValuesForDatalayer(values.language, valuesMap.languages) : []
  });
  filters.push({
    filter_name: dataLayerFieldName.canton,
    filter_value: typeof valuesMap.cantons !== 'undefined' ? prepareTermValuesForDatalayer(values.canton, valuesMap.cantons) : []
  });
  filters.push({
    filter_name: dataLayerFieldName.remainingSpots,
    filter_value: values.remainingSpots === '' ? '1' : values.remainingSpots
  });
  filters.push({
    filter_name: dataLayerFieldName.bio,
    filter_value: values.bio
  });
  filters.push({
    filter_name: dataLayerFieldName.sos,
    filter_value: values.sos
  });
  return filters;
};
const isDateSupported = () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const input = document.createElement('input');
  const value = 'a';
  input.setAttribute('type', 'date');
  input.setAttribute('value', value);
  return input.value !== value;
};
function DateWidget({
  name
}) {
  const [field,, helpers] = useField(name);
  return isDateSupported() ? /*#__PURE__*/React.createElement("div", {
    className: 'relative'
  }, /*#__PURE__*/React.createElement("input", {
    type: "date",
    onChange: e => {
      field.onChange(e);
      pushLocationsSearchFiltersSelect(dataLayerFieldName[name] || name, e.target.value);
    },
    name: name,
    id: name,
    value: field.value,
    className: 'focus w-full appearance-none border-0 !text-left focus:ring-0'
  }), /*#__PURE__*/React.createElement(CalendarIcon, {
    className: 'pointer-events-none absolute top-1/2 right-3 h-4 w-4 -translate-y-1/2'
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DatePicker, {
    className: 'field',
    selected: field.value ? new Date(field.value) : new Date(Date.now() - 86400000),
    dateFormat: "dd.MM.yyyy",
    onChange: date => {
      helpers.setValue(date.toLocaleDateString('en-CA'));
    }
  }));
}

function MicrositeFooter({
  footerMenuItems,
  HomeLink,
  localizations
}) {
  const intl = useIntl();
  const activeTheme = useActiveTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: 'border-t-[7px] border-red-500 py-14 lg:py-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-14 hidden lg:mb-[3.75rem] lg:block'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'focus inline-block'
  }, ['caritas', 'bergeinsatz', 'youngcaritas'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-9',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-9',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'lg:flex lg:items-end lg:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'text-sm'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'font-bold uppercase'
  }, intl.formatMessage({
    id: "SdAr+E",
    defaultMessage: [{
      "type": 0,
      "value": "Caritas Switzerland"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'md:flex md:items-start'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mt-7',
    dangerouslySetInnerHTML: {
      __html: activeTheme === 'bergeinsatz' ? intl.formatMessage({
        id: "crigEa",
        defaultMessage: [{
          "type": 0,
          "value": "Bergeinsatz: Adligenswilerstrasse 15"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "P.O. Box"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "CH-6002 Luzern"
        }]
      }) : intl.formatMessage({
        id: "PFf1dn",
        defaultMessage: [{
          "type": 0,
          "value": "Adligenswilerstrasse 15"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "P.O. Box"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "CH-6002 Luzern"
        }]
      })
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: 'mt-4 md:ml-20 md:mt-7'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'mb-2 lg:mb-0'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'hidden lg:inline-block'
  }, activeTheme === 'caritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  }), activeTheme === 'caritascare' && intl.formatMessage({
    id: "6h0Pmk",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 27"
    }]
  }), activeTheme === 'bergeinsatz' && `${intl.formatMessage({
    id: "Ml3UEf",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 23 29"
    }]
  })} ${intl.formatMessage({
    id: "tInRjp",
    defaultMessage: [{
      "type": 0,
      "value": "(Monday to Friday from 9 to 12)"
    }]
  })}`, activeTheme === 'youngcaritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  })), /*#__PURE__*/React.createElement("span", {
    className: "lg:hidden"
  }, /*#__PURE__*/React.createElement("a", {
    className: 'focus inline-block border-b border-b-transparent pb-0 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: `tel:${activeTheme === 'caritas' ? intl.formatMessage({
      id: "EY/LZm",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 22 22"
      }]
    }) : activeTheme === 'caritascare' ? intl.formatMessage({
      id: "6h0Pmk",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 22 27"
      }]
    }) : activeTheme === 'bergeinsatz' ? intl.formatMessage({
      id: "Ml3UEf",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 23 29"
      }]
    }) : activeTheme === 'youngcaritas' ? intl.formatMessage({
      id: "EY/LZm",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 22 22"
      }]
    }) : null}`
  }, activeTheme === 'caritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  }), activeTheme === 'caritascare' && intl.formatMessage({
    id: "6h0Pmk",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 27"
    }]
  }), activeTheme === 'bergeinsatz' && intl.formatMessage({
    id: "Ml3UEf",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 23 29"
    }]
  }), activeTheme === 'youngcaritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  })), activeTheme === 'bergeinsatz' && ` ${intl.formatMessage({
    id: "tInRjp",
    defaultMessage: [{
      "type": 0,
      "value": "(Monday to Friday from 9 to 12)"
    }]
  })}`)), activeTheme === 'caritas' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "MMvw0L",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:info@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "w5MOit",
    defaultMessage: [{
      "type": 0,
      "value": "info@caritas.ch"
    }]
  }))), activeTheme === 'bergeinsatz' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "RIvexA",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:bergeinsatz@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "U072za",
    defaultMessage: [{
      "type": 0,
      "value": "bergeinsatz@caritas.ch"
    }]
  }))), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "MmebnW",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:gutbetreut@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "6HUTu+",
    defaultMessage: [{
      "type": 0,
      "value": "gutbetreut@caritas.ch"
    }]
  }))), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "BXsmU0",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:young@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "H5Hrs5",
    defaultMessage: [{
      "type": 0,
      "value": "young@caritas.ch"
    }]
  })))))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-7 lg:mt-0 flex flex-col gap-5 lg:items-end'
  }, /*#__PURE__*/React.createElement(MicrositeFooterMenu, {
    footerMenuItems: footerMenuItems
  }), /*#__PURE__*/React.createElement("div", {
    className: 'lg:-mr-2'
  }, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    localizations: localizations
  })))))));
}
function MicrositeFooterMenu({
  footerMenuItems
}) {
  return /*#__PURE__*/React.createElement("ul", {
    className: ' md:flex md:flex-wrap'
  }, footerMenuItems.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    className: 'border-t border-grey-100 py-3 leading-none first:ml-0 first:border-l-0 first:border-t-0 first:pl-0 md:ml-4 md:border-l md:border-t-0 md:border-grey-200 md:py-0 md:pl-4',
    key: index
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600'
  }, title))));
}

function Footer({
  footerMenuItems,
  localizations,
  HomeLink,
  microsite
}) {
  const intl = useIntl();
  const activeTheme = useActiveTheme();
  if (microsite) {
    return /*#__PURE__*/React.createElement(MicrositeFooter, {
      HomeLink: HomeLink,
      footerMenuItems: footerMenuItems,
      localizations: localizations
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'border-t-[7px] border-red-500 py-14 lg:py-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-14 hidden lg:mb-[3.75rem] lg:block'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'focus inline-block'
  }, ['caritas', 'bergeinsatz'].includes(activeTheme) && /*#__PURE__*/React.createElement("img", {
    className: 'h-9',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("img", {
    className: 'h-9',
    src: '/caritas_logo.svg',
    alt: intl.formatMessage({
      id: "J8Mj8q",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas"
      }]
    })
  }), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("img", {
    className: 'h-9',
    src: '/youngcaritas_logo.svg',
    alt: intl.formatMessage({
      id: "kdy9yE",
      defaultMessage: [{
        "type": 0,
        "value": "YoungCaritas"
      }]
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'lg:flex lg:items-end lg:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'text-sm'
  }, activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("h3", {
    className: 'font-bold'
  }, intl.formatMessage({
    id: "AzIKWb",
    defaultMessage: [{
      "type": 0,
      "value": "youngCaritas"
    }]
  })), activeTheme !== 'youngcaritas' && /*#__PURE__*/React.createElement("h3", {
    className: 'font-bold uppercase'
  }, intl.formatMessage({
    id: "SdAr+E",
    defaultMessage: [{
      "type": 0,
      "value": "Caritas Switzerland"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'md:flex md:items-start'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'mt-7',
    dangerouslySetInnerHTML: {
      __html: activeTheme === 'bergeinsatz' ? intl.formatMessage({
        id: "crigEa",
        defaultMessage: [{
          "type": 0,
          "value": "Bergeinsatz: Adligenswilerstrasse 15"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "P.O. Box"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "CH-6002 Luzern"
        }]
      }) : activeTheme === 'youngcaritas' ? intl.formatMessage({
        id: "hPOYQT",
        defaultMessage: [{
          "type": 0,
          "value": "c/o Caritas Switzerland"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "Adligenswilerstrasse 15"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "P.O. Box"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "CH-6002 Luzern"
        }]
      }) : intl.formatMessage({
        id: "PFf1dn",
        defaultMessage: [{
          "type": 0,
          "value": "Adligenswilerstrasse 15"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "P.O. Box"
        }, {
          "type": 0,
          "value": "<br/>"
        }, {
          "type": 0,
          "value": "CH-6002 Luzern"
        }]
      })
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: 'mt-4 md:ml-20 md:mt-7'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'mb-2 lg:mb-0'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'hidden lg:inline-block'
  }, activeTheme === 'caritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  }), activeTheme === 'caritascare' && intl.formatMessage({
    id: "6h0Pmk",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 27"
    }]
  }), activeTheme === 'bergeinsatz' && `${intl.formatMessage({
    id: "Ml3UEf",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 23 29"
    }]
  })} ${intl.formatMessage({
    id: "tInRjp",
    defaultMessage: [{
      "type": 0,
      "value": "(Monday to Friday from 9 to 12)"
    }]
  })}`, activeTheme === 'youngcaritas' && intl.formatMessage({
    id: "AP3Mo5",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 24 40"
    }]
  })), /*#__PURE__*/React.createElement("span", {
    className: "lg:hidden"
  }, /*#__PURE__*/React.createElement("a", {
    className: 'focus inline-block border-b border-b-transparent pb-0 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: `tel:${activeTheme === 'caritas' ? intl.formatMessage({
      id: "EY/LZm",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 22 22"
      }]
    }) : activeTheme === 'caritascare' ? intl.formatMessage({
      id: "6h0Pmk",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 22 27"
      }]
    }) : activeTheme === 'bergeinsatz' ? intl.formatMessage({
      id: "Ml3UEf",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 23 29"
      }]
    }) : activeTheme === 'youngcaritas' ? intl.formatMessage({
      id: "AP3Mo5",
      defaultMessage: [{
        "type": 0,
        "value": "+41 41 419 24 40"
      }]
    }) : null}`
  }, activeTheme === 'caritas' && intl.formatMessage({
    id: "EY/LZm",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 22"
    }]
  }), activeTheme === 'caritascare' && intl.formatMessage({
    id: "6h0Pmk",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 22 27"
    }]
  }), activeTheme === 'bergeinsatz' && intl.formatMessage({
    id: "Ml3UEf",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 23 29"
    }]
  }), activeTheme === 'youngcaritas' && intl.formatMessage({
    id: "AP3Mo5",
    defaultMessage: [{
      "type": 0,
      "value": "+41 41 419 24 40"
    }]
  })), activeTheme === 'bergeinsatz' && ` ${intl.formatMessage({
    id: "tInRjp",
    defaultMessage: [{
      "type": 0,
      "value": "(Monday to Friday from 9 to 12)"
    }]
  })}`)), activeTheme === 'caritas' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "MMvw0L",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:info@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "w5MOit",
    defaultMessage: [{
      "type": 0,
      "value": "info@caritas.ch"
    }]
  }))), activeTheme === 'bergeinsatz' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "RIvexA",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:bergeinsatz@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "U072za",
    defaultMessage: [{
      "type": 0,
      "value": "bergeinsatz@caritas.ch"
    }]
  }))), activeTheme === 'caritascare' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "MmebnW",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:gutbetreut@caritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "6HUTu+",
    defaultMessage: [{
      "type": 0,
      "value": "gutbetreut@caritas.ch"
    }]
  }))), activeTheme === 'youngcaritas' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600',
    href: intl.formatMessage({
      id: "USKr6k",
      defaultMessage: [{
        "type": 0,
        "value": "mailto:info@youngcaritas.ch"
      }]
    })
  }, intl.formatMessage({
    id: "Yz5mpQ",
    defaultMessage: [{
      "type": 0,
      "value": "info@youngcaritas.ch"
    }]
  })))))), /*#__PURE__*/React.createElement(FooterMenu, {
    footerMenuItems: footerMenuItems
  })))));
}
function FooterMenu({
  footerMenuItems
}) {
  return /*#__PURE__*/React.createElement("ul", {
    className: 'mt-7 md:flex md:flex-wrap lg:mt-0'
  }, footerMenuItems.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    className: 'border-t border-grey-100 py-3 leading-none first:ml-0 first:border-l-0 first:border-t-0 first:pl-0 md:ml-4 md:border-l md:border-t-0 md:border-grey-200 md:py-0 md:pl-4',
    key: index
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'focus border-b border-b-transparent pb-1 text-sm text-red-500 transition-all hover:border-red-600 hover:text-red-600'
  }, title))));
}

const newlineHeadings = () => tree => {
  selectAll('h2 > strong, h3 > strong, h4 > strong, h5 > strong', tree).forEach(node => {
    node.properties = {
      class: 'block'
    };
  });
};

/**
 * Turn paragraphs that contain only a single link into a list item, so they
 * can be styled consistently with other list items.
 */
const linkParagraphsToLists = () => tree => {
  visit(tree, 'element', node => {
    if (isElement(node, 'p') && node.children.length === 1 && isElement(node.children[0], 'a')) {
      node.tagName = 'ul';
      node.properties = {
        class: 'list-none'
      };
      node.children = [{
        type: 'element',
        tagName: 'li',
        children: [{
          type: 'element',
          tagName: 'div',
          children: node.children
        }]
      }];
    }
  });
};
const headingClasses = {
  h2: 'leading-tight lg:leading-tight text-3xl lg:text-4xl tracking-[-0.01em]',
  h3: 'leading-snug lg:leading-tight text-2xl lg:text-3xl tracking-[-0.01em]',
  h4: 'leading-normal lg:leading-snug text-xl lg:text-2xl',
  h5: 'leading-normal lg:leading-snug text-lg'
};
function Prose({
  Content
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "prose mt-8 mb-5 max-w-full sm:prose-lg sm:my-10 md:prose-xl"
  }, /*#__PURE__*/React.createElement(Content, {
    plugins: [linkParagraphsToLists, listBullet, newlineHeadings],
    classNames: {
      a: `text-red-500 hover:text-red-600 font-light no-underline transition duration-300 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)] focus`,
      ul: 'list-none',
      'h2:has(strong)': clsx('font-light', headingClasses.h2),
      'h2:not(:has(strong))': clsx('font-bold', headingClasses.h2),
      'h3:has(strong)': clsx('font-light', headingClasses.h3),
      'h3:not(:has(strong))': clsx('font-bold', headingClasses.h3),
      'h4:has(strong)': clsx('font-light', headingClasses.h4),
      'h4:not(:has(strong))': clsx('font-bold', headingClasses.h4),
      'h5:has(strong)': clsx('font-light', headingClasses.h5),
      'h5:not(:has(strong))': clsx('font-bold', headingClasses.h5),
      'h2>strong': 'block mt-3 leading-none',
      strong: 'font-bold'
    }
  }));
}

function FormattedText({
  Content
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "prose my-5 max-w-full sm:prose-lg sm:my-10 md:prose-xl"
  }, /*#__PURE__*/React.createElement(Prose, {
    Content: Content
  }));
}

function FormEmbed({
  url,
  anchor,
  buildMessages,
  redirect
}) {
  const [marginValue, setMarginValue] = useState(200);
  const handleScroll = () => {
    // As soon as there's any scroll, reset the margin so styling remains unaffected.
    setMarginValue(0);
    // We don't need to listen anymore
    window.removeEventListener('wheel', handleScroll);
    window.removeEventListener('touchstart', handleScroll);
  };
  useEffect(() => {
    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchstart', handleScroll);
    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchstart', handleScroll);
    };
  }, [handleScroll]);
  return /*#__PURE__*/React.createElement("div", {
    className: "iframe-wrapper",
    id: anchor
  }, /*#__PURE__*/React.createElement(SilverbackIframe, {
    buildMessages: buildMessages,
    src: url,
    redirect: redirect,
    style: {
      width: '100%',
      minWidth: '100%',
      // We want to make sure that the form isn't in the viewport
      // when navigating to anchor links so that the scroll position is maintained
      marginBottom: `${marginValue}px`
    },
    heightCalculationMethod: "lowestElement"
  }));
}

function useSetMediaQuery() {
  const [mediaQuery, setMediaQuery] = useState('mobile');
  useEffect(() => {
    const SetMediaQuery = () => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        return 'mobile';
      }
      if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        return 'tablet';
      }
      return 'desktop';
    };
    setMediaQuery(SetMediaQuery());
    const handler = debounce(() => setMediaQuery(SetMediaQuery()));
    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [setMediaQuery]);
  return mediaQuery;
}

function FullImageStoryBlock({
  Image,
  content,
  videoUrl,
  VideoImage,
  MobileImage,
  textPosition,
  source,
  headings,
  boxStyle
}) {
  const boxRef = useRef(null);
  const viewport = useSetMediaQuery();
  const isMobile = viewport === 'mobile';
  const {
    scrollYProgress
  } = useScroll({
    target: boxRef,
    offset: ['start end', `start start`]
  });
  const y = useTransform(scrollYProgress, [0, 1], [300, 0], {
    ease: easeOut
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "relative my-10 md:my-20"
  }, /*#__PURE__*/React.createElement(motion.div, {
    transition: {
      duration: 0.7,
      ease: 'easeOut'
    },
    style: {
      opacity: 0,
      y: isMobile ? '80px' : 0
    },
    viewport: {
      once: true,
      margin: '-5% 0px'
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mobile-only:!transform-none mobile-only:!opacity-100 md:aspect-w-16 md:aspect-h-9 md:relative md:overflow-hidden'
  }, Image && !videoUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'h-[calc(100vh+75px)] bg-cover bg-center bg-no-repeat md:hidden',
    style: {
      backgroundImage: `url(${MobileImage?.src ?? Image.src})`
    }
  }), /*#__PURE__*/React.createElement(Image, {
    className: '!absolute !hidden w-full max-w-full object-cover md:!block'
  })) : null, videoUrl ? /*#__PURE__*/React.createElement("video", {
    className: 'hidden h-full min-h-[220px] w-full object-cover object-center transition duration-1000 ease-out md:block',
    width: "100%",
    height: "100%",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    poster: VideoImage?.src
  }, /*#__PURE__*/React.createElement("source", {
    src: videoUrl,
    type: 'video/mp4'
  })) : null, VideoImage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'h-[calc(100vh+75px)] bg-cover bg-center bg-no-repeat md:hidden',
    style: {
      backgroundImage: `url(${MobileImage?.src ?? VideoImage.src})`
    }
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-x-0 bottom-16 left-8 max-w-full md:left-0 md:top-8 md:bottom-[unset] md:px-7 lg:top-20 xl:top-28"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mobile-only:!transform-none md:max-w-[100rem] lg:mx-auto "
  }, /*#__PURE__*/React.createElement(motion.div, {
    ref: boxRef,
    transition: {
      duration: 0.7,
      ease: 'easeOut'
    },
    style: {
      opacity: isMobile ? 0 : 1,
      y: isMobile ? '80px' : y
    },
    viewport: {
      once: true,
      margin: '-5% 0px'
    },
    whileInView: {
      opacity: 1,
      ...(isMobile && {
        y: 0
      })
    },
    className: clsx(boxStyle, 'supports-backdrop transform-gpu rounded-tl-lg border-b-4 border-b-red-500 bg-white px-5 pt-6 pb-px backdrop-blur sm:pb-1 md:absolute md:max-w-lg md:rounded-none md:rounded-tl-xl md:bg-[rgba(255,255,255,0.85)] md:px-8 md:pt-10 lg:max-w-lg lg:px-7 lg:pt-12 lg:pb-11 xl:max-w-xl xl:px-10', {
      'left-0': textPosition !== 'right',
      'right-0': textPosition === 'right'
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "box-prose prose text-lg font-light lg:text-xl lg:leading-[1.8]"
  }, headings, /*#__PURE__*/React.createElement(Group, {
    definition: FullImageStoryContentGroup,
    input: content
  }))))))), source && /*#__PURE__*/React.createElement("p", {
    className: 'mt-1 ml-1 text-sm font-light lg:text-base'
  }, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), source)));
}

function HeaderImageCopyright({
  text
}) {
  const intl = useIntl();
  if (!text || text.trim() === '') {
    return null;
  }
  const copyrightText = intl.formatMessage({
    id: "PBlqkf",
    defaultMessage: [{
      "type": 0,
      "value": "Header image: "
    }, {
      "type": 1,
      "value": "copyright"
    }]
  }, {
    copyright: text
  });
  const Content = buildHtml(`<p>${copyrightText}</p>`);
  return /*#__PURE__*/React.createElement(FormattedText, {
    Content: Content
  });
}

function useUpdateAnchor() {
  return anchor => {
    if (typeof window !== `undefined` && typeof anchor !== `undefined`) {
      window.history.pushState(window.history.state, '', `${window.location.pathname}#${anchor}`);
    }
    return;
  };
}

function Breadcrumb({
  HomeLink,
  items
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("nav", {
    className: clsx('no-scrollbar flex select-none overflow-x-auto overflow-y-hidden bg-blue-100 p-4 md:p-5 lg:overflow-y-visible lg:p-7', {
      'hidden md:flex': items.length < 2
    }),
    "aria-label": intl.formatMessage({
      id: "g6SgtC",
      defaultMessage: [{
        "type": 0,
        "value": "Breadcrumb"
      }]
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'flex max-w-full flex-1 items-end font-light md:space-x-4'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'hidden items-baseline md:flex'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'focus group relative text-grey-600'
  }, /*#__PURE__*/React.createElement(HomeIcon, {
    className: 'absolute -top-px left-0 h-4 w-4 shrink-0',
    strokeWidth: 1.5,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(HomeIcon$1, {
    className: 'relative -top-px h-4 w-4 shrink-0 opacity-0 transition-opacity group-hover:opacity-100',
    strokeWidth: 1.5,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, intl.formatMessage({
    id: "ejEGdx",
    defaultMessage: [{
      "type": 0,
      "value": "Home"
    }]
  })))), items?.map((item, index) => /*#__PURE__*/React.createElement(BreadcrumbItem, _extends({
    key: index
  }, item)))));
}
function BreadcrumbItem({
  Link,
  title
}) {
  const separator = '/';
  return /*#__PURE__*/React.createElement("li", {
    className: 'group relative top-px flex items-baseline overflow-hidden text-ellipsis pl-5 focus-within:overflow-visible not-second-last:hidden md:overflow-visible md:text-clip md:pl-0 md:last:truncate md:focus-within:overflow-visible md:not-second-last:flex'
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden shrink-0 border-b border-transparent text-sm leading-none text-grey-600 md:block",
    "aria-hidden": "true"
  }, separator), /*#__PURE__*/React.createElement(Link, {
    className: clsx('focus ml-3 truncate border-b border-transparent text-sm leading-[1.2] text-grey-600 transition duration-300 hover:border-black hover:text-black md:ml-4')
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    className: 'absolute left-[5px] top-1/2 h-4 w-4 shrink-0 -translate-y-1/2 md:hidden'
  }), title));
}

function HeroSection$1(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('max-w-full w-full', {
      'mb-8 md:mb-16': !props.Image,
      'md:mb-24': !props.Image && props.breadcrumbItems,
      'lg:mb-16': props.urgentStyle && !(props.donation || props.climateChange),
      'lg:mb-44 xl:mb-36': !props.Image && props.breadcrumbItems || props.donation || props.climateChange,
      'pb-12 md:pb-0': props.breadcrumbItems,
      'lg:px-9': !props.fullScreenImage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('relative', {
      'flex min-h-[300px] bg-red-500 md:block md:h-[330px] lg:h-[430px]': !props.Image,
      'border-4 border-red-500 md:border-8 lg:border-[12px]': props.urgentStyle === true && props.Image,
      'container-content lg:rounded-tl-xl': !props.fullScreenImage
    })
  }, props.CallToAction ? /*#__PURE__*/React.createElement(props.CallToAction.Link, {
    className: clsx('group focus:outline-none block', {
      'flex w-full md:h-full': !props.Image
    })
  }, /*#__PURE__*/React.createElement(HeroSectionInner$1, _extends({}, props, {
    donationIsActive: !!props.donation || !!props.climateChange
  }))) : /*#__PURE__*/React.createElement(HeroSectionInner$1, _extends({}, props, {
    donationIsActive: !!props.donation || !!props.climateChange
  })), props.breadcrumbItems && props.HomeLink && !props.donation && !props.climateChange ? /*#__PURE__*/React.createElement("div", {
    className: clsx('flex justify-end', {
      relative: props.Image,
      'md:before:w-full md:before:bg-red-500 md:before:content-[""] md:before:absolute md:before:inset-0 md:before:block md:before:h-1': props.Image && !props.fullScreenImage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute w-full md:relative lg:w-5/6', {
      'top-0 lg:-top-[34px]': props.Image,
      '-bottom-12 md:top-0 lg:-top-[36px]': !props.Image
    })
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    items: props.breadcrumbItems,
    HomeLink: props.HomeLink
  }))) : null), props.donation ? /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content relative flex justify-start', {
      'md:before:w-full md:before:bg-red-500 md:before:content-[""] md:before:absolute md:before:inset-0 md:before:block md:before:h-1': props.Image && !props.fullScreenImage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'w-11/12 -translate-y-[40px] bg-blue-100 md:relative lg:absolute lg:w-5/6 lg:-translate-y-[50%]'
  }, /*#__PURE__*/React.createElement(Donation, props.donation))) : null, props.climateChange ? /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content relative flex justify-start', {
      'md:before:w-full md:before:bg-red-500 md:before:content-[""] md:before:absolute md:before:inset-0 md:before:block md:before:h-1': props.Image && !props.fullScreenImage
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'w-11/12 -translate-y-[20px] bg-blue-100 md:relative lg:absolute lg:w-5/6 lg:-translate-y-[50%]'
  }, /*#__PURE__*/React.createElement(ClimateChange, props.climateChange))) : null, /*#__PURE__*/React.createElement("div", {
    className: "hero-section-end"
  })), !!props.date && /*#__PURE__*/React.createElement(ContentDate, {
    date: props.date
  }));
}
function ContentDate({
  date
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!date && /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement("div", {
    className: 'my-5 flex items-center text-lg uppercase text-grey-500 sm:my-10'
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: date.start
  }, new Date(date.start).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  })), !!date.end && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'mx-3'
  }, ' - '), /*#__PURE__*/React.createElement("time", {
    dateTime: date.end
  }, new Date(date.end).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  }))))));
}
function HeroSectionInner$1({
  Image,
  MobileImage,
  breadcrumbItems,
  urgentStyle,
  donationIsActive = false,
  fullScreenImage = false,
  isScrollover = false,
  overviewNavigation,
  overviewNavigationHeading,
  overviewNavigationSubheading,
  showOverviewNavigation,
  ...props
}) {
  const [playAnimation, setPlayAnimation] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      relative: !isScrollover,
      'flex w-full items-center overflow-hidden py-8 md:h-full': !Image,
      'md:before:w-1/2 md:before:bg-red-500 md:before:content-[""] md:before:absolute md:before:bottom-0 md:before:block md:before:h-1': fullScreenImage && Image && (breadcrumbItems || donationIsActive),
      'md:before:right-0': fullScreenImage && Image && donationIsActive,
      'md:before:left-0': fullScreenImage && Image && !donationIsActive
    }),
    onMouseEnter: () => setPlayAnimation(true),
    onMouseLeave: () => setPlayAnimation(false)
  }, urgentStyle === true ? /*#__PURE__*/React.createElement(UrgentLabels, null) : false, !Image ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "644.766",
    height: "429.996",
    viewBox: "0 0 644.766 429.996",
    className: clsx('absolute -right-[34rem] top-0 sm:-right-[23rem] lg:-right-[18rem] xl:-right-px', {
      'xl:top-[unset] xl:bottom-[34px]': breadcrumbItems
    })
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5850.939,18669.543c30.811-158.207,92.436-303.9,180.857-430h463.908v361.707c-8.334,22.188-15.607,45.01-21.852,68.289Z",
    transform: "translate(-5850.939 -18239.547)",
    fill: "#fafafa"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'top-0 sticky h-0': isScrollover
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'fixed-background h-[calc(100vh-68px)]': !isScrollover,
      'w-full h-screen': isScrollover
    }, 'md:hidden min-h-[400px] bg-cover bg-top bg-no-repeat'),
    style: {
      backgroundImage: `url(${MobileImage?.src})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('hidden md:block fixed-background h-[calc(100vh-68px)] md:min-h-[500px] lg:min-h-[650px] xl:min-h-[700px] bg-cover bg-center bg-no-repeat', {
      'md:!hidden': !fullScreenImage || isScrollover
    }),
    style: {
      backgroundImage: `url(${Image.src})`
    }
  }), /*#__PURE__*/React.createElement(Image, {
    className: clsx('!hidden h-screen w-full bg-cover bg-center bg-no-repeat', {
      'md:!block': isScrollover,
      'lg:rounded-tl-xl': !fullScreenImage && !urgentStyle
    })
  })), /*#__PURE__*/React.createElement(Image, {
    className: clsx('!hidden h-[calc(100vh-56px)] w-full object-cover object-center md:h-[500px] lg:h-[650px]', {
      'xl:h-[700px]': !urgentStyle,
      'xl:h-[680px]': urgentStyle,
      'md:!block': !fullScreenImage && !isScrollover,
      'lg:rounded-tl-xl': !fullScreenImage && !urgentStyle
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'container-page': Image && fullScreenImage,
      relative: isScrollover
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'container-content relative': Image && fullScreenImage,
      'min-h-screen': isScrollover
    })
  }, isScrollover ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('w-full h-[80vh] min-h-[500px] lg:min-h-[600px] xl:min-h-[700px] flex flex-col justify-end pl-0 pb-40 md:pb-16 lg:pb-28', {
      'md:pb-28 lg:pb-48': Image && breadcrumbItems,
      'sm:pb-28 md:pb-40 lg:!pb-40': Image && donationIsActive,
      'pl-4 pb-32 w-11/12 md:pb-20 md:pl-12': urgentStyle
    })
  }, /*#__PURE__*/React.createElement(HeroInnerContent, _extends({}, props, {
    urgentStyle: urgentStyle,
    playAnimation: playAnimation,
    Image: Image
  }))), overviewNavigation && showOverviewNavigation && /*#__PURE__*/React.createElement(OverviewTeasers, {
    overviewNavigation: overviewNavigation,
    overviewNavigationHeading: overviewNavigationHeading,
    overviewNavigationSubheading: overviewNavigationSubheading
  })) : /*#__PURE__*/React.createElement("div", {
    className: clsx('w-full', {
      absolute: Image,
      'pl-5 bottom-40 right-0 md:pl-16 lg:pl-32': Image && !urgentStyle && !fullScreenImage,
      'sm:bottom-28 md:bottom-40 lg:!bottom-40': Image && donationIsActive,
      'md:bottom-28 lg:bottom-48': Image && breadcrumbItems,
      'md:bottom-16 lg:bottom-28': Image && !breadcrumbItems && !urgentStyle,
      'ml-4 md:ml-16 lg:ml-32': !Image,
      'pl-4 bottom-32 w-11/12 md:bottom-20 md:pl-12': urgentStyle,
      'pl-0 bottom-40': Image && fullScreenImage
    })
  }, /*#__PURE__*/React.createElement(HeroInnerContent, _extends({}, props, {
    urgentStyle: urgentStyle,
    playAnimation: playAnimation,
    Image: Image
  })))))));
}
function OverviewTeasers({
  overviewNavigationHeading,
  overviewNavigationSubheading,
  overviewNavigation
}) {
  const updateAnchor = useUpdateAnchor();
  const onTeaserClick = id => {
    updateAnchor(id);
    const element = document.getElementById(id);
    window.scrollTo({
      top: element?.offsetTop ?? 0,
      behavior: 'auto'
    });
    element?.focus();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-5 md:px-[2.75rem] py-8 md:py-[3.25rem] box-prose prose max-w-full mb-24 md:mb-36 mt-[10vh] md:mt-[20vh] cursor-default",
    onClick: e => e.preventDefault()
  }, overviewNavigationHeading && /*#__PURE__*/React.createElement("h2", {
    className: "!m-0 !pt-3 !text-2.5xl md:!text-3xl lg:!text-4xl"
  }, overviewNavigationHeading), overviewNavigationSubheading && /*#__PURE__*/React.createElement("span", {
    className: "!text-2.5xl md:!text-3xl lg:!text-4xl font-light "
  }, overviewNavigationSubheading), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap mt-12 gap-y-4 md:gap-y-[1.875rem] items-stretch sm:-mx-2 md:-mx-[.9375rem] "
  }, overviewNavigation?.map((section, index) => /*#__PURE__*/React.createElement("button", {
    className: "w-full sm:w-1/2 lg:w-1/3 1.5xl:w-1/4 sm:px-2 md:px-[.9375rem] flex flex-col items-start focus pointer-events-auto",
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
      onTeaserClick(kebabCase(section.label));
    },
    key: section.label
  }, /*#__PURE__*/React.createElement("div", {
    className: " px-5 py-7 md:px-6 md:py-8 bg-grey-300 rounded-tl-[0.9375rem] focus relative transition  after:absolute after:content-[''] after:h-[4px] after:bg-red-500 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-200 after:origin-left after:bottom-0 after:left-0 text-left h-full w-full ",
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: "not-prose"
  }, /*#__PURE__*/React.createElement("p", {
    className: "overview-item"
  }, section.label)), /*#__PURE__*/React.createElement("h3", {
    className: "mt-2 lg:mt-3 m-0 !pt-0 !text-[1.375rem] leading-normal"
  }, section.title))))));
}
function HeroInnerContent({
  title,
  description,
  CallToAction,
  Image,
  playAnimation,
  date,
  isProject
}) {
  let isEdge;
  if (typeof window !== 'undefined') {
    const {
      userAgent
    } = window.navigator;
    if (userAgent.includes('Edg/')) {
      isEdge = true;
      if (window.navigator.userAgent.indexOf('Mac OS X') != -1) {
        isEdge = false;
      }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'md:mt-3'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'ml-2.5 md:ml-4'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('max-w-[85%] md:max-w-[75%]')
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'relative block text-2xl font-bold leading-[35px] md:text-3xl md:leading-[52px] lg:text-[34px] lg:leading-[58px]'
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('relative before:absolute before:-left-2.5 before:block before:h-full before:w-8 before:rounded-tl-xl before:bg-white before:content-[""] md:before:-left-4', {
      'before:top-0': isEdge,
      'before:-top-2.5 md:before:-top-3.5 lg:before:-top-4': !isEdge
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('relative rounded-tl-lg bg-white box-decoration-clone pb-2 shadow-[11px_0_0_#fff,_-10px_0_0_#fff] md:rounded-tl-xl md:pb-2.5 md:shadow-[16px_0_0_#fff,-16px_0_0_#fff]', {
      'pt-2': isEdge,
      'pt-2.5 md:pt-3.5 lg:pt-4': !isEdge
    })
  }, title, !!isProject && !!date?.end && new Date(date?.end) < new Date() && /*#__PURE__*/React.createElement(FinishedTag, null))))), description ? /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-[5px] mb-2 md:mt-0 max-w-[85%] md:max-w-[75%]', {
      'md:mb-[0.8rem] lg:mb-[0.71rem]': Image,
      'mb-[8px] md:mb-[7px]': !Image
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('inline bg-white box-decoration-clone pt-[6px] pb-[11px] text-[19px] font-light leading-[29px] shadow-[11px_0_0_#fff,_-10px_0_0_#fff] md:pt-[9px] md:text-[21px] md:leading-relaxed md:shadow-[16px_0_0_#fff,-16px_0_0_#fff] lg:pt-2 lg:text-[26px] lg:leading-10', {
      'md:pb-4': Image
    })
  }, description)) : null), CallToAction ? /*#__PURE__*/React.createElement("div", {
    className: 'relative -top-2 inline-block max-w-[75%] bg-white p-2.5 text-[19px] font-light no-underline group-focus-visible:outline-dotted group-focus-visible:outline-2 group-focus-visible:outline-offset-[-2px] group-focus-visible:outline-red-500 md:max-w-md md:px-4 md:text-[21px] lg:-top-2.5 lg:max-w-[26rem] lg:text-[26px] 1.5xl:max-w-xl'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative top-[3px] mr-2 inline-block lg:top-0.5'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    style: {
      width: 21,
      height: 21
    },
    animationDataUrl: '/lottie/arrow_right_red.json',
    playAnimation: playAnimation
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-red-500 transition duration-300 hover:text-red-600 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)]'
  }, CallToAction.title)) : null);
}
function UrgentLabels() {
  return /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-4 left-4 z-[1] md:top-8 md:left-12'
  }, /*#__PURE__*/React.createElement("img", {
    src: '/urgentLabelGerman.png',
    alt: 'Dringend',
    className: 'mb-1.5 h-6 w-auto md:mb-2 md:h-8 lg:mb-3.5 lg:h-9'
  }), /*#__PURE__*/React.createElement("img", {
    src: '/urgentLabelEnglish.png',
    alt: 'Urgent',
    className: 'mb-1.5 h-6 w-auto md:mb-2 md:h-8 lg:mb-3.5 lg:h-9'
  }), /*#__PURE__*/React.createElement("img", {
    src: '/urgentLabelItalian.png',
    alt: 'Urgente',
    className: 'h-6 w-auto md:h-8 lg:h-9'
  }));
}
function Donation({
  Title,
  items,
  Form,
  displayCustomAmount
}) {
  const FormInner = () => {
    const intl = useIntl();
    const [activeCustomField, setActiveCustomField] = useState(false);
    const {
      values,
      setValues
    } = useFormikContext();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: 'flex flex-col gap-5 md:shrink-0 md:flex-row'
    }, /*#__PURE__*/React.createElement("fieldset", {
      className: clsx('grid gap-5 md:flex md:flex-wrap', {
        'grid-cols-1': items.length === 1 && !displayCustomAmount,
        'grid-cols-2': items.length > 1 || items.length === 1 && displayCustomAmount
      }),
      role: "group"
    }, items.map(({
      amount
    }, index) => /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        // @ts-ignore
        setValues({
          ...values,
          customAmountIsActive: false
        });
        setActiveCustomField(false);
      },
      key: index
    }, /*#__PURE__*/React.createElement(DonationField, {
      amount: amount,
      label: intl.formatMessage({
        id: "hCU9Bm",
        defaultMessage: [{
          "type": 0,
          "value": "CHF"
        }]
      }),
      fieldName: 'amount',
      isHeaderField: true,
      hasRoundedBorder: index === 0,
      inputClass: "tracking-hero-donation-widget-amount"
    }))), !!displayCustomAmount && /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        // @ts-ignore
        setValues({
          ...values,
          customAmountIsActive: true
        });
        setActiveCustomField(true);
      }
    }, /*#__PURE__*/React.createElement(DonationField, {
      amount: '0',
      label: intl.formatMessage({
        id: "hCU9Bm",
        defaultMessage: [{
          "type": 0,
          "value": "CHF"
        }]
      }),
      fieldName: 'amount',
      isCustomAmountField: true,
      customFieldName: 'customAmount',
      activeCustomField: activeCustomField,
      isHeaderField: true,
      inputClass: "tracking-hero-donation-widget-amount"
    }))), /*#__PURE__*/React.createElement("button", {
      className: 'tracking-hero-donation-widget-submit focus flex h-16 items-center justify-center rounded-tl-xl bg-red-500  px-6 font-condensed uppercase text-white transition hover:bg-red-600 md:h-20 md:rounded-tl-none',
      type: "submit"
    }, intl.formatMessage({
      id: "2IFGap",
      defaultMessage: [{
        "type": 0,
        "value": "Donate"
      }]
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'bg-blue-100 py-7 px-5 lg:px-10 xl:flex xl:items-center xl:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose mb-5 pr-10 lg:prose-xl xl:mb-0'
  }, /*#__PURE__*/React.createElement(Title, null)), /*#__PURE__*/React.createElement(Form, {
    id: "donation",
    className: 'shrink-0'
  }, /*#__PURE__*/React.createElement(FormInner, null)));
}
function ClimateChange({
  Title,
  Form,
  items,
  displayCustomAmount
}) {
  const FormInner = () => {
    const intl = useIntl();
    const [activeCustomField, setActiveCustomField] = useState(false);
    const {
      values,
      setValues
    } = useFormikContext();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: 'flex flex-col gap-5 md:shrink-0 md:flex-row'
    }, /*#__PURE__*/React.createElement("fieldset", {
      className: clsx('grid gap-5 md:flex md:flex-wrap', {
        'grid-cols-1': items.length === 1 && !displayCustomAmount,
        'grid-cols-2': items.length > 1 || items.length === 1 && displayCustomAmount
      }),
      role: "group"
    }, items.map(({
      amount
    }, index) => /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        // @ts-ignore
        setValues({
          ...values,
          customAmountIsActive: false
        });
        setActiveCustomField(false);
      },
      key: index
    }, /*#__PURE__*/React.createElement(DonationField, {
      amount: amount,
      label: parseInt(amount) > 1 ? intl.formatMessage({
        id: "mrwfXX",
        defaultMessage: [{
          "type": 0,
          "value": "Shares"
        }]
      }) : intl.formatMessage({
        id: "OKhRC6",
        defaultMessage: [{
          "type": 0,
          "value": "Share"
        }]
      }),
      fieldName: 'amount',
      isHeaderField: true,
      hasRoundedBorder: index === 0,
      inputClass: "tracking-hero-donation-widget-amount"
    }))), !!displayCustomAmount && /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        // @ts-ignore
        setValues({
          ...values,
          customAmountIsActive: true
        });
        setActiveCustomField(true);
      }
    }, /*#__PURE__*/React.createElement(DonationField, {
      amount: '1001',
      label: intl.formatMessage({
        id: "mrwfXX",
        defaultMessage: [{
          "type": 0,
          "value": "Shares"
        }]
      }),
      fieldName: 'amount',
      isCustomAmountField: true,
      customFieldName: 'customAmount',
      activeCustomField: activeCustomField,
      isHeaderField: true,
      inputClass: "tracking-hero-donation-widget-amount"
    }))), /*#__PURE__*/React.createElement("button", {
      className: 'focus flex h-16 items-center justify-center gap-2 rounded-tl-xl bg-red-500  px-6 font-condensed uppercase text-white transition hover:bg-red-600 md:h-20 md:rounded-tl-none',
      type: "submit"
    }, intl.formatMessage({
      id: "ON3hq/",
      defaultMessage: [{
        "type": 0,
        "value": "Subscribe shares"
      }]
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'bg-blue-100 py-7 px-5 lg:px-10 xl:flex xl:items-center xl:justify-between'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prose mb-5 pr-10 md:mb-0 lg:prose-xl'
  }, /*#__PURE__*/React.createElement(Title, null)), /*#__PURE__*/React.createElement(Form, {
    id: "climate-change"
  }, /*#__PURE__*/React.createElement(FormInner, null)));
}
function FinishedTag() {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("p", {
    className: 'inline-block relative ml-3 -top-px md:-top-[3px] bg-blue-500 py-1.5 px-2.5 font-condensed font-bold text-lg leading-[1.375rem] uppercase tracking-wider text-white md:ml-5 '
  }, intl.formatMessage({
    id: "T2DELw",
    defaultMessage: [{
      "type": 0,
      "value": "finished"
    }]
  }));
}

function HeroSection(props) {
  let headerTag;
  if (props.bioTag === true || props.sosTag === true) {
    headerTag = true;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('lg:max-w-full lg:px-9', {
      'mb-8 md:mb-16': !props.Image,
      'md:mb-24': !props.Image && props.breadcrumbItems,
      'pb-12 md:pb-0': props.breadcrumbItems && !headerTag,
      'pb-8 md:pb-0': props.breadcrumbItems && headerTag === true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content relative', {
      'flex min-h-[300px] bg-red-500 md:block md:h-[330px] lg:h-[430px] lg:rounded-tl-xl': !props.Image
    })
  }, props.CallToAction ? /*#__PURE__*/React.createElement(props.CallToAction.Link, {
    className: clsx('group focus:outline-none', {
      'flex w-full md:h-full': !props.Image
    })
  }, /*#__PURE__*/React.createElement(HeroSectionInner, props)) : /*#__PURE__*/React.createElement(HeroSectionInner, props), props.breadcrumbItems && props.HomeLink ? /*#__PURE__*/React.createElement("div", {
    className: clsx('flex justify-end', {
      'relative md:before:absolute md:before:inset-0 md:before:block md:before:h-1 md:before:w-full md:before:bg-red-500 md:before:content-[""]': props.Image
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('absolute w-full md:relative lg:w-5/6', {
      'top-0 lg:-top-[34px]': props.Image,
      '-bottom-12 md:top-0 lg:-top-[36px]': !props.Image,
      '-top-[27px] w-[calc(100%-20px)] md:top-0 md:w-full': headerTag === true
    })
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    items: props.breadcrumbItems,
    HomeLink: props.HomeLink
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: "hero-section-end"
  })), !!props.date && /*#__PURE__*/React.createElement(ContentDate, {
    date: props.date
  }));
}
function HeroSectionInner({
  title,
  description,
  CallToAction,
  Image,
  MobileImage,
  breadcrumbItems,
  bioTag,
  sosTag
}) {
  const [playAnimation, setPlayAnimation] = useState(false);
  let isEdge;
  if (typeof window !== 'undefined') {
    const {
      userAgent
    } = window.navigator;
    if (userAgent.includes('Edg/')) {
      isEdge = true;
      if (window.navigator.userAgent.indexOf('Mac OS X') != -1) {
        isEdge = false;
      }
    }
  }
  let headerTag;
  if (bioTag === true || sosTag === true) {
    headerTag = true;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'relative flex w-full items-center overflow-hidden py-8 md:h-full': !Image
    }),
    onMouseEnter: () => setPlayAnimation(true),
    onMouseLeave: () => setPlayAnimation(false)
  }, !Image ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "644.766",
    height: "429.996",
    viewBox: "0 0 644.766 429.996",
    className: clsx('absolute -right-[34rem] top-0 sm:-right-[23rem] lg:-right-[18rem] xl:-right-px', {
      'xl:top-[unset] xl:bottom-[34px]': breadcrumbItems
    })
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5850.939,18669.543c30.811-158.207,92.436-303.9,180.857-430h463.908v361.707c-8.334,22.188-15.607,45.01-21.852,68.289Z",
    transform: "translate(-5850.939 -18239.547)",
    fill: "#fafafa"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('fixed-background bg-cover bg-center bg-no-repeat md:hidden', {
      'h-[calc(100vh-79px)] border-b-4 border-b-red-500': headerTag === true,
      'h-[calc(100vh-56px)]': !headerTag
    }),
    style: {
      backgroundImage: `url(${MobileImage?.src ?? Image.src})`
    }
  }), /*#__PURE__*/React.createElement(Image, {
    className: '!hidden h-[calc(100vh-56px)] w-full object-cover object-center md:!block md:h-[500px] lg:h-[650px] lg:rounded-tl-xl xl:h-[700px]'
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('bottom-14 md:top-1/2 md:bottom-[unset] md:-translate-y-1/2', {
      absolute: Image,
      'left-5 bottom-8 right-0 md:left-16 lg:left-32': Image,
      'md:bottom-28 lg:bottom-48': Image && breadcrumbItems && !headerTag,
      'ml-4 md:ml-16 lg:ml-32': !Image
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'md:mt-3'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'ml-2.5 md:ml-4'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('max-w-[85%] sm:max-w-[17rem]  md:mt-0 md:max-w-md lg:max-w-[26rem] 1.5xl:max-w-xl', {
      'md:max-w-xl lg:max-w-[43rem] 1.5xl:max-w-[43rem]': headerTag === true
    })
  }, /*#__PURE__*/React.createElement("h1", {
    className: 'relative block text-2xl font-bold md:text-3xl md:leading-[52px] lg:text-[34px] lg:leading-[58px]'
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('relative before:absolute before:-left-2.5 before:block before:h-full before:w-8 before:rounded-tl-xl before:bg-white before:content-[""] md:before:-left-4', {
      'before:top-0': isEdge,
      'before:-top-2.5 md:before:-top-3.5 lg:before:-top-4': !isEdge
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('relative rounded-tl-lg bg-white box-decoration-clone pb-2 shadow-[10px_0_0_#fff,_-10px_0_0_#fff] md:rounded-tl-xl md:pb-2.5 md:shadow-[16px_0_0_#fff,-16px_0_0_#fff]', {
      'pt-2': isEdge,
      'pt-2.5 md:pt-3.5 lg:pt-4': !isEdge
    })
  }, title, bioTag === true ? /*#__PURE__*/React.createElement(BioTag, null) : false, sosTag === true ? /*#__PURE__*/React.createElement(SosTag, null) : false)))), description ? /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-1 mb-2 max-w-[75%] sm:max-w-[65%] md:mt-0 md:max-w-md lg:max-w-[26rem] 1.5xl:max-w-xl', {
      'md:mb-[0.8rem] lg:mb-[0.71rem]': Image,
      'mb-[8px] md:mb-[7px]': !Image,
      'md:max-w-xl lg:max-w-xl': headerTag === true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('inline bg-white box-decoration-clone pt-1.5 pb-[11px] text-[19px] font-light leading-[29px] shadow-[10px_0_0_#fff,_-10px_0_0_#fff] md:pt-[9px] md:text-[21px] md:leading-relaxed md:shadow-[16px_0_0_#fff,-16px_0_0_#fff] lg:pt-2 lg:text-[26px] lg:leading-10', {
      'md:pb-4': Image
    })
  }, description)) : null), CallToAction ? /*#__PURE__*/React.createElement("div", {
    className: 'relative -top-2 inline-block max-w-[75%] bg-white p-2.5 text-[19px] font-light no-underline group-focus-visible:outline-dotted group-focus-visible:outline-2 group-focus-visible:outline-offset-[-2px] group-focus-visible:outline-red-500 md:max-w-md md:px-4 md:text-[21px] lg:-top-2.5 lg:max-w-[26rem] lg:text-[26px] 1.5xl:max-w-xl'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative top-[3px] mr-2 inline-block lg:top-0.5'
  }, /*#__PURE__*/React.createElement(LottieAnimation, {
    style: {
      width: 21,
      height: 21
    },
    animationDataUrl: '/lottie/arrow_right_red.json',
    playAnimation: playAnimation
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-red-500 transition duration-300 hover:text-red-600 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)]'
  }, CallToAction.title)) : null))));
}
function BioTag() {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("span", {
    className: 'relative -top-px ml-3 bg-green-500 py-1 px-2 font-condensed text-sm uppercase tracking-wide text-white md:-top-[3px] md:ml-4 md:text-[17px] lg:-top-1'
  }, intl.formatMessage({
    id: "2W0f9h",
    defaultMessage: [{
      "type": 0,
      "value": "Bio"
    }]
  }));
}
function SosTag() {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("span", {
    className: 'relative -top-px ml-3 bg-red-500 py-1 px-2 font-condensed text-sm uppercase tracking-wide text-white md:-top-[3px] md:ml-4 md:text-[17px] lg:-top-1'
  }, intl.formatMessage({
    id: "CAe6jR",
    defaultMessage: [{
      "type": 0,
      "value": "SOS"
    }]
  }));
}

function Iframe({
  url,
  Html,
  embedType
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: `iframe-wrapper ${embedType} mb-10`
  }, Html ? /*#__PURE__*/React.createElement(Html, null) : /*#__PURE__*/React.createElement("iframe", {
    src: url,
    width: "100%",
    className: 'iframe-block'
  }));
}

function Image({
  Image,
  Description,
  orientation
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "my-8 md:my-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-0 block"
  }, /*#__PURE__*/React.createElement("figure", {
    className: clsx('image-wrapper relative mb-2 block md:mb-5', {
      'w-full lg:max-w-lg 2xl:max-w-xl': orientation === 'portrait'
    })
  }, /*#__PURE__*/React.createElement(Image, {
    className: 'max-w-full'
  }), /*#__PURE__*/React.createElement("figcaption", {
    className: "block w-full pt-2.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "block text-sm font-light lg:text-base"
  }, Description && /*#__PURE__*/React.createElement(Description, null))))));
}

function ImageCarousel({
  images,
  layout = 'horizontal'
}) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const imageRef = useRef(null);
  const [imageHeight, setImageHeight] = useState(null);
  const loopLength = images.length;
  const handleResize = useDebouncedCallback(() => setImageHeight(imageRef?.current?.clientHeight), 200);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    setImageHeight(imageRef?.current?.clientHeight);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
  return /*#__PURE__*/React.createElement("div", {
    className: "my-8 md:my-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('mx-0 block', {
      'md:w-2/3 lg:w-1/2': layout === 'vertical'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-2 md:mb-5"
  }, loopLength > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation, Pagination, A11y],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 2,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  }, images.map((carouselImage, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    key: index
  }, /*#__PURE__*/React.createElement(CarouselSlide, _extends({}, carouselImage, {
    loopIndex: index,
    loopLength: loopLength,
    imageRef: imageRef,
    layout: layout
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SliderNavigation$1, {
    prevRef: prevRef,
    nextRef: nextRef,
    imageHeight: imageHeight || 0
  }), /*#__PURE__*/React.createElement("div", {
    className: "swiper-pagination absolute mt-2 lg:mt-0",
    style: imageHeight ? {
      top: imageHeight - 50
    } : {
      bottom: 0
    }
  })))) : /*#__PURE__*/React.createElement("div", null, images.map((carouselImage, index) => /*#__PURE__*/React.createElement(CarouselSlide, _extends({
    imageRef: imageRef,
    key: index
  }, carouselImage, {
    loopIndex: index,
    loopLength: loopLength,
    layout: layout
  }))))))))));
}
function CarouselSlide(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'block'
  }, /*#__PURE__*/React.createElement(CarouselImage, props), /*#__PURE__*/React.createElement(CarouselDescription, props));
}
function CarouselImage({
  Image,
  VerticalImage,
  imageRef,
  layout = 'horizontal'
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('!relative block overflow-hidden', {
      'aspect-w-9 aspect-h-14': layout === 'vertical',
      'aspect-w-5 aspect-h-4  md:aspect-w-16 md:aspect-h-9': layout === 'horizontal'
    }),
    ref: imageRef
  }, layout === 'vertical' ? /*#__PURE__*/React.createElement(VerticalImage, {
    className: '!absolute !block w-full max-w-full object-cover'
  }) : /*#__PURE__*/React.createElement(Image, {
    className: '!absolute !block w-full max-w-full object-cover'
  }));
}
function CarouselDescription({
  Description,
  loopIndex,
  loopLength
}) {
  const slashString = '/';
  return /*#__PURE__*/React.createElement("section", {
    className: "w-full justify-between pt-2.5"
  }, Description && /*#__PURE__*/React.createElement("div", {
    className: "text-sm font-light lg:text-base"
  }, /*#__PURE__*/React.createElement(Description, null)), loopLength > 1 ? /*#__PURE__*/React.createElement("div", {
    className: "sr-only"
  }, loopIndex + 1, " ", slashString, " ", loopLength) : null);
}
function SliderNavigation$1({
  prevRef,
  nextRef,
  imageHeight
}) {
  const intl = useIntl();
  const buttonRef = useRef(null);
  const [buttonYOffset, setButtonYOffset] = useState('50%');
  const sliderButtonClasses = 'flex h-9 w-9 items-center justify-center bg-[rgba(0,0,0,0.5)] text-white transition-all duration-300 group-hover:bg-black group-focus:bg-black md:h-14 md:w-14 xl:h-16 xl:w-16';
  const sliderButtonIconClasses = 'h-5 w-5 md:h-9 md:w-9 xl:h-12 xl:w-12';
  useEffect(() => {
    if (buttonRef?.current?.clientHeight && imageHeight) {
      setButtonYOffset(`${imageHeight / 2 - buttonRef?.current.clientHeight / 2}px`);
    }
  }, [buttonRef, imageHeight]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'absolute left-0 z-10',
    style: {
      top: buttonYOffset
    }
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": intl.formatMessage({
      id: "vktN+2",
      defaultMessage: [{
        "type": 0,
        "value": "Nach links navigieren"
      }]
    }),
    className: 'focus group cursor-pointer',
    ref: prevRef
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('rounded-r-lg', sliderButtonClasses),
    ref: buttonRef
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon$1, {
    className: clsx(sliderButtonIconClasses),
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'absolute right-0 z-10',
    style: {
      top: buttonYOffset
    }
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": intl.formatMessage({
      id: "e+E3W9",
      defaultMessage: [{
        "type": 0,
        "value": "Nach rechts navigieren"
      }]
    }),
    className: 'focus group cursor-pointer',
    ref: nextRef
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('rounded-l-lg', sliderButtonClasses)
  }, /*#__PURE__*/React.createElement(ChevronRightIcon$1, {
    className: clsx(sliderButtonIconClasses),
    strokeWidth: 1.5
  })))));
}

function People() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "4",
    cy: "10.5",
    r: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4,14.5h3.5c0,2.663-0.25,4.5-2,4.95v4.05 H4H2.5v-4.05c-1.75-0.45-2-2.287-2-4.95H4z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "20",
    cy: "10.5",
    r: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20,14.5h3.5c0,2.663-0.25,4.5-2,4.95 v4.05H20h-1.5v-4.05c-1.75-0.45-2-2.287-2-4.95H20z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "2.5",
    r: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M12,6.5h3.5c0,2.663-0.25,4.5-2,4.95v4.05 H12h-1.5v-4.05c-1.75-0.45-2-2.287-2-4.95H12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  })));
}
function Barn() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "0.5",
    y1: "23.5",
    x2: "23.5",
    y2: "23.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "2.5,11 2.5,23.5 21.5,23.5 21.5,11 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "23.5,9 12,0.5 0.5,9 0.5,12.5 12.03,4 23.5,12.5 \t\t"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6.5",
    y: "13.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    width: "11",
    height: "10"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "6.5",
    y1: "13.5",
    x2: "17.5",
    y2: "23.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "17.5",
    y1: "13.5",
    x2: "6.5",
    y2: "23.5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "9",
    r: "2"
  }))));
}
function Money() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "8",
    cy: "2.5",
    rx: "7.5",
    ry: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M15.5,2.5v3 c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M15.5,5.5v3 c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "16",
    cy: "15.5",
    rx: "7.5",
    ry: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M23.5,15.5v3 c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M23.5,18.5v3 c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M15.5,8.5v3 c0,1.105-3.357,2-7.5,2c-4.142,0-7.5-0.895-7.5-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M0.5,11.5v3 c0,1.105,3.358,2,7.5,2h0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M0.5,14.5v3 c0,1.105,3.358,2,7.5,2h0.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "15.5",
    y1: "11.5",
    x2: "15.5",
    y2: "13.5"
  }))));
}
function Weather() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "2.224",
    y1: "2.224",
    x2: "3",
    y2: "3"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "12.776",
    y1: "2.224",
    x2: "12",
    y2: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M21.988,19.633 C22.909,18.9,23.5,17.77,23.5,16.5c0-1.373-0.693-2.585-1.748-3.306c0.916-2.109-0.801-4.457-3.123-4.169 C17.834,6.965,15.84,5.5,13.5,5.5c-2.877,0-5.234,2.21-5.477,5.024C5.486,10.764,3.5,12.899,3.5,15.5 c0,1.831,0.984,3.433,2.451,4.304"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "5",
    y1: "23.5",
    x2: "10",
    y2: "18.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "10",
    y1: "23.5",
    x2: "15",
    y2: "18.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "15",
    y1: "23.5",
    x2: "20",
    y2: "18.5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.174,9.723 C3.748,9.087,3.5,8.322,3.5,7.5c0-2.209,1.791-4,4-4c0.961,0,1.842,0.339,2.531,0.903"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "0.5",
    y1: "6.5",
    x2: "1.5",
    y2: "6.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "7.5",
    y1: "0.5",
    x2: "7.5",
    y2: "1.5"
  }))));
}
function Sustainability() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    width: "4",
    height: "8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,21 c10.729,3.577,6.771,3.613,19-2.5c-1.062-1.062-1.903-1.313-3-1l-4.434,1.471"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,15.5h3 c2.353,0,4,1.5,4.5,2c0,0,1.5,0,3,0c1.593,0,1.593,2,0,2H9.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M6.851,12.096 C6.307,11.015,6,9.793,6,8.5c0-4.417,3.582-8,8-8c4.417,0,8,3.583,8,8c0,2.924-1.568,5.48-3.908,6.877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M19.913,3.112 c0,0-0.348,1.911-1.739,2.606c-1.391-0.348-2.782,0.694-2.435,0.694c0.348,0,0.695,1.392,0.695,1.392c0.349,0.348,1.044,0,1.044,0 c0.869,0.869-1.392,2.436-1.392,2.783s0.87,0.521,0.347,1.044c-0.521,0.521-1.042,0.694-1.042,0.694 c0,1.739-1.74,1.739-2.087,1.739c-0.348,0-1.044-1.392-1.044-1.739s0.349-0.694,0.349-1.043c0-0.348-0.696-1.043-0.696-1.043 c0-1.392-1.043-1.044-2.087-1.044c-1.043,0-1.043-1.392-1.043-1.392s0-2.434,1.739-2.781c1.738-0.35,1.738,0.348,1.738,0.348 c0.697,0.694,2.087,0,2.783,0c0,0,0.348-2.436-0.348-2.088C14,3.632,13.376,3.361,13.305,2.588 c-0.102-1.088,3.035-1.739,3.035-1.739"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "invisible_shape"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  })));
}
function Farmer() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M9.437,15.5 l-6.341,1.754C1.534,17.84,0.5,19.332,0.5,21v2.5h23V21c0-1.668-1.034-3.16-2.596-3.746L14.583,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M9,9.502 c0-0.553,0.448-0.5,1-0.5c0.553,0,1-0.053,1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M13,9.502 c0-0.553,0.448-0.5,1-0.5c0.553,0,1-0.053,1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M17,6.373V8.5 c1.5,0,1.5,3,0,3c0,3-3.5,5.027-5,5.027S7,14.5,7,11.5c-1.5,0-1.5-3,0-3V6.373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M5.911,10.393 C3.896,9.934,2.5,9.256,2.5,8.5C2.5,7.119,6.753,6,12,6s9.5,1.119,9.5,2.5c0,0.756-1.393,1.435-3.411,1.893"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20,7.151 c-2.102-1.456-3.485-3.38-4.153-5.308C15.567,1.039,14.809,0.5,13.958,0.5h-3.915c-0.852,0-1.61,0.539-1.889,1.344 C7.485,3.771,6.102,5.695,4,7.151"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "5,23.5 6,20.5 18,20.5 19,23.5 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "5.511,16.586 6,20.5 8.5,20.5 7.988,15.901 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "18.489,16.586 18,20.5 15.5,20.5 16.012,15.901 \t\t"
  }))));
}
function Woman() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "11.5",
    cy: "4",
    r: "3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M11.5,9C8.462,9,6,13.5,6,18.5h3.5v5h4v-5 H17C17,13.5,14.537,9,11.5,9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  })));
}
function Globe() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20.5,4.255 C20.5,4.255,20,7,18,8c-2-0.5-4,1-3.5,1s1,2,1,2c0.5,0.5,1.5,0,1.5,0c1.25,1.25-2,3.5-2,4s1.25,0.75,0.5,1.5s-1.5,1-1.5,1 c0,2.5-2.5,2.5-3,2.5s-1.5-2-1.5-2.5s0.5-1,0.5-1.5s-1-1.5-1-1.5c0-2-1.5-1.5-3-1.5s-1.5-2-1.5-2s0-3.5,2.5-4s2.5,0.5,2.5,0.5 c1,1,3,0,4,0c0,0,0.5-3.5-0.5-3s-1.896,0.114-2-1C10.854,1.938,15.363,1,15.363,1"
  }))));
}
function Education() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M9.437,15.5 l-6.34,1.755C1.535,17.84,0.5,19.333,0.5,21v2.5h23V21c0-1.667-1.034-3.16-2.596-3.745L14.547,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M9,9.502 c0-0.553,0.448-0.5,1-0.5s1-0.053,1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M13,9.502 c0-0.553,0.448-0.5,1-0.5s1-0.053,1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M7,6v2.5 c-1.5,0-1.5,3,0,3c0,3,3.5,5,5,5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M17,6v2.5 c1.5,0,1.5,3,0,3c0,3-3.5,5-5,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "12,4.5 23.5,2.5 12,0.5 0.5,2.5 \t\t\t"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M7,3.631V6 c0,0,1.5,1.5,5,1.5S17,6,17,6V3.631"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "3",
    y1: "2.935",
    x2: "3",
    y2: "6.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "3,6.5 1.5,13.5 4.5,13.5 3,6.5 \t\t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: " 6.75,16.25 12,21.5 17.259,16.241 \t\t\t"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  })));
}
function Sow() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "19.5",
    y: "1.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    width: "4",
    height: "8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M19.5,2.943 c-10.729-3.576-6.771-3.614-19,2.5c1.062,1.062,1.903,1.313,3,1l6-2.173l3.792,0.917c-1.146,1.042-4.62,3.036-4.042,4.104 c0.542,1,1.057,0.414,6.062-1.668L19.438,9"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "7.531",
    y1: "12.094",
    x2: "5.578",
    y2: "14.046"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "12.557",
    y1: "11.115",
    x2: "14.552",
    y2: "13.025"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "17.792",
    y1: "13.71",
    x2: "17.317",
    y2: "16.431"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "10.592",
    y1: "15.079",
    x2: "12.517",
    y2: "17.06"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "7.473",
    y1: "16.69",
    x2: "7.637",
    y2: "19.448"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "12.673",
    y1: "20.261",
    x2: "10.436",
    y2: "21.88"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "7.896",
    y1: "22.396",
    x2: "5.212",
    y2: "21.743"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "15.216",
    y1: "19.731",
    x2: "15.893",
    y2: "22.409"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "3.352",
    y1: "17.942",
    x2: "1.757",
    y2: "20.198"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "2.354",
    y1: "9.704",
    x2: "2.754",
    y2: "12.436"
  }))));
}
function Accomodation() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "3.5,13.5 3.5,23.5 9.5,23.5 9.5,16.5 14.5,16.5 14.5,23.5 20.5,23.5 20.5,14 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "0.5,13 12,1.5 23.5,13 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "16,2.5 19.5,2.5 19.5,6 \t\t"
  }))));
}
function Child() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M10.5,21.5 c0,1.104-0.896,2-2,2h-6c-1.104,0-2-0.896-2-2v-6c0-1.104,0.896-2,2-2h6c1.104,0,2,0.896,2,2V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M23.5,21.5 c0,1.104-0.896,2-2,2h-6c-1.104,0-2-0.896-2-2v-6c0-1.104,0.896-2,2-2h6c1.104,0,2,0.896,2,2V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M16.5,9.5 c0,1.104-0.896,2-2,2h-6c-1.104,0-2-0.896-2-2v-6c0-1.104,0.896-2,2-2h6c1.104,0,2,0.896,2,2V9.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M3.5,15.5H6c0.828,0,1.5,0.672,1.5,1.5 S6.828,18.5,6,18.5H3.5V15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M3.5,18.5H6c0.828,0,1.5,0.672,1.5,1.5 S6.828,21.5,6,21.5H3.5V18.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    points: "9,9.484 11.578,3.516 14,9.484 \t\t\t"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "9.864",
    y1: "7.5",
    x2: "13.188",
    y2: "7.5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M21.061,20.621 c-0.543,0.543-1.293,0.879-2.121,0.879c-1.657,0-3-1.343-3-3s1.343-3,3-3c0.789,0,1.508,0.306,2.043,0.804"
  }))));
}
function Man() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "11.5",
    cy: "4",
    r: "3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M17,9.5H6c0,4.069,1.547,6.442,3.5,7.5 v6.5h4V17C15.451,15.942,17,13.569,17,9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  })));
}
function Meals() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M22.927,2.049l-2.646,9.237 c-1.026,0.834-2.969,0.625-4.198,0.329L20.79,1.243c0.225-0.589,0.882-0.886,1.472-0.666C22.852,0.802,23.147,1.46,22.927,2.049z "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20.77,9.235 c1.087,0.73,1.73,1.594,1.73,2.52c0,2.624-5.17,4.75-10.969,4.75S0.5,14.379,0.5,11.755c0-2.623,5.232-4.75,11.031-4.75 c2.175,0,4.261,0.299,6.019,0.811"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M0.5,11.505v2 c0,5.799,3.5,10.001,11.031,10.001S22.5,19.304,22.5,13.505v-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4,12.505 c0-1.104,0.896-2,2-2s2,0.896,2,2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M12.5,14.255 c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M10,10.505 c0-0.553,0.447-1,1-1s1,0.447,1,1"
  }))));
}
function Give() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "16.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    width: "4",
    height: "7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,22.5h17 c0-1.5-3.5-3-7.5-3H7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,17.5H8c2.353,0,3.5,1.5,4,2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M18,15.5c0,0,5.5-3.96,5.5-6.893 c0-3.384-4.5-4.455-5.5-0.34c-1-4.115-5.5-3.044-5.5,0.34C12.5,11.54,18,15.5,18,15.5z"
  })))));
}
function WomanMan() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "6.5",
    cy: "4",
    r: "3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M12,9.5H1c0,4.069,1.64,6.442,3.5,7.5v6.5 h4V17C10.359,15.942,12,13.569,12,9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    cx: "17.5",
    cy: "4",
    r: "3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M17.5,9c-3.038,0-5.5,4.5-5.5,9.5h3.5v5 h4v-5H23C23,13.5,20.538,9,17.5,9z"
  }))))));
}
function Like() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M19,15.5L19,15.5 c0.829,0,1.5,0.672,1.5,1.5c0,0.829-0.671,1.5-1.5,1.5h-1c0.829,0,1.5,0.672,1.5,1.5c0,0.829-0.671,1.5-1.5,1.5c0,0-4,0-6.5,0 c-4,0-3-2-11-2c0-0.5,0-9,0-9h3c3.5,0,7.5-3.222,7.5-8c0-1.581,3-1.781,3,1.219c0,2-1,5.781-1,5.781h8c0.829,0,1.5,0.672,1.5,1.5 c0,0.829-0.671,1.5-1.5,1.5h-1c0.829,0,1.5,0.672,1.5,1.5c0,0.829-0.671,1.5-1.5,1.5H19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  })));
}
function Water() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    width: "4",
    height: "8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,21.062 c10.5,3.5,7,3.5,19-2.5c-1.062-1.062-1.902-1.313-3-1l-4.316,1.367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M4.5,15.5h3 c2.353,0,4,2,4.5,2c0,0,1.5,0,3.5,0c1,0,1,2,0,2H10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M21,10 c0,2.563-1.936,4.5-4.5,4.5S12,12.563,12,10s4.5-8.5,4.5-8.5S21,7.437,21,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M16.5,12.5 c-1.289,0-2.333-1.045-2.333-2.333"
  }))));
}
function Harvest() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "5.5",
    y1: "0.506",
    x2: "5.5",
    y2: "23.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M3.5,3.99v4 c-2.5-1.984-3-4.484-3-7L3.5,3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M3.5,11.506v4 c-2.5-1.984-3-4.484-3-7L3.5,11.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M3.5,19.021v4 c-2.5-1.984-3-4.484-3-7L3.5,19.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M7.5,3.99v4 c2.5-1.984,3-4.484,3-7L7.5,3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M7.5,11.506v4 c2.5-1.984,3-4.484,3-7L7.5,11.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M7.5,19.021v4 c2.5-1.984,3-4.484,3-7L7.5,19.021z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "18.5",
    y1: "0.506",
    x2: "18.5",
    y2: "23.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M16.5,3.99v4 c-2.5-1.984-3-4.484-3-7L16.5,3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M16.5,11.506v4 c-2.5-1.984-3-4.484-3-7L16.5,11.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M16.5,19.021v4 c-2.5-1.984-3-4.484-3-7L16.5,19.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20.5,3.99v4 c2.5-1.984,3-4.484,3-7L20.5,3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20.5,11.506v4 c2.5-1.984,3-4.484,3-7L20.5,11.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M20.5,19.021v4 c2.5-1.984,3-4.484,3-7L20.5,19.021z"
  }))));
}
const IconMap = {
  people: /*#__PURE__*/React.createElement(People, null),
  barn: /*#__PURE__*/React.createElement(Barn, null),
  money: /*#__PURE__*/React.createElement(Money, null),
  weather: /*#__PURE__*/React.createElement(Weather, null),
  sustainability: /*#__PURE__*/React.createElement(Sustainability, null),
  farmer: /*#__PURE__*/React.createElement(Farmer, null),
  woman: /*#__PURE__*/React.createElement(Woman, null),
  globe: /*#__PURE__*/React.createElement(Globe, null),
  education: /*#__PURE__*/React.createElement(Education, null),
  sow: /*#__PURE__*/React.createElement(Sow, null),
  accomodation: /*#__PURE__*/React.createElement(Accomodation, null),
  child: /*#__PURE__*/React.createElement(Child, null),
  man: /*#__PURE__*/React.createElement(Man, null),
  meals: /*#__PURE__*/React.createElement(Meals, null),
  give: /*#__PURE__*/React.createElement(Give, null),
  womanMan: /*#__PURE__*/React.createElement(WomanMan, null),
  like: /*#__PURE__*/React.createElement(Like, null),
  water: /*#__PURE__*/React.createElement(Water, null),
  harvest: /*#__PURE__*/React.createElement(Harvest, null)
};

function formatNumber$1(x) {
  return x.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
}
function ImpactCommunication({
  Title,
  items
}) {
  const viewport = useSetMediaQuery();
  return /*#__PURE__*/React.createElement(React.Fragment, null, Title ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-2 md:mb-5'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: clsx('my-10 grid grid-cols-1 gap-10', {
      'lg:grid-cols-2': items.length === 2,
      'lg:grid-cols-3': items.length === 3,
      'lg:grid-cols-2 xl:grid-cols-4': items.length === 4
    })
  }, items.map((item, index) => /*#__PURE__*/React.createElement(motion.div, {
    key: index,
    className: clsx('box box-border w-full rounded-tl-lg', {
      'bg-[#FCF1E7]': index === 0,
      'bg-yellow-100': index === 1,
      'bg-[#F6F8E7]': index === 2,
      'bg-green-100': index === 3
    }),
    transition: {
      duration: 1,
      ease: 'easeOut'
    },
    style: {
      opacity: 0,
      y: 80
    },
    viewport: {
      once: true,
      margin: '-15% 0px'
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  }, /*#__PURE__*/React.createElement(ImpactCommunicationItem, _extends({}, item, {
    animationDelay: viewport === 'mobile' || viewport === 'tablet' ? 0 : index * 0.5
  }))))));
}
function ImpactCommunicationItem({
  description,
  icon,
  number,
  metric,
  actuality,
  animationDelay
}) {
  const isInteger = Number.isInteger(Number(number));
  const ref = useRef(null);
  const isBoxInView = useInView(ref, {
    margin: '-15% 0px'
  });
  const count = useMotionValue(0);
  const formattedNumber = useTransform(count, latest => formatNumber$1(isInteger ? Math.round(latest).toString() : latest.toFixed(2).toString()));
  useEffect(() => {
    if (isBoxInView) animate(count, Number(number), {
      duration: 1.5,
      delay: animationDelay,
      ease: 'easeOut'
    });
  }, [isBoxInView]);
  const Icon = icon ? IconMap[icon] : undefined;
  const actualityText = `(${actuality})`;
  return /*#__PURE__*/React.createElement("div", {
    className: 'p-7 text-center flex flex-col h-full',
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex items-center justify-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-20 w-20"
  }, Icon)), /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-5 mt-8 leading-none', {
      'flex items-center justify-center gap-2': metric
    })
  }, /*#__PURE__*/React.createElement(motion.h3, {
    "data-number": number,
    className: 'text-4xl font-bold'
  }, formattedNumber), metric ? /*#__PURE__*/React.createElement("span", {
    className: 'text-xl font-bold'
  }, metric) : null), /*#__PURE__*/React.createElement("p", {
    className: 'grow relative mx-auto max-w-4xl pt-2 after:rounded-sm font-light after:absolute after:-top-3 after:left-1/2 after:h-1 after:w-6 after:-translate-x-1/2 after:bg-red-500 after:content-[""]'
  }, description), actuality ? /*#__PURE__*/React.createElement("p", {
    className: 'pt-5 font-light text-sm text-center mt-auto'
  }, actualityText) : null);
}

function LogoCloudBlock({
  logos
}) {
  const intl = useIntl();
  const getLocalisedLink = links => {
    return links.reduce((accumulator, current) => {
      // We found a perfect match, so we update the accumulator.
      if (current.langcode === intl.locale) {
        accumulator = current;
      }
      // The accumulator does not have yet a perfect match, but we found the
      // english version of the link, so we change the value in the accumulator
      // (that means we'd fallback to english if no other better match gets
      // found).
      if (current.langcode === 'en' && accumulator?.langcode !== intl.locale) {
        accumulator = current;
      }
      return accumulator;
    }, links[0]);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10 grid grid-cols-2 gap-7 md:grid-cols-3'
  }, logos.map(({
    Image,
    links,
    description
  }, index) => {
    const linkDetails = links ? getLocalisedLink(links) : undefined;
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, linkDetails ? /*#__PURE__*/React.createElement("a", {
      href: linkDetails.url,
      target: '_blank',
      className: 'focus block',
      rel: "noreferrer",
      title: linkDetails.title
    }, /*#__PURE__*/React.createElement(Image, {
      className: 'h-auto w-full max-w-full'
    })) : /*#__PURE__*/React.createElement(Image, {
      className: 'h-auto w-full max-w-full'
    }), description ? /*#__PURE__*/React.createElement("p", {
      className: 'mt-2'
    }, description) : null);
  }));
}

function formatNumber(x) {
  return x.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
}
function PetitionTool({
  number,
  description
}) {
  const numberRef = useRef(null);
  const intl = useIntl();
  const isInteger = Number.isInteger(Number(number));
  const isBoxInView = useInView(numberRef, {
    margin: '-15% 0px'
  });
  const count = useMotionValue(0);
  const formattedNumber = useTransform(count, latest => formatNumber(isInteger ? Math.round(latest).toString() : latest.toFixed(2).toString()));
  useEffect(() => {
    if (isBoxInView) animate(count, Number(number), {
      duration: 1,
      ease: 'easeOut'
    });
  }, [isBoxInView]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10 bg-blue-600 text-white md:p-10 px-5 py-10 rounded-tl-lg text-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex justify-center items-center md:gap-x-6 gap-x-4')
  }, /*#__PURE__*/React.createElement(motion.span, {
    "data-number": number,
    ref: numberRef,
    className: 'text-6xl font-bold'
  }, formattedNumber), /*#__PURE__*/React.createElement("span", {
    className: 'text-lg md:text-xl font-bold pb-2'
  }, intl.formatMessage({
    id: "JZnNTW",
    defaultMessage: [{
      "type": 0,
      "value": "Persons"
    }]
  }))), /*#__PURE__*/React.createElement("p", {
    className: 'text-lg md:text-xl relative mx-auto max-w-2xl pt-10 font-light after:absolute after:top-3 after:left-1/2 after:rounded-sm after:h-1 after:w-6 after:-translate-x-1/2 after:bg-red-500 after:content-[""]'
  }, description));
}

function SocialMenu({
  items
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-wrap gap-5'
  }, items?.map((item, index) => /*#__PURE__*/React.createElement(SocialMenuItem, _extends({
    key: index
  }, item))));
}
function SocialMenuItem({
  Link,
  type
}) {
  return /*#__PURE__*/React.createElement(Link, {
    "aria-label": type,
    className: 'focus relative top-0 transition-all ease-linear hover:text-red-500 hover:top-1'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, type !== 'twitter' ? type : 'Twitter / X'), type == 'facebook' ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.158 26",
    fill: "none",
    className: 'h-7'
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.036,26h0a13.082,13.082,0,1,1,4.088,0V16.86h3.048l.58-3.781H15.123V10.625a2.114,2.114,0,0,1,.457-1.408,2.109,2.109,0,0,1,1.675-.633H18.9V5.365a20.317,20.317,0,0,0-2.927-.256,4.933,4.933,0,0,0-3.59,1.314,5.2,5.2,0,0,0-1.35,3.775v2.881H7.714V16.86h3.322V26Z",
    fill: "currentColor"
  })) : null, type == 'twitter' || type == 'x' ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-6 relative top-0.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5387 0H19.7589L12.7238 8.04821L21 19H14.5198L9.44429 12.3578L3.63674 19H0.414686L7.93935 10.3915L0 0H6.64467L11.2325 6.07123L16.5387 0ZM15.4086 17.0708H17.1929L5.67513 1.8279H3.76037L15.4086 17.0708Z",
    fill: "currentColor"
  })) : null, type == 'youtube' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5169 2.51289C25.7681 1.18197 24.9566 0.937424 23.3032 0.844368C21.652 0.736163 17.498 0.685303 13.9002 0.685303C10.3023 0.685303 6.13969 0.731827 4.48631 0.842197C2.83294 0.952566 2.02248 1.1798 1.26721 2.51289C0.511937 3.84598 0.104004 6.13127 0.104004 10.163V10.1771C0.104004 14.1904 0.500035 16.4973 1.27154 17.8131C2.04304 19.1289 2.83835 19.3853 4.48848 19.4978C6.1386 19.6104 10.2948 19.6515 13.9023 19.6515C17.5099 19.6515 21.6541 19.5941 23.3075 19.5C24.9609 19.3918 25.7735 19.1462 26.5212 17.8153C27.2992 16.4995 27.692 14.1926 27.692 10.1792V10.1641C27.6898 6.13127 27.296 3.84165 26.5169 2.51289ZM10.4484 15.3406V4.9962L19.0691 10.1684L10.4484 15.3406Z",
    fill: "currentColor"
  })) : null, type == 'instagram' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    viewBox: "0 0 420 419.997",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M388.818,146.28a24.3,24.3,0,1,1-24.295-24.295A24.3,24.3,0,0,1,388.818,146.28ZM466,256l-0.005.306-1.38,88.105a121.58,121.58,0,0,1-120.2,120.2L256,466l-0.306-.006-88.105-1.376a121.586,121.586,0,0,1-120.206-120.2L46,256l0.006-.306,1.376-88.108a121.59,121.59,0,0,1,120.206-120.2L256,46l0.306,0.006,88.105,1.376a121.584,121.584,0,0,1,120.2,120.2Zm-39.112,0-1.374-87.8A82.654,82.654,0,0,0,343.8,86.485L256,85.114l-87.8,1.371A82.658,82.658,0,0,0,86.484,168.2L85.113,256l1.371,87.8A82.655,82.655,0,0,0,168.2,425.515l87.8,1.371,87.8-1.371A82.651,82.651,0,0,0,425.514,343.8Zm-63.048,0A107.841,107.841,0,1,1,256,148.159,107.962,107.962,0,0,1,363.84,256Zm-39.107,0A68.734,68.734,0,1,0,256,324.734,68.812,68.812,0,0,0,324.732,256Z",
    transform: "translate(-46 -46.001)"
  })) : null, type == 'linkedin' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88907 15.2773H0.650506V5.4444H3.88907V15.2773ZM10.6194 8.64205C9.83309 8.64205 9.18671 9.32676 9.18671 10.1597V15.2773H5.78156V5.4444H9.18671V6.56676C9.98636 5.85381 10.9926 5.45146 12.0388 5.43734C14.1512 5.43734 15.6172 7.09617 15.6172 10.2444V15.2773H12.0388V10.1597C12.0388 9.32676 11.4057 8.64911 10.6194 8.64205ZM3.94904 2.04205C3.94904 3.01617 3.20271 3.80676 2.28311 3.80676C1.36352 3.80676 0.617188 3.01617 0.617188 2.04205C0.617188 1.06793 1.36352 0.277344 2.28311 0.277344C3.19604 0.284403 3.94904 1.07499 3.94904 2.04205Z",
    fill: "currentColor"
  })) : null, type == 'tiktok' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    viewBox: "0 0 23.581 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.041,1.25a.907.907,0,0,0-.907.907v16.93a2.721,2.721,0,1,1-2.721-2.721.907.907,0,0,0,.907-.907V11.831a.907.907,0,0,0-.907-.907,8.163,8.163,0,1,0,8.163,8.163V12.094a11.739,11.739,0,0,0,6.349,1.854.907.907,0,0,0,.907-.907V9.413a.907.907,0,0,0-.907-.907,6.349,6.349,0,0,1-6.349-6.349.907.907,0,0,0-.907-.907Z",
    transform: "translate(-1.25 -1.25)",
    fill: "currentColor"
  })) : null, type == 'spotify' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    viewBox: "0 0 26.001 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.078,18.315v-.008a.981.981,0,0,0-.5-.857l-.005,0a14.339,14.339,0,0,0-7.262-1.95c-.107,0-.213,0-.321,0H11a22.711,22.711,0,0,0-5.012.606l.154-.03a.815.815,0,0,0-.714.808c0,.026,0,.051,0,.076v.01a.825.825,0,0,0,.23.572.778.778,0,0,0,.569.246h.033a4.915,4.915,0,0,0,.662-.144l-.035.009a20.08,20.08,0,0,1,4.1-.457h.011c.081,0,.178,0,.274,0a12.714,12.714,0,0,1,6.505,1.779l-.059-.033a1.148,1.148,0,0,0,.556.186h0a.8.8,0,0,0,.8-.8v-.018h0Zm1.625-3.64V14.64a1.135,1.135,0,0,0-.587-.995l-.005,0A17.6,17.6,0,0,0,11.2,11.252c-.128,0-.257,0-.384,0h.019A18.916,18.916,0,0,0,5.575,12l.133-.034a1.017,1.017,0,0,0-.816,1,.86.86,0,0,0,0,.092v0a1.012,1.012,0,0,0,1.012,1.012h0a3.777,3.777,0,0,0,.653-.142l-.026.008a15.809,15.809,0,0,1,4.219-.559h.028c.107,0,.234,0,.362,0a15.813,15.813,0,0,1,7.974,2.144l-.076-.041a1.46,1.46,0,0,0,.637.22H19.7a1.012,1.012,0,0,0,1.012-1.012v0Zm1.831-4.2c0-.016,0-.037,0-.056A1.279,1.279,0,0,0,21.863,9.3l-.007,0a17.126,17.126,0,0,0-4.845-1.849L16.9,7.423a25.757,25.757,0,0,0-5.755-.635h-.051l-.308,0a21.9,21.9,0,0,0-6.008.835l.154-.038a1.347,1.347,0,0,0-.65.431l0,0a1.23,1.23,0,0,0-.261.76c0,.022,0,.042,0,.064v.028a1.206,1.206,0,0,0,.348.849,1.163,1.163,0,0,0,.84.355h.033a3.039,3.039,0,0,0,.7-.142l-.022.006A18.981,18.981,0,0,1,10.82,9.31l.309,0h.032a23.785,23.785,0,0,1,5.351.607l-.159-.031a14.787,14.787,0,0,1,4.364,1.646l-.073-.038a1.356,1.356,0,0,0,.675.2h.013a1.191,1.191,0,0,0,.843-.347,1.15,1.15,0,0,0,.361-.837c0-.013,0-.025,0-.038v0ZM26,13v.1a12.652,12.652,0,0,1-1.777,6.486l.033-.059a13.049,13.049,0,0,1-4.67,4.7l-.061.033a13.095,13.095,0,0,1-13.114-.034l.062.034a13.049,13.049,0,0,1-4.7-4.67l-.033-.061A13.095,13.095,0,0,1,1.776,6.411l-.034.062a13.049,13.049,0,0,1,4.67-4.7l.061-.033a13.095,13.095,0,0,1,13.114.034l-.062-.034a13.049,13.049,0,0,1,4.7,4.67l.033.061A12.573,12.573,0,0,1,26,12.9V13Z",
    transform: "translate(0.001 0.001)",
    fill: "currentColor"
  })) : null, type == 'flickr' ? /*#__PURE__*/React.createElement("svg", {
    className: 'h-7',
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 362.68 362.68"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "85.8",
    cy: "181.34",
    r: "85.8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "276.88",
    cy: "181.34",
    r: "85.8"
  }))) : null);
}

function PreFooter({
  quickLinksMenu,
  socialMenuLinks,
  donationSection,
  NewsletterForm
}) {
  const intl = useIntl();
  const {
    iban,
    CertificateLink,
    donationMenu
  } = donationSection;
  const activeTheme = useActiveTheme();
  const twintButtonLink = {
    caritas: 'https://donate.raisenow.io/wtjbb',
    youngcaritas: 'https://donate.raisenow.io/jmsfb',
    bergeinsatz: 'https://donate.raisenow.io/thqdz',
    caritascare: 'https://donate.raisenow.io/wtjbb'
  };
  useEffect(() => {
    // This component is includes ConvertFlow embeds
    // and we need to reinitialise on first render
    // @ts-ignore
    if (window.convertflow !== undefined) {
      try {
        // @ts-ignore
        window.convertflow.start();
      } catch (error) {
        console.error(error);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page bg-grey-300 py-10 md:py-16 lg:py-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mb-11 border-b border-blue-300 md:mb-0 md:w-[37%] md:shrink-0 md:border-b-0 md:border-r md:pr-[3.5%] lg:w-1/3 lg:w-1/3 2xl:pr-[5%]"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mb-6 font-bold uppercase tracking-widest lg:text-[1.15rem]"
  }, intl.formatMessage({
    id: "Oc4Fge",
    defaultMessage: [{
      "type": 0,
      "value": "Donate now"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'flex items-start justify-between'
  }, /*#__PURE__*/React.createElement("div", null, iban ? /*#__PURE__*/React.createElement("p", {
    className: 'mb-4 text-lg md:text-xl font-light'
  }, intl.formatMessage({
    id: "+SgU+0",
    defaultMessage: [{
      "type": 0,
      "value": "IBAN"
    }]
  }), ' ', /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: iban
    }
  })) : null, /*#__PURE__*/React.createElement("a", {
    className: 'focus relative top-0 block w-full max-w-[275px] transition-all ease-linear hover:top-1 hover:opacity-80',
    href: twintButtonLink[activeTheme],
    target: '_blank',
    rel: "noreferrer"
  }, !['de', 'fr', 'it'].includes(intl.locale) && /*#__PURE__*/React.createElement("img", {
    className: 'mb-7 h-auto w-full',
    src: '/button_paylink_donate_EN.png',
    alt: intl.formatMessage({
      id: "tu9xrs",
      defaultMessage: [{
        "type": 0,
        "value": "Donate with TWINT"
      }]
    })
  }), intl.locale === 'de' && /*#__PURE__*/React.createElement("img", {
    className: 'mb-7 h-auto w-full',
    src: '/button_paylink_donate_DE.png',
    alt: intl.formatMessage({
      id: "mavd04",
      defaultMessage: [{
        "type": 0,
        "value": "Mit TWINT spenden"
      }]
    })
  }), intl.locale === 'fr' && /*#__PURE__*/React.createElement("img", {
    className: 'mb-7 h-auto w-full',
    src: '/button_paylink_donate_FR.png',
    alt: intl.formatMessage({
      id: "eEnnei",
      defaultMessage: [{
        "type": 0,
        "value": "Faites un don avec TWINT"
      }]
    })
  }), intl.locale === 'it' && /*#__PURE__*/React.createElement("img", {
    className: 'mb-7 h-auto w-full',
    src: '/button_paylink_donate_IT.png',
    alt: intl.formatMessage({
      id: "ilkxk2",
      defaultMessage: [{
        "type": 0,
        "value": "Dona con TWINT"
      }]
    })
  }), /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, intl.formatMessage({
    id: "QGMUV+",
    defaultMessage: [{
      "type": 0,
      "value": "Donate with Twint"
    }]
  }))), donationMenu && /*#__PURE__*/React.createElement("ul", {
    className: 'xl:max-w-[290px]'
  }, donationMenu.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: 'mb-4 last:mb-0'
  }, /*#__PURE__*/React.createElement(Link, {
    key: index,
    className: 'focus relative left-0 flex items-start text-sm font-bold tracking-widest text-red-500 transition-all duration-300 hover:left-1 hover:text-red-600'
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'mr-2.5 h-4 w-4 shrink-0'
  }), title)))), /*#__PURE__*/React.createElement(CertificateLink, {
    className: 'focus block'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'mb-11 mt-8 h-20 w-20 md:mb-0 lg:mt-8',
    src: '/Zewo_Logo_D.svg',
    alt: intl.formatMessage({
      id: "j4OG5m",
      defaultMessage: [{
        "type": 0,
        "value": "Zewo certified"
      }]
    })
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-blue-300 pb-12 md:w-[33%] md:shrink-0 md:border-r md:border-b-0 md:px-[4.5%] md:pb-0 lg:w-1/3 2xl:px-[6%]"
  }, NewsletterForm && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "mb-6 font-bold uppercase tracking-widest lg:text-[1.15rem]"
  }, intl.formatMessage({
    id: "il3/qR",
    defaultMessage: [{
      "type": 0,
      "value": "Subscribe to newsletter"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-6 min-h-[65px]"
  }, /*#__PURE__*/React.createElement(NewsletterForm, null))), /*#__PURE__*/React.createElement("h3", {
    className: "mb-6 font-bold uppercase tracking-widest lg:text-[1.15rem]"
  }, activeTheme === 'caritas' && intl.formatMessage({
    id: "zWKTRP",
    defaultMessage: [{
      "type": 0,
      "value": "Follow Caritas"
    }]
  }), activeTheme === 'bergeinsatz' && intl.formatMessage({
    id: "Vb3zXG",
    defaultMessage: [{
      "type": 0,
      "value": "Follow Caritas Bergeinsatz"
    }]
  }), activeTheme === 'youngcaritas' && intl.formatMessage({
    id: "B+XD2k",
    defaultMessage: [{
      "type": 0,
      "value": "Follow youngCaritas"
    }]
  })), /*#__PURE__*/React.createElement(SocialMenu, {
    items: socialMenuLinks
  })), /*#__PURE__*/React.createElement("div", {
    className: "md:w-[30%] md:shrink-0 md:pl-[5%] lg:w-1/3 lg:pl-[7%]"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mb-6 mt-11 font-bold uppercase tracking-widest md:mt-0 md:mb-8 lg:text-[1.15rem]"
  }, intl.formatMessage({
    id: "RiXtkb",
    defaultMessage: [{
      "type": 0,
      "value": "Related links"
    }]
  })), /*#__PURE__*/React.createElement("ul", null, quickLinksMenu.map(({
    title,
    Link
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: 'mb-4 last:mb-0'
  }, /*#__PURE__*/React.createElement(Link, {
    className: 'focus relative left-0 flex items-start text-sm font-bold tracking-widest text-red-500 transition-all duration-300 hover:left-1 hover:text-red-600'
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    className: 'mr-2.5 h-4 w-4 shrink-0'
  }), title)))))));
}

function RawHtml({
  Html
}) {
  useEffect(() => {
    // This component is currently used only for ConvertFlow embeds
    // and we need to reinitialise on first render

    // @ts-ignore
    if (window.convertflow !== undefined) {
      try {
        // @ts-ignore
        window.convertflow.start();
      } catch (error) {
        console.error(error);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-5 sm:my-10'
  }, /*#__PURE__*/React.createElement(Html, null));
}

const useScrolloverStore = create(set => ({
  latestSectionInView: undefined,
  updateLatestSectionInView: latestSectionInView => {
    set({
      latestSectionInView
    });
  },
  sectionsStatus: undefined,
  setSections: sections => {
    set({
      sectionsStatus: sections.reduce((acc, section) => {
        acc[kebabCase(section)] = false;
        return acc;
      }, {})
    });
  },
  updateSectionStatus: (sectionId, isInView) => {
    set(state => {
      return {
        sectionsStatus: {
          ...state.sectionsStatus,
          [sectionId]: isInView
        }
      };
    });
  },
  lastSection: undefined,
  setLastSection: lastSection => {
    set({
      lastSection
    });
  }
}));

function ScrolloverPageMenu({
  sections
}) {
  const intl = useIntl();
  const latestSectionInView = useScrolloverStore(state => state.latestSectionInView);
  const sectionsStatus = useScrolloverStore(state => state.sectionsStatus);
  const [clickedSection, setClickedSection] = useState({
    clicked: false,
    section: undefined
  });
  const updateAnchor = useUpdateAnchor();
  useEffect(() => {
    if (clickedSection?.clicked && clickedSection?.section) {
      updateAnchor(clickedSection.section);
      const element = document.getElementById(clickedSection.section);
      window.scrollTo({
        top: element?.offsetTop ?? 0,
        behavior: 'auto'
      });
      element?.focus();
      setClickedSection(prev => ({
        ...prev,
        clicked: false
      }));
    }
  }, [clickedSection?.clicked]);

  //check if any section is in view
  const isAnySectionInView = Object.values(sectionsStatus ?? {}).some(section => section);
  const defaultLabel = intl.formatMessage({
    id: "gjyzc7",
    defaultMessage: [{
      "type": 0,
      "value": "Table of contents"
    }]
  });

  // 1. check if any section is in view
  // 2. if it's the latestSectionInView that registered in view -> check if it's still in view
  // 3. if the latest section observed is not in view anymore -> check if any other section is in view (the case intersecting sections)
  // 4. if no section is in view -> show default label
  const menuLabel = isAnySectionInView && latestSectionInView ? sectionsStatus?.[latestSectionInView.id] ? latestSectionInView.label : Object.entries(sectionsStatus ?? {}).find(([, value]) => value)?.[0] ?? defaultLabel : defaultLabel;
  return /*#__PURE__*/React.createElement(Disclosure, null, ({
    open,
    close
  }) => /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Table of contents",
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content relative "
  }, /*#__PURE__*/React.createElement(MenuButton, {
    open: false,
    title: menuLabel
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait"
  }, open && /*#__PURE__*/React.createElement(Disclosure.Panel, {
    className: `bg-red-500 absolute bottom-[1.875rem] md:bottom-auto md:top-[1.875rem] right-0 rounded-tl-xl z-[3000] overflow-hidden`,
    as: motion.div,
    initial: "closed",
    animate: "open",
    exit: 'closed',
    variants: {
      closed: {
        height: 0,
        width: 0
      },
      open: {
        height: 'auto',
        width: 'auto'
      }
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.1
    },
    static: true
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: 'flex flex-col overflow-hidden relative md:block',
    key: "content",
    initial: "closed",
    animate: "open",
    exit: "closed",
    variants: {
      closed: {
        opacity: 0,
        transition: {
          duration: 0.1,
          ease: 'easeInOut'
        }
      },
      open: {
        opacity: 1,
        transition: {
          duration: 0.2,
          delay: 0.35,
          ease: 'easeInOut'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(MenuButton, {
    open: true,
    title: intl.formatMessage({
      id: "gjyzc7",
      defaultMessage: [{
        "type": 0,
        "value": "Table of contents"
      }]
    }),
    className: "z-[3000] !bottom-0 md:!top-0 md:!bottom-auto"
  }), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-col gap-5 md:gap-7 items-start pt-12 pl-7 pr-20 md:!pt-[6.5rem] md:pl-[3.75rem] md:pr-[6.5rem] grow pb-[5rem] text-left"
  }, sections.map(section => {
    const id = kebabCase(section);
    return /*#__PURE__*/React.createElement("li", {
      key: id
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => {
        setClickedSection({
          clicked: true,
          section: id
        });
        close();
      },
      className: 'text-white text-xl font-bold md:text-[1.375rem] transition-all ease-in-out duration-200 focus text-left'
    }, section));
  }))))))));
}
const MenuButton = ({
  open,
  title,
  className
}) => {
  const intl = useIntl();
  const [ref, {
    width
  }] = useMeasure();
  return /*#__PURE__*/React.createElement(Disclosure.Button, {
    animate: {
      width: width || 'auto'
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    },
    as: motion.button,
    className: clsx(className, {
      'hover:bg-red-600': !open
    }, 'bg-red-500 rounded-tl-xl ml-auto focus self-end text-white bottom-[1.875rem] md:bottom-auto md:top-[1.875rem] right-0 flex absolute z-[2909] cursor-pointer overflow-hidden')
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, open ? intl.formatMessage({
    id: "Lnreb5",
    defaultMessage: [{
      "type": 0,
      "value": "Close table of contents"
    }]
  }) : intl.formatMessage({
    id: "HLprRI",
    defaultMessage: [{
      "type": 0,
      "value": "Open table of contents"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative text-white text-[15px] md:text-base flex flex-row gap-2 items-center right-0 uppercase text-left font-condensed py-5 pl-5 pr-[1.75rem] whitespace-nowrap',
    ref: ref
  }, title, open ? /*#__PURE__*/React.createElement(XIcon, {
    className: "h-6 w-6 text-white"
  }) : /*#__PURE__*/React.createElement(MenuAlt1Icon, {
    className: "h-6 w-6 text-white"
  })));
};

// import ScrolloverPageMenu from './ScrolloverPageMenu';

function HeaderDesktop({
  HomeLink
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-content relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute top-0 left-0'
  }, /*#__PURE__*/React.createElement(HomeLink, {
    className: 'logo focus absolute z-[1010] left-0 w-[270px] h-[100px] bg-white flex items-center justify-center rounded-bl-xl'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'h-7',
    src: '/caritas-logo1.svg',
    alt: intl.formatMessage({
      id: "gxfl/7",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Schweiz"
      }]
    })
  }))));
}
function ScrolloverPageHeader({
  HomeLink,
  sections,
  backButton,
  showMenu = true
}) {
  const setSections = useScrolloverStore(state => state.setSections);
  const setLastSection = useScrolloverStore(state => state.setLastSection);
  useEffect(() => {
    if (sections && sections?.length > 0) {
      setSections(sections);
      setLastSection(kebabCase(sections[sections.length - 1]) ?? '');
    }
  }, [sections]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement(HeaderDesktop, {
    HomeLink: HomeLink
  })), sections && showMenu ? /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 inset-x-0 md:sticky md:top-0 z-[3000]"
  }, /*#__PURE__*/React.createElement(ScrolloverPageMenu, {
    sections: sections
  })) : null, !showMenu && /*#__PURE__*/React.createElement("div", {
    className: " fixed bottom-0 z-[3000] right-0 md:top-0 h-fit md:sticky"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative container-content"
  }, /*#__PURE__*/React.createElement(BackButton, {
    backButton: backButton,
    className: "absolute bottom-[1.875rem] md:bottom-auto md:top-[1.875rem] right-0 "
  })))));
}

function ScrolloverSectionItem({
  cover,
  sectionContent
}) {
  const id = kebabCase(cover.label);
  return /*#__PURE__*/React.createElement("section", {
    id: id,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(SectionContent, _extends({}, cover, {
    sectionContent: sectionContent
  })));
}
const SectionContent = ({
  Image,
  content,
  videoUrl,
  VideoImage,
  MobileImage,
  textPosition,
  label,
  title,
  sectionContent,
  source
}) => {
  const ref = useRef(null);
  const viewport = useSetMediaQuery();
  const isMobile = viewport === 'mobile';
  const isSectionInView = useInView(ref, {
    margin: '-15% 0px'
  });
  const {
    updateLatestSectionInView,
    updateSectionStatus,
    lastSection
  } = useScrolloverStore();
  const id = kebabCase(label);
  const isLast = lastSection === id;
  useEffect(() => {
    if (label && id) {
      if (isSectionInView) updateLatestSectionInView({
        id,
        label
      });
      updateSectionStatus(id, isSectionInView);
    }
  }, [isSectionInView, label]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'h-0': !isLast
    }, 'sticky top-0')
  }, Image && !videoUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative !hidden md:!block"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "!hidden md:!block h-screen max-h-screen w-full bg-cover bg-center bg-no-repeat"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'block md:hidden h-screen max-h-screen w-full bg-cover bg-center bg-no-repeat relative',
    style: {
      backgroundImage: `url(${MobileImage?.src})`
    }
  })) : null, videoUrl ? /*#__PURE__*/React.createElement("video", {
    className: 'h-screen max-h-screen w-full object-cover object-center transition duration-1000 ease-out hidden md:block relative',
    width: "100%",
    height: "100%",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    poster: VideoImage?.src
  }, /*#__PURE__*/React.createElement("source", {
    src: videoUrl,
    type: 'video/mp4'
  })) : null, VideoImage ? /*#__PURE__*/React.createElement("div", {
    className: ' block md:hidden h-screen w-full bg-cover bg-center bg-no-repeat relative',
    style: {
      backgroundImage: `url(${MobileImage?.src ?? VideoImage.src})`
    }
  }, source && /*#__PURE__*/React.createElement(MediaCopyright, {
    source: source
  })) : null), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      '-mt-[100vh]': isLast
    }, {
      'container-page': !isMobile
    }, 'relative')
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content pb-[20vh] md:pb-[30vh]"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'justify-end md:justify-start': textPosition !== 'right',
      'justify-end': textPosition === 'right'
    }, 'flex flex-row')
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: "hidden",
    whileInView: "visible",
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    },
    variants: {
      visible: {
        opacity: 1,
        y: 0
      },
      hidden: {
        opacity: 0,
        y: isMobile ? '70px' : '300px'
      }
    },
    className: 'mt-[70vh] md:mt-[35vh] backdrop-blur-[6px] bg-[rgba(255,255,255,0.92)] h-fit lg:pb-7 lg:pl-[3.125rem] lg:pt-[3.125rem] lg:pr-[4.375rem] supports-backdrop-light transform-gpu rounded-tl-lg border-b-4 border-b-red-500 px-5 pt-6 pb-px sm:pb-1  md:max-w-lg md:rounded-none md:rounded-tl-xl md:px-8 md:pt-10 xl:px-10 max-w-[90%] lg:max-w-lg xl:max-w-xl  '
  }, /*#__PURE__*/React.createElement("div", {
    className: "box-prose prose text-lg font-light lg:text-xl lg:leading-[1.8]"
  }, label && /*#__PURE__*/React.createElement("p", {
    className: "text-red-500 font-bold text-lg lg:text-xl m-0  "
  }, label), title && /*#__PURE__*/React.createElement("h2", {
    className: "!mt-3 md:!mt-5 !pt-0"
  }, title), /*#__PURE__*/React.createElement(Group, {
    definition: FullImageStoryContentGroup,
    input: content
  }))))), /*#__PURE__*/React.createElement(InnerContent, {
    sectionContent: sectionContent
  }), source && /*#__PURE__*/React.createElement(MediaCopyright, {
    source: source
  })))));
};
const MediaCopyright = ({
  source
}) => /*#__PURE__*/React.createElement("p", {
  className: 'absolute left-2.5 bottom-2.5 px-2 bg-white text-sm font-light lg:text-base rounded-tl-[0.25rem]'
}, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), source);
const InnerContent = /*#__PURE__*/React.memo(({
  sectionContent
}) => /*#__PURE__*/React.createElement("div", {
  className: "md:pb-0 container-content"
}, /*#__PURE__*/React.createElement("div", {
  className: "bg-transparent"
}, sectionContent.map((contentItem, index) => /*#__PURE__*/React.createElement("div", {
  className: 'pb-[50vh] md:pb-[60vh] contained-overlay',
  key: index
}, /*#__PURE__*/React.createElement("div", {
  className: clsx({
    'bg-transparent md:rounded-tl-none ': !contentItem.hasOverlay,
    'py-1': contentItem.hasOverlay
  }, 'bg-white md:rounded-tl-xl')
}, /*#__PURE__*/React.createElement("div", {
  className: clsx('my-4 md:mt-10 md:mb-16', {
    'container-nooverlay my-0': !contentItem.hasOverlay
  })
}, /*#__PURE__*/React.createElement(Group, {
  definition: ScrolloverSectionItemContentGroup,
  input: contentItem.content
}))))))), (prev, next) => prev.sectionContent.length === next.sectionContent.length);
InnerContent.displayName = 'InnerContent';

/* eslint-disable react/jsx-no-literals */
function SelectionForm({
  Form,
  items,
  overlapSelectionError
}) {
  const intl = useIntl();
  const Title = buildHtml(`<h3>${intl.formatMessage({
    id: "lXeyCY",
    defaultMessage: [{
      "type": 0,
      "value": "Book your Bergeinsatz place now"
    }]
  })}</h3>`);
  const Intro = buildHtml(`<p>${intl.formatMessage({
    id: "jqlNuO",
    defaultMessage: [{
      "type": 0,
      "value": "Please select the number of places in the desired period"
    }]
  })}</p>`);
  const ExtraText = buildHtml(`<p>${intl.formatMessage({
    id: "lWgwkz",
    defaultMessage: [{
      "type": 0,
      "value": "Only one place per week can be booked. Additional places can be booked once registration is complete"
    }]
  })}</p>`);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    id: "booking-form"
  }, items.length <= 0 ? /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: "prose mb-10 md:mb-20 max-w-full sm:prose-lg md:prose-xl"
  }, /*#__PURE__*/React.createElement("p", {
    className: "inline"
  }, /*#__PURE__*/React.createElement(ViolationMessage, {
    dangerousHtmlMessageString: intl.formatMessage({
      id: "8e8RdH",
      defaultMessage: [{
        "type": 0,
        "value": "You cannot book any mission at this family right now."
      }]
    }),
    className: "mb-0"
  })))))) : /*#__PURE__*/React.createElement("div", {
    className: 'container-page mb-10 max-w-full rounded-tl-lg bg-blue-100 pt-8 pb-11 md:mb-24 md:rounded-none md:px-4 md:pb-20 md:pt-16 lg:pt-14'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-text'
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:px-2.5"
  }, Heading ? /*#__PURE__*/React.createElement("div", {
    className: 'mb-3 lg:mb-6'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: 'lg:text-lg'
  }, /*#__PURE__*/React.createElement(Intro, null)), overlapSelectionError && items.length > 1 && /*#__PURE__*/React.createElement(ViolationMessage, {
    dangerousHtmlMessageString: intl.formatMessage({
      id: "FI930I",
      defaultMessage: [{
        "type": 0,
        "value": "You already have a booking for the selected period, please choose a different one."
      }]
    })
  }), /*#__PURE__*/React.createElement(Form, {
    className: 'form mt-6 md:mt-8'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'w-full'
  }, items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'relative items-end justify-between border-t border-t-blue-300 py-4 font-light last:border-b last:border-b-blue-300 lg:flex lg:text-lg'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: 'mb-1.5 block md:mb-2 '
  }, intl.formatMessage({
    id: "XEsFTe",
    defaultMessage: [{
      "type": 0,
      "value": "Calendar week"
    }]
  }), ' ', item.weekNumber), /*#__PURE__*/React.createElement("span", {
    className: 'block font-bold'
  }, formatDate(item.startDate), " -", ' ', formatDate(item.endDate))), /*#__PURE__*/React.createElement("div", {
    className: 'mt-1.5 items-baseline justify-between sm:flex lg:mt-0 lg:w-[57%]'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mt-1.5 -mb-1 flex items-center justify-start leading-[1.9] sm:m-0 lg:items-baseline'
  }, item.placesAvailable, ' ', item.placesAvailable < 2 ? intl.formatMessage({
    id: "FldtOX",
    defaultMessage: [{
      "type": 0,
      "value": "available place"
    }]
  }) : intl.formatMessage({
    id: "9GlVRT",
    defaultMessage: [{
      "type": 0,
      "value": "available places"
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: 'relative ml-3 flex text-green-500 xl:ml-7'
  }, /*#__PURE__*/React.createElement(PlaceIcon, null), item.placesAvailable >= 2 ? /*#__PURE__*/React.createElement(PlaceIcon, null) : item.placesTotal >= 2 ? /*#__PURE__*/React.createElement(PlaceIconSolid, null) : null, item.placesAvailable >= 3 ? /*#__PURE__*/React.createElement(PlaceIcon, null) : item.placesTotal >= 3 ? /*#__PURE__*/React.createElement(PlaceIconSolid, null) : null, item.placesAvailable >= 4 ? /*#__PURE__*/React.createElement(PlaceIcon, null) : item.placesTotal >= 4 ? /*#__PURE__*/React.createElement(PlaceIconSolid, null) : null, item.placesTotal >= 5 ? /*#__PURE__*/React.createElement(PlusSmIcon, {
    className: 'absolute -right-4 top-2.5 h-5 w-5'
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "checkboxes--wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item selection-form-item"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: `book-${item.id}`
  }, intl.formatMessage({
    id: "bv2X6I",
    defaultMessage: [{
      "type": 0,
      "value": "Book"
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "bookIds",
    value: item.id,
    id: `book-${item.id}`
  }), /*#__PURE__*/React.createElement("span", {
    className: "selection-checkmark absolute -top-0.5 right-0 h-7 w-7 border border-grey-200 bg-white after:absolute after:top-px after:left-2 after:h-5 after:w-2.5 after:border-r-4 after:border-b-4 after:border-green-500 after:transition after:content-[''] md:-top-1"
  })))))))), hasSubmitted && /*#__PURE__*/React.createElement(ValidationMessage, null), /*#__PURE__*/React.createElement(OverlapValidationMessage, {
    items: items
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    hasSubmitted: hasSubmitted,
    onClick: () => setHasSubmitted(true),
    items: items
  })), /*#__PURE__*/React.createElement("div", {
    className: 'mt-9 font-bold md:mt-10 lg:mt-14 lg:text-lg'
  }, /*#__PURE__*/React.createElement(ExtraText, null)))))));
}
function isBookingSelected(formValues) {
  return formValues.bookIds && formValues.bookIds.length > 0;
}
function isSelectedPeriodsOverlapWithExistingBookings(formValues, items) {
  if (typeof formValues.bookIds === 'undefined') {
    return false;
  }
  const overlap = items.reduce((accumulator, currentValue) => {
    if (!accumulator && currentValue.periodOverlapsForCurrentUser && formValues.bookIds.includes(currentValue.id)) {
      return true;
    }
    return accumulator;
  }, false);
  return overlap;
}
function OverlapValidationMessage({
  items
}) {
  const intl = useIntl();
  const {
    values
  } = useFormikContext();
  if (isSelectedPeriodsOverlapWithExistingBookings(values, items)) {
    return /*#__PURE__*/React.createElement(ViolationMessage, {
      dangerousHtmlMessageString: intl.formatMessage({
        id: "XuTiVy",
        defaultMessage: [{
          "type": 0,
          "value": "Your selected items overlap with one of your existings bookings."
        }]
      })
    });
  }
  return null;
}
function ValidationMessage() {
  const intl = useIntl();
  const {
    values
  } = useFormikContext();
  if (isBookingSelected(values)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ViolationMessage, {
    dangerousHtmlMessageString: intl.formatMessage({
      id: "t/Mcc+",
      defaultMessage: [{
        "type": 0,
        "value": "Please select at least one item before continuing."
      }]
    })
  });
}
function SubmitButton({
  onClick,
  hasSubmitted,
  items
}) {
  const intl = useIntl();
  const {
    values
  } = useFormikContext();
  return /*#__PURE__*/React.createElement("button", {
    type: "submit",
    onClick: onClick,
    disabled: hasSubmitted && !isBookingSelected(values) || isSelectedPeriodsOverlapWithExistingBookings(values, items),
    className: "focus mt-6 flex w-full cursor-pointer select-none items-center justify-center whitespace-normal rounded-tl-xl bg-red-500 px-6 py-3 font-condensed text-sm uppercase tracking-wide text-white transition duration-300 hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-60 md:py-4 md:text-lg"
  }, intl.formatMessage({
    id: "9+Ddtu",
    defaultMessage: [{
      "type": 0,
      "value": "Next"
    }]
  }));
}
function PlaceIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.529",
    height: "27.333",
    className: 'mr-px',
    viewBox: "0 0 10.529 27.333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.752 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.509,15.7l-.344,6.143a.793.793,0,0,1-.574.746H8.155l-.919,9.472H4.768l-.919-9.472H2.644a.345.345,0,0,1-.23-.057h0a.793.793,0,0,1-.574-.746L1.5,15.7a3.114,3.114,0,0,1,.919-2.411,4.075,4.075,0,0,1,.8-.574,5.025,5.025,0,0,1,.919-.115l1.837,1.378L7.81,12.6a5.025,5.025,0,0,1,.919.115,2.06,2.06,0,0,1,.8.574A2.9,2.9,0,0,1,10.509,15.7Z",
    transform: "translate(-1.49 -6.228)",
    fill: "none",
    stroke: "#7ba36d",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.724,1.5A2.157,2.157,0,0,0,5.6,3.624c0,1.148.976,2.756,2.124,2.756S9.848,4.772,9.848,3.624A2.119,2.119,0,0,0,7.724,1.5Z",
    transform: "translate(-3.241 -1.5)",
    fill: "none",
    stroke: "#7ba36d",
    strokeWidth: "1.5"
  })));
}
function PlaceIconSolid() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.529",
    height: "27.333",
    className: 'mr-px',
    viewBox: "0 0 10.529 27.333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.752 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.809,15.7l-.344,6.143a.793.793,0,0,1-.574.746H37.455l-.919,9.472H34.125l-.976-9.472H31.944a.345.345,0,0,1-.23-.057h0a.793.793,0,0,1-.574-.746L30.8,15.7a3.114,3.114,0,0,1,.919-2.411,4.075,4.075,0,0,1,.8-.574,5.025,5.025,0,0,1,.919-.115l1.837,1.378L37.11,12.6a5.025,5.025,0,0,1,.919.115,2.059,2.059,0,0,1,.8.574A2.9,2.9,0,0,1,39.809,15.7Z",
    transform: "translate(-30.79 -6.228)",
    fill: "#b4cbb0",
    stroke: "#b4cbb0",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.124,1.5A2.157,2.157,0,0,0,35,3.624c0,1.148.976,2.756,2.124,2.756s2.124-1.607,2.124-2.756A2.157,2.157,0,0,0,37.124,1.5Z",
    transform: "translate(-32.583 -1.5)",
    fill: "#b4cbb0",
    stroke: "#b4cbb0",
    strokeWidth: "1.5"
  })));
}

const localeMap = {
  de: 'de_CH',
  en: 'en_US',
  fr: 'fr_CH',
  it: 'it_CH',
  pt: 'pt_PT',
  es: 'es_ES'
};
function SEO({
  currentTheme = 'caritas',
  title,
  description = '',
  viewport = 'width=device-width, initial-scale=1, maximum-scale=2, user-scalable=yes',
  generator = 'Gatsby',
  links,
  locale,
  imageUrl,
  imageAlt,
  ogType,
  publishedTime,
  noIndex
}) {
  const intl = useIntl();
  const siteName = {
    caritas: intl.formatMessage({
      id: "SdAr+E",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Switzerland"
      }]
    }),
    bergeinsatz: intl.formatMessage({
      id: "gsutf1",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Bergeinsatz"
      }]
    }),
    caritascare: intl.formatMessage({
      id: "RWklaC",
      defaultMessage: [{
        "type": 0,
        "value": "Caritas Care"
      }]
    }),
    youngcaritas: intl.formatMessage({
      id: "AzIKWb",
      defaultMessage: [{
        "type": 0,
        "value": "youngCaritas"
      }]
    })
  }[currentTheme];
  const defaultMetaDescription = {
    caritas: intl.formatMessage({
      id: "hlGSGt",
      defaultMessage: [{
        "type": 0,
        "value": "In Switzerland and worldwide for social justice and against poverty."
      }]
    }),
    bergeinsatz: intl.formatMessage({
      id: "Um3X+u",
      defaultMessage: [{
        "type": 0,
        "value": "Mountain farmers can count on the support of Caritas Mountain Operation. Support Swiss mountain farming families with a voluntary mountain assignment."
      }]
    }),
    caritascare: intl.formatMessage({
      id: "ElUo44",
      defaultMessage: [{
        "type": 0,
        "value": "Private care for the elderly and sensitive all-round care at home. So that you can live independently, carefree and safely in old age - Caritas Care."
      }]
    }),
    youngcaritas: intl.formatMessage({
      id: "gYtIZF",
      defaultMessage: [{
        "type": 0,
        "value": "youngCaritas is the youth section of Caritas. Together we stand up for a just and sustainable society."
      }]
    })
  }[currentTheme];
  const twitterSite = {
    caritas: '@CaritasSchweiz',
    bergeinsatz: undefined,
    caritascare: undefined,
    youngcaritas: undefined
  }[currentTheme];
  const googleSearchConsole = {
    caritas: '5P6Z7hTZmcbAGflCB6N0DpsbEodWmzxE_6cH_LZh83A',
    bergeinsatz: 'fgal8vJxpBCTorjcWU2r2jwBRI-abkxRcgE-rbcSh0c',
    caritascare: 'W3KoO4paMwy6TdD4Id3x6pH8g0gOMfyGL0XKsDIeV3s',
    youngcaritas: 'ou1dzjZas4AwqrlV3wVxpqzEG52-1wxX5eLOmSZHgjA'
  }[currentTheme];
  const metaDescription = description || defaultMetaDescription;

  /**
   * This is to ensure we don't output empty metadata, especially important for noindex metatag
   * @param name
   * @param content
   */
  const metaDataItem = (name, content) => {
    const isOgMetatag = name.startsWith('og:');
    return content ? /*#__PURE__*/React.createElement("meta", {
      name: !isOgMetatag ? name : undefined,
      property: isOgMetatag ? name : undefined,
      content: content
    }) : undefined;
  };
  const addTrailingSlash = path => {
    return typeof path === 'undefined' || path.endsWith('/') ? path : `${path}/`;
  };

  // If no Meta from Drupal use a static set of meta from gatsby-config
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, intl.formatMessage({
    id: "fwkQuE",
    defaultMessage: [{
      "type": 1,
      "value": "title"
    }, {
      "type": 0,
      "value": " | "
    }, {
      "type": 1,
      "value": "site"
    }]
  }, {
    title,
    site: siteName
  })), metaDataItem('description', metaDescription), metaDataItem('og:site_name', siteName), metaDataItem('og:locale', locale ? localeMap[locale] || locale : undefined), metaDataItem('og:title', `${title} | ${siteName}`), metaDataItem('og:description', metaDescription), metaDataItem('og:url', links ? addTrailingSlash(links.find(link => link.rel === 'canonical')?.href) : undefined), metaDataItem('og:type', ogType), metaDataItem('og:image', imageUrl), metaDataItem('og:image:alt', imageAlt), metaDataItem('og:article:published_time', publishedTime), metaDataItem('twitter:card', 'summary'), metaDataItem('twitter:site', twitterSite), metaDataItem('generator', generator), metaDataItem('robots', noIndex ? 'noindex' : undefined), metaDataItem('viewport', viewport), metaDataItem('HandheldFriendly', 'true'), metaDataItem('MobileOptimized', 'width'), metaDataItem('google-site-verification', googleSearchConsole), links?.map((link, index) => /*#__PURE__*/React.createElement("link", _extends({
    key: index,
    rel: link.rel,
    href: addTrailingSlash(link.href)
  }, link.hrefLang ? {
    hrefLang: link.hrefLang
  } : {}))));
}

function SiteSearch({
  Content
}) {
  useEffect(() => {
    // @ts-ignore
    if (window !== undefined && window.google !== undefined) {
      // @ts-ignore
      window.google.search.cse.element.render({
        div: 'gcse-wrapper',
        tag: 'search'
      });
    }
  }, []);
  const wrapperRef = useRef(null);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const wrapper = wrapperRef.current;
      const input = wrapper ? wrapper.querySelector("input[type='text']") : null;
      if (input) {
        clearInterval(intervalId);
        input.focus();
      }
    }, 200);
    return () => clearInterval(intervalId);
  }, [wrapperRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: "prose my-5 max-w-full sm:prose-lg sm:my-10 md:prose-xl google-search-wrapper",
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Prose, {
    Content: Content
  }));
}

function SuccessMessage({
  Message
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'border-l-4 border-green-500 bg-white px-4 py-3 -mb-1.5 mt-7 status-message success-message'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'relative top-px'
  }, /*#__PURE__*/React.createElement(Message, null)));
}

function StatusMessages({
  status,
  error
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, status && status?.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: "prose md:prose-xl"
  }, status.map((item, index) => {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(SuccessMessage, {
      Message: buildHtml(item)
    }));
  })) : null, error && error?.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: "prose md:prose-xl"
  }, error.map((item, index) => {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(ViolationMessage, {
      Message: buildHtml(item)
    }));
  })) : null);
}

function StoryBlock({
  Image,
  content,
  textPosition = 'left',
  source
}) {
  const BoxRef = useRef(null);
  const isDesktop = useSetMediaQuery() === 'desktop';
  const {
    scrollYProgress
  } = useScroll({
    target: BoxRef,
    offset: ['start end', `start start`]
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-5%', '-50%'], {
    ease: easeOut
  });
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-16 md:my-20'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'lg:relative'
  }, /*#__PURE__*/React.createElement(motion.div, {
    transition: {
      duration: 1,
      ease: 'easeOut'
    },
    style: {
      opacity: 0,
      y: 80
    },
    viewport: {
      once: true,
      margin: '-5% 0px'
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('w-full rounded-tl-lg lg:aspect-w-11 lg:aspect-h-6 lg:w-2/3 relative', {
      'lg:ml-[33.333333%]': textPosition === 'left'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'bg-grey-200 inset-0 absolute rounded-tl-lg z[-1] !w-[calc(100%-10px)] !h-[calc(100%-10px)] !m-auto'
  }), /*#__PURE__*/React.createElement(Image, {
    className: '!block !relative rounded-tl-lg lg:!absolute lg:object-cover'
  })), source && /*#__PURE__*/React.createElement("p", {
    className: clsx('my-1 hidden text-sm font-light lg:block lg:text-base', {
      'lg:ml-[33.333333%]': textPosition === 'left'
    })
  }, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), source)), /*#__PURE__*/React.createElement(motion.div, {
    transition: {
      duration: 1,
      ease: 'easeOut'
    },
    style: {
      opacity: isDesktop ? 1 : 0,
      y: isDesktop ? y : '80px'
    },
    viewport: {
      once: true,
      margin: '-5% 0px'
    },
    whileInView: {
      opacity: 1,
      ...(!isDesktop && {
        y: 0
      })
    },
    ref: BoxRef,
    className: clsx('story-block-content relative w-full max-w-full bg-blue-100 px-10 pb-9 pt-1 md:pb-10 lg:absolute lg:top-1/2 lg:max-w-[45%] lg:-translate-y-1/2 lg:pt-10', {
      'lg:right-0': textPosition === 'right'
    }, {
      'lg:left-0': textPosition === 'left'
    })
  }, source && /*#__PURE__*/React.createElement("p", {
    className: 'my-1 mb-9 text-sm font-light lg:hidden lg:text-base'
  }, /*#__PURE__*/React.createElement(ImageCopyrightPrefix, null), source), /*#__PURE__*/React.createElement("div", {
    className: clsx('prose first:mt-8 sm:prose-lg md:prose-xl first:lg:mt-0')
  }, /*#__PURE__*/React.createElement(Group, {
    definition: StoryContentGroup,
    input: content
  })))));
}

function HighlightTeaser({
  Image,
  title,
  description,
  date,
  category,
  Link,
  sosTag,
  bioTag,
  status,
  isProject = false
}) {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Link, {
    className: clsx('focus group relative block rounded-tl-lg', {
      'border-4 border-red-500': status === 0
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'aspect-w-2 aspect-h-1 relative -mb-9 block overflow-hidden rounded-tl-lg border-b-4 border-red-500'
  }, Image ? /*#__PURE__*/React.createElement(Image, {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105'
  }) : /*#__PURE__*/React.createElement("img", {
    className: '!absolute block w-full max-w-full object-cover transition duration-300 group-hover:scale-105',
    src: '/fallback_teaser_image.svg',
    alt: 'Teaser image fallback'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'relative ml-[5.1%] w-[95%] max-w-[95%] bg-blue-100  md:-mt-20 md:ml-[10.1%] md:w-[90%] md:max-w-[90%]'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute -top-[26px] right-0 md:-top-3.5'
  }, isProject && !!date?.end && new Date(date?.end) < new Date() && /*#__PURE__*/React.createElement("span", {
    className: 'ml-0.5 bg-blue-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "T2DELw",
    defaultMessage: [{
      "type": 0,
      "value": "finished"
    }]
  })), !!bioTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-green-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "2W0f9h",
    defaultMessage: [{
      "type": 0,
      "value": "Bio"
    }]
  })), !!sosTag && /*#__PURE__*/React.createElement("span", {
    className: 'ml-1 bg-red-500 px-2 py-1 font-condensed uppercase tracking-wider text-white'
  }, intl.formatMessage({
    id: "CAe6jR",
    defaultMessage: [{
      "type": 0,
      "value": "SOS"
    }]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "relative overflow-hidden py-9 px-5 transition after:absolute after:left-0 after:top-[-105%] after:h-full after:w-[4px] after:bg-red-500 after:transition-[top] after:content-[''] group-hover:after:top-0 md:pl-7 md:pr-16 lg:pb-16 lg:pt-12 lg:pl-16"
  }, !!category && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(category.CategoryLink, {
    className: clsx('focus mb-2.5 inline-block border-black text-xs font-bold uppercase text-red-500 transition')
  }, category.text)), /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-xl font-bold transition md:text-2xl lg:text-3xl')
  }, title), !!date && !!date.start && /*#__PURE__*/React.createElement("div", {
    className: 'mb-2.5 flex items-center text-sm uppercase text-grey-500'
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: date.start
  }, new Date(date.start).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  })), !!date.end && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'mx-2'
  }, ' - '), /*#__PURE__*/React.createElement("time", {
    dateTime: date.end
  }, new Date(date.end).toLocaleString('de-CH', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Zurich'
  })))), description ? /*#__PURE__*/React.createElement("div", {
    className: 'mt-2.5 font-light'
  }, description) : null)));
}

function TeaserPromoLayout({
  teasers,
  Title,
  Link,
  MoreLink,
  MoreLinkTitle
}) {
  const [height, setHeight] = useState(0);
  const elementRef = useRef(null);
  useEffect(() => {
    if (elementRef.current && elementRef.current.clientHeight) {
      const height = elementRef.current.clientHeight;
      setHeight(height);
    }
  }, [teasers]);
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: 'my-10'
  }, Title ? /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content mb-2 md:mb-4'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'md:inline-block'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })), Link ? /*#__PURE__*/React.createElement(Link, {
    className: 'focus mb-2 inline-block font-light text-red-500 hover:text-red-600 hover:underline md:mb-0 md:ml-4'
  }, intl.formatMessage({
    id: "pFK6bJ",
    defaultMessage: [{
      "type": 0,
      "value": "View all"
    }]
  })) : null)) : null, /*#__PURE__*/React.createElement("div", {
    className: 'container-page container-promo overflow-y-scroll mobile-only:!max-h-[unset]',
    style: {
      maxHeight: height + 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: "items-start md:-mx-4 md:flex md:flex-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mb-5 last:mb-0 md:sticky md:top-0 md:mb-0 md:w-3/5 md:px-3 md:pt-3 lg:w-2/3 lg:px-5 lg:pt-5'
  }, /*#__PURE__*/React.createElement("div", {
    ref: elementRef
  }, !!teasers[0] && /*#__PURE__*/React.createElement(HighlightTeaser, teasers[0]))), /*#__PURE__*/React.createElement("div", {
    className: 'md:sticky md:top-0 md:w-2/5 lg:w-1/3'
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !!teasers.length && teasers.length > 1 && teasers.slice(1).map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: 'mb-5 last:mb-0 md:mb-0 md:p-3 lg:p-5'
  }, /*#__PURE__*/React.createElement(Teaser, teaser))), MoreLink ? /*#__PURE__*/React.createElement(MoreLinkCard, {
    title: MoreLinkTitle || intl.formatMessage({
      id: "pFK6bJ",
      defaultMessage: [{
        "type": 0,
        "value": "View all"
      }]
    }),
    Link: MoreLink
  }) : null))))));
}

function SliderNavigation({
  prevRef,
  nextRef,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-0.5', className)
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": 'Nach links navigieren',
    className: 'focus group cursor-pointer',
    ref: prevRef
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex h-11 w-11 items-center justify-center bg-blue-100 transition group-hover:bg-red-500 group-hover:text-white'
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon$1, {
    className: 'h-4 w-4'
  }))), /*#__PURE__*/React.createElement("button", {
    "aria-label": 'Nach rechts navigieren',
    className: 'focus group cursor-pointer transition',
    ref: nextRef
  }, /*#__PURE__*/React.createElement("div", {
    className: 'relative flex h-11 w-11 items-center justify-center bg-blue-100 transition group-hover:bg-red-500 group-hover:text-white'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'absolute left-0 top-1/2 h-5 w-px -translate-y-1/2 bg-grey-200 group-hover:bg-red-500'
  }), /*#__PURE__*/React.createElement(ChevronRightIcon$1, {
    className: 'h-4 w-4'
  }))));
}

function TeaserSlideshow({
  teasers,
  Title,
  Link,
  MoreLink,
  MoreLinkTitle
}) {
  const [showSlideshow, setShowSlideShow] = useState(false);
  useEffect(() => {
    setShowSlideShow(window.matchMedia('(max-width: 767px)').matches && teasers.length > 1 || window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches && teasers.length > 2 || window.matchMedia('(min-width: 1024px)').matches && teasers.length > 3);
  }, [teasers, setShowSlideShow]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-page'
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('container-content lg:mb-[2.125rem] mb-10', {
      'lg:flex lg:items-center lg:justify-between': Title || showSlideshow
    })
  }, Title ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'lg:inline-block mb-5 lg:mb-0'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  })), Link ? /*#__PURE__*/React.createElement(Link, {
    className: 'focus inline-block font-light text-red-500 hover:text-red-600 hover:underline lg:mb-0 lg:ml-4 mb-3'
  }, intl.formatMessage({
    id: "pFK6bJ",
    defaultMessage: [{
      "type": 0,
      "value": "View all"
    }]
  })) : null) : null, showSlideshow ? /*#__PURE__*/React.createElement(SliderNavigation, {
    prevRef: prevRef,
    nextRef: nextRef
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: 'container-page overflow-x-hidden md:overflow-x-auto'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, showSlideshow ? /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation],
    onBeforeInit: swiper => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.prevEl = prevRef.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.update();
    },
    slidesPerView: 'auto',
    spaceBetween: 20,
    className: '!-ml-1.5 overflow-visible lg:overflow-hidden'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    className: 'max-w-[280px] p-1.5 md:max-w-[320px] lg:max-w-[400px]',
    key: index
  }, /*#__PURE__*/React.createElement(Teaser, teaser))), MoreLink ? /*#__PURE__*/React.createElement(SwiperSlide, {
    className: '!h-auto max-w-[280px] md:max-w-[320px] lg:max-w-[400px]'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'h-full w-full p-1.5'
  }, /*#__PURE__*/React.createElement(MoreLinkCard, {
    title: MoreLinkTitle || intl.formatMessage({
      id: "pFK6bJ",
      defaultMessage: [{
        "type": 0,
        "value": "View all"
      }]
    }),
    Link: MoreLink
  }))) : null) : /*#__PURE__*/React.createElement("div", {
    className: 'flex gap-5'
  }, teasers.map((teaser, index) => /*#__PURE__*/React.createElement("div", {
    className: 'w-full py-1.5 md:w-1/2 lg:w-1/3',
    key: index
  }, /*#__PURE__*/React.createElement(Teaser, teaser))), MoreLink ? /*#__PURE__*/React.createElement("div", {
    className: '!h-auto w-full py-1.5 md:w-1/2 lg:w-1/3'
  }, /*#__PURE__*/React.createElement(MoreLinkCard, {
    title: MoreLinkTitle || intl.formatMessage({
      id: "pFK6bJ",
      defaultMessage: [{
        "type": 0,
        "value": "View all"
      }]
    }),
    Link: MoreLink
  })) : null))));
}

const Map = loadable(() => import('./Map-59f23966.js'));
const SeoRoute = route(Head, {
  contents: SEO
});
const PageRoute = route(Page, {
  header: Header,
  preFooter: PreFooter,
  footer: Footer
});
const DonationPageRoute = route(Page, {
  header: DonationHeader,
  preFooter: PreFooter,
  footer: Footer
});
const MicrositePageRoute = route(Page, {
  header: MicrositeHeader,
  preFooter: PreFooter,
  footer: MicrositeFooter
});
const ScrolloverPageRoute = route(Page, {
  header: ScrolloverPageHeader,
  preFooter: PreFooter,
  footer: MicrositeFooter
});
const ContentRoute = route(Content, {
  body: {
    heroSection: HeroSection$1,
    heroSectionB: HeroSection,
    formattedText: wrap(TextContainer, FormattedText),
    rawHtml: wrap(TextContainer, RawHtml),
    teaserSlideshow: TeaserSlideshow,
    accordion: Accordion,
    blockquote: Blockquote,
    fileLinksblock: FileLinksBlock,
    teaserGrid: TeaserGrid,
    heading: wrap(HeadingContainer, Heading),
    ImageCarousel: ImageCarousel,
    Image: wrap(TextContainer, Image),
    CBox: CBox,
    CBoxDonation: CBoxDonation,
    ImpactCommunication: wrap(ContentContainer, ImpactCommunication),
    fullImageStoryBlock: FullImageStoryBlock,
    collageStoryBlock: wrap(ContentContainer, CollageStoryBlock),
    storyBlock: wrap(ContentContainer, StoryBlock),
    map: Map,
    contactBox: wrap(TextContainer, ContactBox),
    formEmbed: wrap(ContentContainer, FormEmbed),
    factTiles: FactTiles,
    contentHub: ContentHub,
    filteredLocations: FilteredLocations,
    teaserPromoLayout: TeaserPromoLayout,
    confirmedWeekList: ConfirmedWeekList,
    selectionForm: SelectionForm,
    missionSummary: BookingMissionSummary,
    socialMenuAlt: wrap(TextContainer, SocialMenuAlt),
    iframe: wrap(TextContainer, Iframe),
    factSheetBlock: FactSheet,
    logoCloudBlock: wrap(TextContainer, LogoCloudBlock),
    headerImageCopyright: wrap(TextContainer, HeaderImageCopyright),
    siteSearch: wrap(ContentContainer, SiteSearch),
    petition: wrap(TextContainer, PetitionTool),
    statusMessages: wrap(TextContainer, StatusMessages),
    cookieButton: wrap(TextContainer, CookiePreferencesButton)
  }
});
const ScrolloverContentRuote = route(Content, {
  body: {
    heroSection: HeroSection$1,
    scrolloverSectionItem: ScrolloverSectionItem,
    headerImageCopyright: wrap(TextContainer, HeaderImageCopyright),
    statusMessages: wrap(TextContainer, StatusMessages)
  }
});
const ScrolloverSectionItemCoverGroup = group({
  items: {
    formattedText: FormattedText,
    heading: wrap(StoryHeadingContainer, Heading)
  }
});
const ScrolloverSectionItemContentGroup = group({
  items: {
    formattedText: wrap(TextContainer, FormattedText),
    rawHtml: wrap(TextContainer, RawHtml),
    teaserSlideshow: TeaserSlideshow,
    accordion: Accordion,
    blockquote: Blockquote,
    fileLinksblock: FileLinksBlock,
    teaserGrid: TeaserGrid,
    heading: wrap(HeadingContainer, Heading),
    ImageCarousel: ImageCarousel,
    Image: wrap(TextContainer, Image),
    CBox: CBox,
    CBoxDonation: CBoxDonation,
    ImpactCommunication: wrap(ContentContainer, ImpactCommunication),
    collageStoryBlock: wrap(ContentContainer, CollageStoryBlock),
    storyBlock: wrap(ContentContainer, StoryBlock),
    map: Map,
    contactBox: wrap(TextContainer, ContactBox),
    formEmbed: wrap(ContentContainer, FormEmbed),
    factTiles: FactTiles,
    contentHub: ContentHub,
    filteredLocations: FilteredLocations,
    teaserPromoLayout: TeaserPromoLayout,
    socialMenuAlt: wrap(TextContainer, SocialMenuAlt),
    iframe: wrap(TextContainer, Iframe),
    factSheetBlock: FactSheet,
    logoCloudBlock: wrap(TextContainer, LogoCloudBlock),
    petition: wrap(TextContainer, PetitionTool),
    statusMessages: wrap(TextContainer, StatusMessages),
    cookieButton: wrap(TextContainer, CookiePreferencesButton)
  }
});
const DonationRoute = route(Content, {
  body: {
    heroSection: HeroSection$1,
    DonationForm: wrap(TextContainer, DonationForm),
    formattedText: wrap(TextContainer, FormattedText),
    donationBox: DonationBox,
    headerImageCopyright: wrap(TextContainer, HeaderImageCopyright)
  }
});
const AccordionContentGroup = group({
  items: {
    formattedText: FormattedText,
    Image: Image
  }
});
const CBoxContentGroup = group({
  items: {
    formattedText: CBoxFormattedText,
    donationWidget: DonationWidget
  }
});
const FileListContentGroup = group({
  items: {
    formattedText: FormattedText
  }
});
const FullImageStoryContentGroup = group({
  items: {
    formattedText: FormattedText,
    heading: wrap(StoryHeadingContainer, Heading)
  }
});
const StoryContentGroup = group({
  items: {
    formattedText: FormattedText,
    heading: wrap(StoryHeadingContainer, Heading)
  }
});
const CollageStoryContentGroup = group({
  items: {
    formattedText: FormattedText,
    heading: wrap(StoryHeadingContainer, Heading)
  }
});
const FactSheetContentGroup = group({
  items: {
    formattedText: FormattedText
  }
});

export { AccordionContentGroup as A, ContentRoute as C, DonationPageRoute as D, FileListContentGroup as F, Heading as H, MicrositePageRoute as M, PageRoute as P, SeoRoute as S, ThemeProvider as T, ScrolloverPageRoute as a, ScrolloverContentRuote as b, ScrolloverSectionItemCoverGroup as c, ScrolloverSectionItemContentGroup as d, DonationRoute as e, CBoxContentGroup as f, FullImageStoryContentGroup as g, StoryContentGroup as h, CollageStoryContentGroup as i, FactSheetContentGroup as j, listBullet as l, useSetMediaQuery as u };
